{
  "accessibility": {
    "closeModal": "Fermer la fenêtre modale",
    "useSetting": "Utiliser le paramètre",
    "srOnly": {
      "close": "Fermer",
      "loading": "Chargement…"
    }
  },
  "account": {
    "salesResources": {
      "title": "Ressources de vente",
      "searchDocuments": "Rechercher des documents",
      "minimalRating": "Évaluation minimale",
      "maxRating": "Note maximale"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Activez la refacturation pour ce client afin de multiplier par 10 vos bénéfices sur l'utilisation du téléphone, des e-mails, des automatisations, etc.",
      "enableRebilling": "Activer la refacturation",
      "servicesActivateAfterPayment": "Les services de refacturation seront actifs dès que le client aura ajouté un mode de paiement. En attendant, l'accès au compte du client sera restreint.",
      "cannotModifyOnHold": "Impossible de modifier les paramètres de refacturation car ce sous-compte a déjà un forfait SaaS en attente. Les majorations de refacturation seront configurées en fonction du forfait dès que le client ajoutera un mode de paiement.",
      "rebillingSettings": "Paramètres de Refacturation"
    }
  },
  "affiliates": {
    "aboutMe": "À propos de moi",
    "error": {
      "unableToSend": "Impossible d'envoyer l'e-mail"
    },
    "industriesServed": "Secteurs d'activité desservis",
    "sendAMessage": "Envoyer un message",
    "sendMessageIntro": "Envoyez un message pour vous présenter à ce conseiller. Fournissez des informations sur vous-même et sur les services que vous recherchez.",
    "socialSites": "Sites de réseaux sociaux",
    "success": {
      "emailSent": "Email envoyé avec succès"
    },
    "validationErrors": {
      "validEmail": "Veuillez fournir une adresse e-mail valide.",
      "validMessage": "Veuillez fournir un message valide.",
      "validName": "Veuillez fournir un nom valide."
    },
    "yearsInBusiness": "Années d'activité",
    "yourEmail": "Votre adresse e-mail",
    "yourName": "Votre nom",
    "paymentDetailsAccessMessage": " Cette section sur les détails du paiement n'est accessible et modifiable que par le <strong>propriétaire de l'agence</strong>. Si vous avez besoin d'aide, veuillez contacter votre <strong>propriétaire d'agence ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Badge de partenaire",
    "photoAlt": "Photo de partenaire",
    "defaultCompany": "Aucune entreprise",
    "moreServices": "+ {count} services supplémentaires"
  },
  "agency": {
    "saas": {
      "saasMode": "Mode SaaS",
      "pendingPaymentInformation": "Informations de paiement en attente",
      "customerId": "ID client",
      "noPaymentMethods": "Il semble qu'aucun mode de paiement n'ait été ajouté ! Veuillez en ajouter un pour activer le mode SaaS",
      "enableSaasDescription": "Activez le mode SaaS pour cet établissement afin de créer un abonnement et de refacturer l'utilisation du téléphone et des e-mails",
      "missingEmailAddress": "Il manque l'adresse e-mail du compte. Veuillez d'abord ajouter ces informations.",
      "toConvertToSaaS": "Pour convertir ce compte en SaaS, vous devez d'abord ajouter un administrateur d'établissement et réessayer",
      "newUser": "Créer un nouvel utilisateur",
      "stripeCustomerConnected": "Le client Stripe a été connecté avec succès !",
      "requestClientPaymentDetails": "Demander les informations de paiement des clients",
      "saasLocationDescription": "Les établissements en mode SaaS ont besoin de la carte bancaire de votre client pour fonctionner. Vous pouvez en faire la demande en envoyant un e-mail, un SMS ou en partageant une URL",
      "selectSpace": "Sélectionnez un espace pour continuer",
      "spaceDescription": "L'espace que vous sélectionnez ici sera utilisé pour stocker les informations de ce client, traiter ses paiements et gérer ses abonnements.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Quand un utilisateur s'inscrit, vous pouvez lui offrir des crédits gratuits pour utiliser les services d'e-mail et de téléphonie.",
      "thatAboutMinsInCalls": "Cela représente environ {count} messages ou {count1} minutes d'appels",
      "subscriptionSettings": "Paramètres d'abonnement",
      "toUpgradeOrCancelPlan": "Pour mettre à niveau ou résilier un forfait",
      "allowClientUpgrade": "Autorisez le client (sous-compte) à passer à un forfait supérieur.",
      "addNewPlanFeatures": "Ajoutez les fonctionnalités du nouveau forfait lors de la mise à niveau",
      "upgradeFeatureDescription": "Lors du passage à un forfait supérieur, les sous-comptes auront accès aux fonctionnalités supplémentaires du nouveau forfait. accéder aux fonctionnalités supplémentaires dans le nouveau forfait.",
      "allowClientCancel": "Autoriser le client (sous-compte) à annuler son abonnement.",
      "snapshotDescription": "L'instantané sélectionné sera automatiquement ajouté au nouvel établissement SaaS créé",
      "ownSnapshots": "Vos propres instantanés",
      "selectAndContinue": "Sélectionner et continuer"
    },
    "advancedSettings": {
      "controlLocationSettings": "Gérer les paramètres d'emplacement",
      "disableAddSmtp": "Désactiver le bouton Ajouter un service de messagerie dans les paramètres de service de messagerie du sous-compte",
      "disableAddSmtpDescription": "Empêcher les utilisateurs de sous-comptes d'inclure leur propre fournisseur de messagerie électronique",
      "enableReVerification": "Activer la revérification pendant 90 jours",
      "lcEmailNotEnabled": "L'emplacement n'a pas LeadConnector comme fournisseur d'e-mail par défaut",
      "onlyVisibleForAgency": "Vous pouvez uniquement voir ces paramètres activés pour l'agence",
      "reVerificationDescription": "Chaque statut de vérification d'e-mail sera révoqué après 90 jours (protégez votre réputation d'expéditeur et garantissez une délivrabilité optimale)",
      "account": {
        "accountDetails": "Détails du compte",
        "advancedEmailSettings": "Paramètres d'e-mail avancés",
        "hipaa": "HIPAA",
        "hipaaCompliant": "Conforme à la norme HIPAA",
        "smsEmailLimits": "Limites SMS/Email",
        "socialProfiles": "Profils sur les réseaux sociaux",
        "subscribed": "Abonné"
      },
      "activityTracking": {
        "history": "Historique"
      },
      "addAccount": {
        "accountInfo": "Informations du compte",
        "accountSnapshots": "Instantanés du compte",
        "businessNiche": "Créneau entreprise",
        "chooseBusinessNiche": "Sélectionnez un secteur d'activité...",
        "pickSnapshot": "Veuillez choisir un instantané",
        "selectSnapshot": "Sélectionnez l'instantané",
        "title": "Ajouter un sous-compte",
        "accountInfo1": "Informations sur le compte"
      },
      "addBalance": {
        "addBalanceToWallet": "Ajouter le solde au portefeuille numérique",
        "addMoneyToWallet": "Ajouter de l'argent au portefeuille numérique",
        "balanceAddedSuccessfully": "Solde ajouté avec succès",
        "cardWillBeCharged": "La carte se terminant par {cardNumber} sera débitée",
        "complimentaryCredits": "Crédits gratuits ({credits})",
        "creditsRemovedByAgency": "Crédits supprimés par l'agence",
        "currentBalance": "Solde actuel",
        "customerCCWillNotBeCharged": "La carte de crédit du client ne sera pas débitée",
        "moneyWillBeAddedToWallet": "L'argent sera ajouté au portefeuille numérique",
        "pleaseProvideAmountBetween": "Veuillez saisir un montant compris entre {min} et {max}",
        "processing": "Traitement",
        "removeBalance": "Effacer le solde",
        "transactionSuccessful": "Transaction réussie",
        "walletBalance": "Solde du portefeuille numérique ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Ajout...",
        "cardDetails": "Informations de la carte",
        "cardSuccessfullyAdded": "La carte a bien été ajoutée",
        "errorWhileAddingCard": "Erreur lors de l'ajout de la nouvelle carte\t!",
        "maximumCardUpdateLimitReached": "Limite maximale de mise à jour de carte atteinte",
        "rateLimitMessage": "Il semble que vous ayez atteint le nombre maximum de tentatives autorisées d'ajout de carte pour aujourd'hui. Veuillez réessayer dans 24 heures."
      },
      "aiProductRebilling": {
        "funnel": " entonnoir",
        "images": " Images,",
        "per1000Words": " /1 000 mots, ",
        "perFunnel": " /entonnoir",
        "perImage": " / Image,",
        "pleaseCheckSupport": "veuillez consulter notre",
        "ratesMayDiffer": "Les tarifs peuvent différer selon la région. Les calculs indiqués tiennent compte des tarifs pour le Royaume-Uni,",
        "ratesMayDifferUS": "Les tarifs peuvent différer selon la région. Les calculs sont affichés selon les tarifs de Twilio pour les États-Unis, veuillez consulter Twilio pour plus de détails.",
        "pleaseCheckTwilioRates": "Les SMS sortants pour les États-Unis/Canada seront facturés à 0,0079 $ par segment, et les SMS entrants 0,0075 $ par segment.",
        "words": " mots, "
      },
      "api": {
        "advancedFunctionalityNote": "Remarque de fonctionnalité avancée",
        "agencyApiKeys": "Clés API d’agence",
        "apiAccess": {
          "partOfAdvancedApi": "Cela fait partie de l'API Advanced disponible dans le forfait Pro.",
          "toUpgrade": "pour mettre à niveau."
        },
        "createNew": "Créer",
        "developerCouncilInfo": "Informations du Conseil des Développeurs",
        "noAccess": "Vous n'avez pas accès à cette section.",
        "securityAlert": "Message d'alerte de sécurité",
        "table": {
          "fetchingKeys": "Récupération des clés de l'entreprise...",
          "noKeysYet": "Vous n'avez pas encore de clés API.",
          "toCreateFirstKeys": "pour générer vos premières clés API."
        },
        "zapierNote": "Remarque Zapier"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Possibilité de choisir les calendriers Google à « Ajouter à » + les calendriers « Conflit » à vérifier pour calculer la disponibilité de chaque utilisateur",
        "abilityToAllocateRoundRobin": "Possibilité d'attribuer les rendez-vous en round-robin",
        "abilityToChooseSpecificUser": "Possibilité de sélectionner un utilisateur spécifique avec lequel le rendez-vous doit être réservé.",
        "adminAbilitySeeEveryUser": "Admin - Possibilité de voir tous les rendez-vous du calendrier de chaque utilisateur",
        "adminAbilityViewAllCalendar": "Admin - Possibilité de voir tous les rendez-vous du calendrier de chaque utilisateur",
        "adminsCanDeleteIntegrations": "Les administrateurs peuvent supprimer toutes les intégrations qu'ils souhaitent, mais les utilisateurs ne peuvent supprimer que les leurs",
        "adminsCanSeeAllIntegrations": "Les administrateurs peuvent voir toutes les intégrations, quel que soit leur créateur, mais les utilisateurs ne peuvent voir que les intégrations qu'ils ont créées pour eux-mêmes.",
        "contactDetailAppointments": "Détails du contact > Rendez-vous (Nouveau)",
        "conversationsScheduleAppointment": "Conversations > Programmer un rendez-vous (Nouveau)",
        "essentialConsiderations": "Considérations essentielles",
        "funnelsWebsitesCalendar": "Entonnoirs/Sites Web > Calendrier (Nouveau)",
        "helpReorientTriggers": "Pendant l'appel, nous vous aiderons à réorienter les déclencheurs en fonction de la nouvelle configuration du calendrier.",
        "iAgreeMessage": "Si vous êtes à l'aise avec les changements susmentionnés, veuillez cliquer sur « J'accepte » et commencer à utiliser Calendrier (Bêta) pour cet emplacement",
        "integrationNew": "Intégration (Nouveau)",
        "loseAbilityToViewEdit": "Les utilisateurs de la nouvelle version ne pourront plus consulter/modifier les rendez-vous (créés dans la version précédente) par le biais de la fenêtre modale Informations sur l'opportunité, mais ils pourront continuer à effectuer toutes ces actions depuis la page Rendez-vous.",
        "newOldTriggersCoexist": "Les déclencheurs nouveaux et anciens coexisteront.",
        "nonAdminAbilityViewPersonal": "Non-admin - Possibilité de ne voir que les rendez-vous personnels (les données attribuées/le mappage du calendrier sous GESTION D'ÉQUIPE n'ont pas d'impact).",
        "nonAdminViewPersonalOnly": "Non-admin - Possibilité de ne voir que ses rendez-vous personnels",
        "notAtMoment": "Pas pour le moment, mais nous travailler dur pour la proposer sur mobile dès que possible.",
        "oldAppointmentsCanBeViewed": "Les anciens rendez-vous peuvent être consultés sur la page des rendez-vous grâce à un bouton bascule.",
        "oldAppointmentsDisplayed": "Les anciens rendez-vous seront affichés à côté des nouveaux rendez-vous dans la même liste de rendez-vous",
        "oldCalendarVersionAppointments": "Ancienne version du calendrier + Anciens rendez-vous",
        "onlyNewCalendarWidget": "Seul le nouveau widget de calendrier peut être ajouté",
        "opportunityAddAppointment": "Opportunité > Ajouter un rendez-vous (Nouveau)",
        "profilePageAdmin": "Page de profil pour l'administrateur (Nouveau)",
        "profilePageAllUsers": "Page de profil (Tous les utilisateurs)",
        "providesAllOptions": "Fournit toutes les options (Groupes + services) nécessaires pour configurer le nouveau calendrier.",
        "reintegratingConnectionsRequired": "Il peut être nécessaire de réintégrer toutes les connexions une fois que la version bêta du calendrier est activée pour un emplacement donné",
        "roundRobinHighlight": "La possibilité de répartir les rendez-vous en round-robin entre différents groupes d'agents est la principale nouveauté de cette mise à jour.",
        "schedulingCalendarAppointments": "Programmation > Calendrier/Rendez-vous (Nouveaux filtres + Bouton bascule pour passer entre les nouveaux et les anciens rendez-vous)",
        "settingsCalendarBeta": "Paramètres > Calendrier (Bêta)",
        "surfacingFirstTime": "Récupération initiale",
        "teamManagementAdminOnly": "Gestion d'équipe (Disponible uniquement pour les administrateurs)",
        "toggleOffNewVersion": "Bouton bascule désactivé (Nouvelle version)",
        "toggleOnOldVersion": "Bouton bascule activé (Ancienne version)",
        "whatChangesWithNewVersion": "Quels sont les changements apportés par la nouvelle version du calendrier ?",
        "whatDoesCalendarEntail": "Que comprend le Calendrier (Bêta privé) ?",
        "whatHappensToOldAppointments": "Qu'advient-il de nos anciens rendez-vous après la transition ?",
        "whatWillWeSeeMobile": "Que verrons-nous sur la version mobile pendant la bêta ?",
        "willOldAppointmentsBeFactored": "Les anciens rendez-vous seront-ils pris en compte lors du calcul de la disponibilité pour les nouveaux rendez-vous ?",
        "willOldCalendarUrlsWork": "Nos anciennes URL de calendrier continueront-elles à fonctionner après la transition ?",
        "willWeGetNewVersionMobile": "Pourrons-nous utiliser la nouvelle version sur mobile pendant la phase bêta ?",
        "yesOldSettingsPageContinues": "Oui. L'ancienne page de paramètres continuera d'exister et vous pourrez y apporter des modifications. L'ancien widget de calendrier et le nouveau widget de calendrier fonctionneront indépendamment tout en étant constamment synchronisés l'un avec l'autre afin de garantir un calcul précis de votre disponibilité dans les deux systèmes. Pour éviter toute confusion, nous vous encourageons vivement à utiliser les nouvelles URL dans la mesure du possible, afin que vous n'ayez pas à surveiller deux URL distinctes pour les mêmes groupes d'utilisateurs.",
        "yesSyncOnGoogleCalendar": "Oui, puisque la synchronisation à sens unique est activée, le calendrier Google s'assurera que les créneaux non disponibles sont bloqués."
      },
      "companyPlansModal": {
        "billedAnnually": "Facturé chaque année",
        "billedMonthly": "Facturé mensuellement",
        "changePlanFor": "Modifier le plan pour {locationName}",
        "notAuthorized": "Vous n'êtes pas autorisé à effectuer cette action. Seuls les utilisateurs/administrateurs de l'agence et l'administrateur de l'emplacement peuvent effectuer cette opération.",
        "payAnnually": "Payer annuellement",
        "payMonthly": "Payer mensuellement"
      },
      "locationBillingHistory": {
        "billingHistory": "Historique de facturation",
        "cardNo": "N° de carte",
        "errorWhileFetchingInvoices": "Erreur lors de la récupération des factures, cliquer pour réessayer",
        "invoiceDescription": "Description de la facture",
        "invoiceNo": "N° de facture",
        "noInvoices": "Aucune facture",
        "refunded": "Remboursé",
        "succeeded": "réussi",
        "view": "AFFICHER"
      },
      "locationWallet": {
        "autoRechargeWith": "Recharge automatique avec",
        "balance": "Solde :",
        "credits": "Crédits",
        "seeTransactions": "Voir les transactions",
        "whenBalanceLowerThan": "quand le solde est inférieur à"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Veuillez vérifier vos emails ({emails}).",
        "csvSentMessage": "Nous vous enverrons un fichier CSV à votre adresse e-mail. Cela prend généralement 7 à 10 minutes.",
        "enterEmailAddress": "Saisir l'adresse e-mail",
        "exportAndSendCsv": "Exporter et envoyer des fichiers CSV",
        "exportTransactions": "Exporter les transactions",
        "itUsuallyArrives": "Il arrive généralement dans 10 minutes.",
        "useCommasToSeparate": "Utilisez des virgules pour séparer plusieurs e-mails."
      },
      "modifySubscription": {
        "cancelClientDescription": "Annuler l'abonnement de votre client et clôturer le compte",
        "cancelDescription": "Annuler votre abonnement et fermer le compte",
        "cancelImmediately": "Annulez immédiatement",
        "cancelNow": "Annuler",
        "cancelSubscription": "Résilier l'abonnement",
        "changedYourMind": "Vous avez changé d'avis ?",
        "changedYourMindClient": "Vous pouvez reprendre l’abonnement de votre client.",
        "changedYourMindYou": "Vous pouvez reprendre votre abonnement.",
        "confirmByTyping": "Confirmez en saisissant {text} ci-dessous",
        "confirmCancellation": "Confirmer l'annulation",
        "modifySubscription": "Modifier l'abonnement",
        "modifyYourSubscription": "Modifier votre abonnement",
        "resumeSubscription": "Reprendre l'abonnement",
        "subscriptionWillBeCancelledOn": "Cela programmera l'annulation de votre abonnement pour le {date}. Vous pouvez reprendre votre abonnement à tout moment en annulant la résiliation programmée.",
        "subscriptionWillBeCancelledOnClient": "Cela programmera l'annulation de l'abonnement de votre client pour le {date}. Vous et vos clients pouvez reprendre l'abonnement en annulant la résiliation programmée à tout moment.",
        "subscriptionWillBeCancelledOnDate": "Votre abonnement sera résilié le {date}.",
        "subscriptionWillBeCancelledOnDateClient": "L'abonnement de votre client sera résilié le {date}.",
        "subscriptionWillBeResumed": "Votre abonnement sera repris et vous serez facturé normalement.",
        "subscriptionWillBeResumedClient": "L'abonnement de votre client sera repris et il commencera à être facturé normalement.",
        "upgradeDescription": "Passez à une formule d'abonnement supérieure",
        "weAreGladYouStaying": "Nous sommes heureux de savoir que vous restez !",
        "nextBillingDate": "Prochaine date de facturation : {date}",
        "cancelImmediatelyTitle": "Souhaitez-vous vraiment annuler l'abonnement immédiatement ?",
        "cancelNowDescription": "Votre abonnement sera résilié le {date}. Si vous choisissez de le résilier maintenant, votre compte, y compris toutes les activités sortantes telles que les messages programmés et les e-mails, sera immédiatement interrompu.",
        "cancelNowDescriptionClient": "L'abonnement de votre client sera résilié le {date}. Si vous choisissez de le résilier maintenant, le compte de votre client, y compris toutes les activités sortantes telles que les messages programmés et les e-mails, sera immédiatement interrompu.",
        "modifyDescription": "Vous pouvez {action} votre abonnement",
        "modifyDescriptionClient": "Vous pouvez {action} l'abonnement de votre client"
      },
      "noPaymentMethodWarning": {
        "addNow": "Ajoutez maintenant",
        "youNeedToEnterCardInfo": "Vous devez saisir les informations de votre carte.",
        "youNeedToEnterClientCardInfo": "Veuillez saisir les informations de la carte de votre client."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Les frais sont calculés en fonction des jetons. Les nombres de mots indiqués ci-dessous sont des estimations destinées à vous aider à comprendre l'utilisation. La facturation réelle peut varier.",
        "examplePricingGpt4oMini": "Exemple de tarification – GPT-4o Mini",
        "for750kWords": "(pour 750 000 mots) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Entrée",
        "or": "ou ",
        "output": "Sortie",
        "perImage": " / Image",
        "perResultSelection": " / Sélection de résultats",
        "ratesMayDifferUK": "Les tarifs peuvent différer selon la région. Les calculs indiqués sont basés sur les tarifs pour le Royaume-Uni, veuillez consulter notre",
        "ratesMayDifferUS": "Les tarifs peuvent différer selon la région et le type de numéro. Les calculs indiqués tiennent compte des tarifs Twilio pour les États-Unis.",
        "pleaseCheckSupport": "veuillez consulter notre",
        "resultSelection": " Sélection de résultats",
        "supportDoc": "document d'assistance",
        "forMoreDetails": "pour plus de détails",
        "words": " mots"
      },
      "removePaymentMethod": {
        "endingIn": "Se terminant par *{cardNo}",
        "no": "Non",
        "removeCard": "Retirer la carte ?",
        "removing": "Suppression...",
        "yesRemove": "Oui, effacer"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Demander les informations de paiement du client",
        "saasLocationDescription": "Configurez un abonnement SaaS pour cet emplacement",
        "selectSpace": "Sélectionner l'espace",
        "spaceDescription": "Sélectionnez où vous souhaitez configurer la facturation pour cet emplacement."
      },
      "saasEnableProducts": {
        "disable": "Désactiver",
        "enableDisableProducts": "Activer / Désactiver des produits",
        "feature": "Fonctionnalité",
        "unsavedChanges": "Modifications non enregistrées"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "La prochaine facturation pour ce client semble avoir déjà eu lieu. Cela se produit lorsque le compte Stripe de votre agence ne fonctionne pas correctement. Veuillez vous connecter au compte Stripe de votre agence pour résoudre le problème.",
        "copiedText": "texte copié :",
        "couldNotCopy": "Async : Impossible de copier le texte : ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Prochaine date de facturation : ",
        "plan": "Forfait",
        "pleaseContactAgency": "Veuillez contacter l'agence pour activer votre abonnement.",
        "stripeSubscriptionId": "ID d'abonnement Stripe :",
        "subscriptionPlans": "Forfaits",
        "subscriptionWillBeCancelledOn": "Votre abonnement sera résilié le {date}",
        "subscriptionWillBeCancelledOnClient": "L'abonnement de votre client sera résilié le {date}",
        "toModifyClientSubscription": "pour modifier l'abonnement de votre client",
        "toModifyYourSubscription": "pour modifier votre abonnement",
        "whatsappNumberSubscription": "Abonnement au numéro WhatsApp",
        "yourBillingDatePast": "Votre prochaine date de facturation semble être dans le passé. Veuillez contacter {email} pour résoudre ce problème. Entre-temps, tout se déroulera comme d'habitude."
      },
      "salesResources": {
        "certifiedUser": "Utilisateur Certifié",
        "clearFilter": "Effacer le filtre",
        "dateRange": "Date de portée"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Vous paierez {amount} $ par mois, facturés {interval}.",
        "planUpgradeFailed": "Votre plan n'a pas pu être mis à niveau !",
        "planUpgraded": "Votre plan a été mis à niveau !",
        "retryUpgrade": "Réessayer la mise à niveau",
        "upgradeFailed": "La mise à niveau de votre forfait a échoué, veuillez réessayer",
        "upgradedSuccessfully": "Vous avez bien mis à niveau votre forfait {oldPlan} vers {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "facturé comme frais mensuels de {amount} /mois",
        "billedAsYearlyCharge": "facturé comme frais annuels de {amount} /année",
        "upgradeFrom": "Mettre à niveau depuis",
        "whatYouWillGet": "Ce que vous recevrez :"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Solde après la transaction :",
        "callDuration": "Durée de l'appel :",
        "callSid": "SID d'appel :",
        "charge": "Frais :",
        "contact": "Contact :",
        "contactName": "Nom du contact :",
        "contactPhone": "Téléphone du contact :",
        "credit": "Crédit :",
        "creditsAfterTransaction": "Crédits après la transaction :",
        "dateSent": "Date d'envoi",
        "deleted": "<Deleted>",
        "discount": "Réduction :",
        "eventId": "ID de l'événement :",
        "from": "De :",
        "noContactFound": "Aucun contact trouvé",
        "noOfSegments": "Nombre de segments :",
        "openContactPage": "Ouvrir la page de contact",
        "openConversation": "Ouvrir la conversation",
        "openEvent": "Événement ouvert",
        "originalCharge": "Frais initiaux :",
        "received": "Reçu",
        "smsSid": "SID de SMS :",
        "timeBilled": "Temps facturé :",
        "timeOfCall": "Heure de l'appel",
        "transactionDetails": "Informations de la transaction -",
        "transactionId": "ID de transaction :",
        "type": "Type :",
        "segments": "Segments"
      },
      "calendarSettings": {
        "meetings": "Réunions",
        "services": "Services",
        "hideCalendarWarning": "Si vous souhaitez masquer complètement le module Calendrier, faites-le depuis la Configuration du sous-compte > Mon personnel > Rôles et autorisations",
        "calendarSettingsUpdated": "Paramètres du calendrier mis à jour",
        "meetingDescription": "Activez cette option pour permettre aux sous-comptes d'utiliser la fonctionnalité Réunions, conçue pour gérer les calendriers de ventes, les appels d'intégration, la planification round-robin, les collaborations d'équipe, les réservations de cours, les entretiens, et plus encore. Idéal pour les entreprises ayant besoin d'outils de planification flexibles et collaboratifs.",
        "serviceDescription": "Activez les Services pour donner aux sous-comptes accès à une solution de réservation complète pour les entreprises de services. Cela comprend la création de pages de réservation avec plusieurs services, la gestion des ressources, la gestion de plusieurs emplacements, la définition de tarifications spécifiques au personnel, l'ajout de variations de services ou de modules complémentaires, et plus encore."
      }
    },
    "apiKeys": {
      "apiKey": "Clé API",
      "copied": "Copié !",
      "copyApiKey": "copier l'ID secret",
      "createApiKey": "Créer une clé API",
      "deleteAllKeys": "Supprimer toutes les clés",
      "nameRequired": "Le champ Nom est obligatoire.",
      "somethingWentWrong": "Désolé, une erreur s'est produite. Veuillez réessayer.",
      "updatedSuccessfully": "Mise à jour réussie"
    },
    "billing": {
      "accountPaused": "Votre compte {name} a été mis en pause.",
      "accountProvisioned": "Votre compte est en cours de configuration.",
      "activateSubAccount": "Activer le sous-compte",
      "activeServices": "Services actifs",
      "addNewCard": "Ajouter une nouvelle carte",
      "addNewService": "Ajouter un nouveau service",
      "addPaymentMethod": "ajouter un mode de paiement",
      "alertIcon": "Icône d'alerte",
      "approve": "Approuver",
      "authenticateCardMessage": "Pour renforcer la sécurité, vous devez réauthentifier les informations de votre carte.",
      "badActorWarning": "Si vous pensez que ce sous-compte a été créé par une personne malveillante, nous vous recommandons de le supprimer et de résilier l'abonnement correspondant.",
      "callUs": "Appelez-nous",
      "cancelAndDelete": "Résilier l'abonnement et supprimer le sous-compte",
      "completeFormNextStep": "Veuillez compléter le formulaire à l'étape suivante",
      "congratulations": "🎉 Félicitations ! 🎉",
      "contactAgency": "Veuillez contacter votre agence pour résoudre ce problème",
      "contactThroughEmailOrPhone": "Vous pouvez nous contacter par e-mail ou par téléphone pour résoudre ce problème.",
      "dataSafe": "Toutes vos données sont en sécurité et toutes les automatisations, pages web, etc. fonctionneront à nouveau une fois le paiement réussi.",
      "declineSubAccount": "Refuser le sous-compte",
      "deleteRecommendation": "Il est recommandé de supprimer ce sous-compte. Sinon, vous pouvez le faire plus tard depuis la page Sous-comptes > Gérer le client.",
      "emailUsAt": "Envoyez-nous un e-mail à",
      "moveToDashboard": "Accéder au tableau de bord",
      "noPaymentMethods": "Il semble qu'aucune méthode de paiement n'ait été ajoutée ! Veuillez",
      "paymentMethod": "Mode de paiement",
      "paymentMethodUpdated": "Votre méthode de paiement a été mise à jour",
      "paymentNotCompleted": "Vous voyez ce message, car le paiement n'a pas abouti.",
      "proceedToNextStep": "Passer à l'étape suivante",
      "questionMark": "?",
      "reachOutMessage": "n'hésitez pas à nous contacter en cas de questions.",
      "reactivateBillingFor": "Réactiver la facturation pour {location}",
      "retryPayment": "Réessayer de payer",
      "secureSystemMessage": "Nous avons adopté un système de facturation plus sûr.",
      "setupMessage": "Quelqu'un va vous contacter pour configurer le compte. Cela prend généralement 12 à 24 heures,",
      "signout": "Déconnexion",
      "subAccountId": "ID de sous-compte :",
      "successfullyInitiated": "{product} a été initialisé avec succès",
      "systemError": "Une erreur système est survenue",
      "toReactivate": "pour réactiver le compte",
      "userImage": "Image utilisateur",
      "verificationSkipped": "La vérification de l'adresse e-mail et du numéro de téléphone sera ignorée pour ce sous-compte et le client pourra y accéder.",
      "verifyAccount": "Vérifier le compte",
      "verifyAfterAttempt": "Vous pouvez vérifier ce compte après au moins une tentative de vérification de la part de l'administrateur du sous-compte",
      "verifySubAccount": "Vérifier le sous-compte",
      "recommendedPlans": "Forfaits recommandés",
      "buildYourOwnPlan": "CRÉEZ VOTRE PROPRE PLAN",
      "resetToDefaults": "Réinitialiser aux paramètres par défaut",
      "paymentMethodChange": "Si vous avez besoin de changer de mode de paiement",
      "approveSubAccount": "Approuver le sous-compte",
      "approveSubAccountDescription": "Le sous-compte sera réactivé, et les administrateurs du sous-compte pourront y accéder et l'utiliser.",
      "productInitiated": "Produit lancé"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Cette action est irréversible.",
      "cancelKeep": "Annuler, Garder",
      "confirmDeletionInstructions": "Confirmez la suppression en tapant {word} ci-dessous :",
      "enterConfirm": "Entrez {word} pour régénérer",
      "message": "La clé API de cet emplacement sera supprimée.",
      "title": "Supprimer l'ID secret de l'emplacement ?",
      "yesDelete": "Oui, supprimer"
    },
    "generalDetails": {
      "noPermission": "Vous n'avez pas l'autorisation de télécharger le fichier. Vérifiez vos autorisations avec l'administrateur de votre agence.",
      "relatedContacts": "Contacts associés ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Voulez-vous vraiment supprimer toutes les clés API d'emplacement ?",
      "deleteAllConfirmTitle": "Supprimer toutes les clés API d’emplacement ?",
      "deleteConfirmMessage": "Vous allez supprimer l'ID secret de l'emplacement : {location}. Voulez-vous continuer ?",
      "deleteAgencyApiKeyConfirmMessage": "Cela supprimera la clé API. Voulez-vous continuer ?",
      "fetchingLocations": "Récupération des emplacements...",
      "maxApiKeysMessage": "Vous pouvez avoir un maximum de cinq clés API.",
      "noLocationsFound": "Aucun emplacement trouvé",
      "old": "Ancien",
      "proPlanRequiredMessage": "Cela fait partie de l'API Advanced disponible dans le forfait Pro.",
      "searchLocation": "Rechercher un emplacement",
      "title": "Clé API d'emplacement"
    },
    "locationCard": {
      "deletionScheduledMessage": "Ce sous-compte sera supprimé le {date}. Si vous avez changé d'avis,",
      "emailUsageNotRebilled": "L'utilisation des e-mails n'est pas refacturée",
      "emailUsageRebilled": "L'utilisation des e-mails est refacturée à votre client",
      "listings": "Annonces",
      "manageClient": "Gérer le client",
      "paymentPending": "Le paiement est en attente",
      "remainingWalletBalance": "Solde restant du portefeuille numérique de cet emplacement SaaS",
      "requestPaymentAgain": "Demander à nouveau le paiement",
      "saasModeActivated": "Le mode SaaS est activé",
      "saasModeNotActivated": "Le mode SaaS n'est pas activé",
      "saasSubscriptionNotEnabled": "Le calendrier d'abonnement SaaS n'est pas activé",
      "saasSubscriptionRunning": "L'abonnement SaaS est en cours",
      "social": "Réseau social",
      "switchToSaaS": "Passer à SaaS",
      "switchToSubAccount": "Passer au sous-compte",
      "telephoneUsageNotBilled": "L'utilisation du téléphone n'est pas facturée",
      "telephoneUsageRebilled": "L'utilisation du téléphone est refacturée à votre client",
      "wordpressActive": "WordPress actif",
      "wordpressInactive": "WordPress inactif",
      "wordpressNotSoldYet": "WordPress n'est pas encore vendu",
      "wordpressSaleSuccessful": "Vente de WordPress réussie",
      "yextActive": "Yext dynamique",
      "yextInactive": "Yext inactif",
      "yextNotSoldYet": "Yext n'est pas encore vendu",
      "yextSaleSuccessful": "Vente de Yext réussie",
      "reviews": "Avis"
    },
    "messageUsage": {
      "acceptTnc": "Veuillez accepter les CGU",
      "cannotPerformAction": "Impossible d'effectuer cette action. N'hésitez pas à nous contacter pour obtenir de l'aide.",
      "currentLimit": "Limite actuelle",
      "days": "Jour(s)",
      "failedToUpdate": "Échec de la mise à jour de l'utilisation des messages",
      "helpCentre": "Centre d'aide",
      "increaseLimitFurther": "Augmenter la limite",
      "increaseLimitNow": "Augmenter la limite maintenant",
      "lessThanUsage": "L'utilisation actuelle est de {usage}. L'utilisation sélectionnée est inférieure à l'utilisation actuelle.",
      "lessThanUsageModal": "L'utilisation actuelle est de {usage}. La limite ne peut pas être inférieure à l'utilisation actuelle",
      "limitAlreadyUnlocked": "La limite est déjà déverrouillée",
      "limitReached": "Limite atteinte",
      "limitUpdatedFrom": "Limite {type} mise à jour de {old} à {new}",
      "lookingForSmsLimit": "Besoin d'une limite SMS ?",
      "minLimitShould": "La limite minimum doit être de {limit}",
      "newLimit": "Nouvelle limite {type}",
      "perDay": "/ Jour",
      "sameLimit": "La limite sélectionnée est identique à la limite en cours !",
      "smsLimitLocation": "Les limites de SMS peuvent désormais être trouvées au niveau de l'emplacement.",
      "smsLimitSettingsInfo": "Vous pouvez maintenant trouver ces paramètres sous « Limite de communication » dans « Paramètres avancés »",
      "timesInLast30Days": "Nombre de fois au cours des 30 derniers jours",
      "todaysUsage": "Utilisation ce jour",
      "typePerDay": "{type} / jour",
      "updateLimit": "Mettre à jour la limite",
      "updateLimitFor": "Mettre à jour la limite {type} pour {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "{type} actif",
      "contactSource": "Source du contact",
      "customer": "Client",
      "noPastCampaignsWorkflows": "Aucun {type} passé",
      "pastCampaignsWorkflows": "{type} passé"
    },
    "settings": {
      "affiliateSettings": "Configuration d'affilié",
      "agencyBilling": "Facturation de l'agence",
      "agencyTeamManagement": "Gestion d'équipe d'agence",
      "apiKeys": "Clés API",
      "compliance": "Conformité",
      "customMenuLink": "Lien de menu personnalisé",
      "launchpadSettings": "Configuration de Launchpad",
      "phoneSystemTwilio": "Système téléphonique – Twilio",
      "smtpService": "Service SMTP",
      "userSettings": "Paramètres utilisateur",
      "agencySettings": "Paramètres de l'agence",
      "mailgun": "Mailgun"
    },
    "snapshot": {
      "errorCreating": "Erreur lors de la création de l'instantané",
      "pickAnAccount": "Vous devez sélectionner un compte.",
      "snapshotName": "Nom de l'instantané",
      "snapshotNameRequired": "Vous devez donner un nom à l'instantané."
    },
    "socialDetails": {
      "blogRss": "Blog RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "ID Google Places",
      "googlePlus": "Google+",
      "googlePlusUrl": "URL Google+",
      "instagramUrl": "URL Instagram",
      "linkedInUrl": "URL LinkedIn",
      "pinterest": "Pinterest",
      "pinterestUrl": "URL Pinterest",
      "yelp": "Yelp",
      "yelpUrl": "URL Yelp",
      "youTube": "YouTube"
    },
    "requestSms": "Demande par SMS",
    "iAlreadyHaveACustomer": "J'ai déjà un client",
    "noAccountFound": "Aucun compte trouvé !",
    "thisIs": "Ceci est",
    "pleaseEnterValueBetween0To30Days": "Veuillez entrer une valeur comprise entre 0 et 30 jours",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Découvrez comment ajouter des frais de configuration uniques à ces forfaits",
    "doNotDeleteStripeProductsWarning": "Veuillez <span style=\"font-weight: bold;\">ne pas supprimer</span> ces produits dans votre compte Stripe",
    "opportunityStats": "Statistiques des opportunités",
    "createNewSnapshot": "Créer un nouvel instantané",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Tableau de bord de l'agence visible par",
      "onlyMe": "Moi uniquement",
      "allAgencyAdmins": "Tous les administrateurs d'agence",
      "stripeConnect": "Sera bientôt obsolète. Passez à Stripe Connect",
      "recommendStripe": "Nous vous recommandons d’utiliser Stripe Connect pour plus de sécurité",
      "switchToStripeConnect": "Passer à Stripe Connect",
      "highLevelAccess": "HighLevel aura accès à vos données et pourra créer des paiements et des clients en votre nom",
      "stripeAccountWarning": "Une fois connecté, le compte Stripe ne pourra plus être modifié. Il est recommandé d'utiliser un nouveau compte Stripe dédié aux revenus Highlevel.",
      "connectToStripeAccount": "Connectez-vous à votre compte Stripe",
      "unverified": "Le compte Stripe connecté à cette agence n'est pas vérifié et ne peut pas collecter les paiements. Veuillez terminer la vérification en vous connectant à votre compte Stripe.",
      "loginToStripe": "Se connecter à Stripe",
      "connectedAccount": "Compte connecté",
      "verified": "VÉRIFIÉ",
      "totalPendingBalance": "Solde total en attente",
      "disconnectStripe": "Déconnecter Stripe",
      "removeSaasPlanConfigurations": "Supprimer toutes les configurations du forfait SaaS ?",
      "haveSaasPlans": "Vous avez créé des forfaits SaaS sur votre compte Stripe.",
      "disconnectWarning": "Si vous le déconnectez, tous les forfaits SaaS seront perdus et vous devrez les créer à nouveau.",
      "acknowledgeDisconnect": "Je comprends que tous mes forfaits SaaS seront perdus et que je devrai les créer à nouveau.",
      "disconnect": "Déconnecter"
    },
    "zoomSuccess": {
      "title": "J'espère que vous avez eu une excellente expérience !",
      "message": "Merci d'avoir participé à cet appel. Au plaisir de vous accueillir à nouveau !"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Votre spécialiste de l'expérience d'essai",
      "successSpecialist": "Votre spécialiste de la réussite",
      "supportSpecialist": "Votre spécialiste de l'assistance",
      "jumpOnZoomCall": "Rejoignez-moi sur Zoom pour votre appel de lancement",
      "jumpOnChat": "Rejoignez-moi par chat pour obtenir de l'aide",
      "joinVideoCallNow": "Rejoignez l'appel vidéo maintenant",
      "whatToExpect": "À quoi devez-vous vous attendre ?",
      "helpArticles": "Articles d'aide",
      "changelog": "Journal des modifications",
      "ideasBoard": "Tableau d’idées"
    },
    "saasDashboard": {
      "title": "Tableau de bord SaaS",
      "plansAndPricing": "Forfaits et tarifs"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Une interface plus propre et plus rapide est désormais disponible pour cette page. Essayez-la !",
      "enableInLabs": "Activer dans Labs",
      "pendingTransferRequests": "Vous avez des demandes de transfert de sous-compte en attente.",
      "otherAgenciesRequested": "D'autres agences ont demandé de vous transférer des sous-comptes.",
      "reviewRequests": "Demandes d'avis",
      "clientList": "Liste des clients (sous-comptes)",
      "subAccountTransfers": "Transferts de sous-compte"
    },
    "implementationModal": {
      "title": "Votre expérience d'appel vidéo HighLevel est sur le point de démarrer !",
      "videoCall": "Appel vidéo",
      "whatsNext": "Et après ?",
      "enteringLobby": "Vous entrerez dans notre accueil en compagnie d'autres Highlevelers comme vous !",
      "successConcierge": "Notre concierge de la réussite vous accueillera et vous mettra en contact avec le prochain conseiller disponible pour une session individuelle.",
      "haveReady": "Veuillez avoir les éléments suivants prêts",
      "stableInternet": "Connexion Internet stable.",
      "videoNameMatches": "Le nom de votre vidéo correspond à votre nom d'utilisateur HighLevel.",
      "estimatedDuration": "Durée estimée de la session",
      "firstVisit": "Première visite : Session d'onboarding HighLevel  : (45-60 minutes).",
      "returning": "Visite suivante : Assistance à la configuration continue (15-25 minutes).",
      "meetingBegins": "Votre réunion commencera automatiquement dans <span class=\"text-[#155EEF]\">{ countdown } secondes.</span>  Vous pouvez également la rejoindre immédiatement en cliquant sur le bouton ci-dessous :",
      "joinNow": "Rejoindre maintenant"
    },
    "gdpr": {
      "logo": "Logo RGPD",
      "dataProtection": "Protection des données et RGPD",
      "introduction": "Introduction",
      "intro1": "HighLevel s'engage à protéger la vie privée de ses utilisateurs et de leurs clients. Nous nous tenons au courant de l'évolution des lois sur la protection des données afin que vous puissiez utiliser notre plateforme en toute sécurité.",
      "intro2": "Cette page a pour but d'expliquer quelles sont les règles, comment elles s'appliquent à votre utilisation de la plateforme HighLevel et les mesures que nous avons prises pour nous y conformer.",
      "intro3": " Nous vous conseillons de lire ce document conjointement avec notre Politique de confidentialité et de contacter un professionnel du droit spécialisé si vous avez besoin de plus d'informations ou de conseils.",
      "gdprRegulation": "Règlement général sur la protection des données (RGPD)",
      "regulation1": "Le règlement (UE) 2016/679, plus communément appelé Règlement général sur la protection des données (RGPD), est un règlement de l'UE visant à harmoniser les lois sur la protection des données et de la vie privée dans l'ensemble de l'UE. Les dispositions du RGPD s'appliquent dès lors que des données personnelles d'une personne concernée de l'UE sont impliquées.",
      "regulation2": "Le RGPD vise à donner aux individus plus de contrôle sur la manière dont leurs données sont utilisées par les entreprises, et à rendre la collecte et le traitement des données plus transparents.",
      "regulation3": "Le RGPD a été incorporé directement dans le droit britannique après la fin de la période de transition du Brexit, ce qui signifie que les entreprises britanniques doivent encore se conformer à ses dispositions par le biais du « UK GDPR ».",
      "basicConcepts": "Concepts simples du RGPD",
      "controllerAndProcessor": "Responsable de traitement et sous-traitant",
      "controllerProcessorObligation": "Le RGPD impose diverses obligations à une personne selon qu'elle est un responsable du traitement ou un sous-traitant de données à caractère personnel.",
      "controllerDefinition": " Un responsable du traitement est une entité qui décide de traiter des données à caractère personnel et qui prend des décisions concernant la base du traitement et les méthodes qui seront utilisées. Les responsables du traitement des données ont certaines obligations concernant les données personnelles, dont vous devriez vous familiariser avant de collecter des données personnelles auprès de vos clients.",
      "processorDefinition": "Un sous-traitant est une entité qui traite des données pour le compte d'un responsable du traitement. Il ne prend aucune décision indépendante concernant les données ou leur traitement, puisqu'il ne les traite que pour le compte du responsable du traitement et doit se conformer à toutes les instructions données par ce dernier.",
      "youAreController": "Lorsque vous utilisez le service HighLevel, vous êtes un responsable du traitement. Vous contrôlez les données que vous importez dans le système HighLevel, ce que vous faites de ces données et pourquoi. Par conséquent, il vous incombe de vous assurer que vous disposez d'une base juridique pour traiter les données et que vous ne les conservez pas plus longtemps que nécessaire.",
      "highlevelIsProcessor": "Vous devez vous assurer que vous comprenez vos obligations en tant que responsable du traitement, et mettre à jour vos propres systèmes et politiques pour permettre le transfert légal de données personnelles à HighLevel. HighLevel est un sous-traitant de données. Par l'intermédiaire de la plateforme HighLevel, nous stockons et gérons les données que vous avez collectées selon vos instructions. Nous n'utiliserons jamais les données à caractère personnel que vous avez importées dans le système HighLevel à nos propres fins ou sans votre autorisation.",
      "legalBasisForProcessing": "Base légale pour le traitement",
      "legalBasisRequirement": "Les données à caractère personnel ne peuvent être collectées et traitées que s'il existe une base juridique pour le faire. Les bases légales autorisées sont définies dans le RGPD.",
      "processorReliesOnCustomers": "En tant que sous-traitant, HighLevel compte sur ses clients pour sélectionner la base correcte sur laquelle ils collecteront et traiteront les données à caractère personnel, et pour mettre en place les avertissements et consentements appropriés. Avant d'utiliser le service HighLevel, vous devez prendre le temps d'identifier la base juridique dont vous pouvez vous prévaloir, et ne collecter et conserver les données à caractère personnel que dans la mesure nécessaire à l'application de ces bases. Vous ne devez pas changer la base sur laquelle vous avez collecté les données à caractère personnel sans une très bonne raison. Il est donc important de comprendre les exigences des différentes bases et de vous assurer que vous choisissez la bonne dès le départ.",
      "dataSubjectAccessRights": "Droits d'accès des personnes concernées",
      "dataSubjectRights": "Le RGPD accorde aux personnes concernées (c'est-à-dire vos clients) certains droits relatifs à leurs données personnelles, y compris le droit d'accès, de rectification et/ou de suppression des données les concernant.",
      "highlevelEasySystems": "HighLevel a mis en place des systèmes simples vous permettant de nous informer si vous recevez une telle demande de la part d'une personne concernée, et nous permettant de vous informer si nous recevons une telle demande. Nous veillerons à ce que ces demandes soient rapidement satisfaites, conformément à vos instructions. Vous devez vous familiariser avec les obligations qui vous seront imposées, notamment en ce qui concerne les données à caractère personnel que vous détenez sur vos propres systèmes ou sur des services autres que HighLevel.",
      "transfersToUSA": "Transferts de données vers les États-Unis",
      "transfersRestrictions": "Les statistiques personnelles ne peuvent être transférées en dehors de l’EEE, sauf dans des circonstances spécifiques. Nous utilisons les Clauses contractuelles types dans le cadre de l'accord sur le traitement des données que nous signons avec tous nos clients.",
      "dataSecurity": "Sécurité des données",
      "securitySafeguards": "Nous avons mis en place de solides mesures de sécurité pour garantir que toutes les données personnelles que nous détenons sont stockées en toute sécurité. Nous effectuons régulièrement des tests sur nos produits pour détecter les bugs et les vulnérabilités.",
      "backupSystems": "Nous veillons à mettre en place des systèmes de sauvegarde réguliers et à disposer de systèmes et de processus de récupération et d'intégrité des données afin de minimiser le risque de corruption ou de perte de données à caractère personnel.",
      "stepsForCompliance": "Mesures que nous avons prises pour garantir la conformité au RGPD",
      "dutyAsProcessor": "Nous prenons très au sérieux nos obligations en tant que sous-traitant. Nous avons mis en place un certain nombre de procédures et pris un certain nombre de mesures afin de nous assurer que nous restons conformes au RGPD et que vous pouvez nous envoyer dans le respect de la loi des données personnelles que vous avez collectées. Par exemple :",
      "standardContractualClauses": "Notre accord de traitement des données utilise les Clauses contractuelles types pour garantir que vous puissiez nous envoyer légalement des données à caractère personnel aux États-Unis.",
      "detectBreaches": "Nous sommes en mesure de détecter les atteintes à la vie privée et d'en informer nos clients dès que possible.",
      "dealWithAccessRequests": "Nous sommes en mesure de traiter les demandes d'accès des personnes concernées et les demandes de droit à l'effacement, et nous veillons à vous informer lorsqu'une personne concernée nous a adressé une telle demande.",
      "assessedDocumented": "Nous avons évalué et documenté les données personnelles que nous traitons en votre nom.",
      "assessedSecurity": "Nous avons évalué notre sécurité et l'avons améliorée où cela état nécessaire afin de nous assurer qu'elle est adaptée au niveau de risque auquel nous sommes confrontés en cas de violation des données.",
      "dataProcessingAgreement": "Accord sur le traitement des données",
      "dateUpdated": "Date de mise à jour : 1er avril 2023",
      "downloadAgreement": "Télécharger l'accord",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Avez-vous des questions ?"
    },
    "sendGridSettings": {
      "title": "Paramètres de SendGrid",
      "settingsForLocations": "Paramètres SendGrid pour les emplacements",
      "sendGrid": "SendGrid",
      "last12Months": "Les 12 derniers mois",
      "totalSent": "Total envoyé",
      "opens": "Ouvertures",
      "clicks": "Clics",
      "bounces": "Rebonds"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Désactivez Launchpad pour tous mes emplacements.",
      "description1": "Launchpad est une page de destination bien conçue qui a prouvé qu'elle augmentait la satisfaction et la fidélisation des clients en augmentant l'utilisation du produit. ",
      "description2": "La connexion de GMB, FB, le plugin Webchat, l'utilisation d'une application mobile, etc. se sont révélés être des éléments très utiles pour fidéliser les clients plus longtemps.",
      "confirmDisable": "Êtes-vous sûr de vouloir désactiver Launchpad ?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Ceci est votre lien d'affiliation, utilisez ce lien pour permettre aux personnes que vous connaissez de s'inscrire pour un compte et vous recevrez 40 % de leurs revenus mensuels récurrents à vie.",
      "appendToUrls": "Ajoutez ceci à la fin de vos URL :",
      "needToSignUp": "Besoin de vous inscrire ?",
      "goToUrl": "Accédez à l'URL :",
      "andSignUpUsing": "et inscrivez-vous en utilisant l'adresse e-mail",
      "asYourEmailAddress": "comme votre adresse e-mail pour FirstPromoter.",
      "pageSettings": "Paramètres de la page",
      "facebookPixelId": "ID de pixel Facebook",
      "pixelId": "ID de pixel"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "À partir du 17 juin 2024, la sécurité renforcée sera automatiquement activée par défaut sur votre compte. Les améliorations de sécurité renforcées incluent :",
      "discontinuationOfAutoGeneration": "Arrêt de la génération automatique des clés API d'emplacements",
      "exclusionOfApiKeysInLocationCrudApis": "Exclusion des clés API dans l'API CRUD pour l'emplacement",
      "optOutLink": "Pour vous désinscrire de cette modification, veuillez désactiver la sécurité renforcée du compte dans <a href=\"/settings/company\">Paramètres &gt; Entreprise</a>",
      "advancedFunctionalityNote": "Cette API est destinée à des fonctionnalités avancées. Notre équipe d'assistance n'est pas en mesure de fournir une assistance directe concernant la configuration de l'API.",
      "developerCouncilInfo": "Nous proposons un Conseil des Développeurs qui se réunit une fois par mois pour des heures de permanence (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) et un canal Slack de la Communauté des Développeurs où vous pouvez trouver de l'aide auprès de la communauté et de notre équipe API. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Pour utiliser Zapier, vous devez utiliser la clé API d'emplacement pour l'emplacement spécifique. Vous pouvez l'obtenir à partir de la liste ci-dessous ou en passant au compte à l'aide du bouton à bascule situé dans le menu de gauche.",
      "partOfAdvancedApi": "Cela fait partie de l'API Advanced disponible dans le forfait Pro.",
      "upgradeMessage": "Cela fait partie de l'API Advanced disponible dans le forfait Pro. <a>Cliquez ici</a> pour changer de forfait."
    },
    "accountMap": {
      "addAccountManually": "Ajouter un compte manuellement"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Paramètres en tant que groupes."
    },
    "accountDetails": {
      "basicDetails": "Détails de base",
      "saas": "SaaS",
      "rebilling": "Refacturation",
      "marketplaceApps": "Applications de la marketplace",
      "advancedEmailSettings": "Paramètres avancés",
      "calendarSettings": "Paramètres du calendrier"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Gérer les paramètres d'emplacement",
      "disableAddEmailService": "Désactiver le bouton Ajouter un service de messagerie dans les paramètres de service de messagerie du sous-compte",
      "disableAddSmtp": "Désactiver le bouton Ajouter un service de messagerie dans les paramètres de service de messagerie du sous-compte",
      "restrictSubAccountEmailProvider": "Empêcher les utilisateurs de sous-comptes d'inclure leur propre fournisseur de service de messagerie électronique",
      "disableAddSmtpDescription": "Empêcher les utilisateurs de sous-comptes d'inclure leur propre fournisseur de service de messagerie électronique",
      "enableReVerification": "Activer la revérification pendant 90 jours",
      "locationNoLeadConnector": "L'emplacement n'a pas LeadConnector comme fournisseur de courrier électronique par défaut",
      "lcEmailNotEnabled": "L'emplacement n'a pas LeadConnector comme fournisseur de courrier électronique par défaut",
      "onlyForAgency": "Vous pouvez uniquement voir ces paramètres activés pour l'agence",
      "onlyVisibleForAgency": "Vous pouvez uniquement voir ces paramètres activés pour l'agence",
      "reVerificationDescription": "Chaque statut de vérification d'e-mail sera révoqué après 90 jours (protégez votre réputation d'expéditeur et garantissez une délivrabilité optimale)"
    }
  },
  "attributes": {
    "addAttribute": "Ajouter un Attribut",
    "attributeName": "Nom de l'Attribut",
    "enterAttributeName": "Saisissez le nom de l’attribut",
    "number": "Nombre",
    "selectAttributeType": "Sélectionnez le type"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Métadonnées supplémentaires",
      "title": "Champs ajoutés/mis à jour"
    }
  },
  "bulkActions": {
    "additionalDetails": "Informations supplémentaires",
    "allOnGivenDate": "Tous à une date donnée",
    "attempted": "Tentative",
    "batchQuantity": "Quantité par lot",
    "bulkActionProcessing": "Traitement des actions en masse",
    "bulkActionTitle": "Action en masse",
    "campaignRequired": "La campagne est obligatoire",
    "currentStatus": "Statut actuel",
    "delayBetweenBatches": "Délai entre les lots",
    "dispatchMode": "Mode d'expédition : {mode}",
    "editBatchQuantity": "Modifier la quantité par lot",
    "emailStats": "Statistiques sur les e-mails",
    "enterBatchSprintLimit": "Veuillez entrer une limite de sprint par lot",
    "hideStats": "Masquer les statistiques",
    "mode": "Mode",
    "nextProcessingOn": "Prochain traitement le",
    "noStatsFound": "Aucune statistique trouvée",
    "parentBulkActionID": "ID d'action en masse parent",
    "pleaseEnterQuantity": "Saisissez une quantité",
    "processAllAsSoonAsPossible": "Traiter tout dès que possible",
    "processAllOnGivenDate": "Traiter tout à la date donnée",
    "processDuring": "Traiter pendant",
    "processGraduallyDrip": "Traiter progressivement (goutte-à-goutte)",
    "processingAllowedOn": "Traitement autorisé le",
    "restoredBulkActionId": "ID de l'action en masse restaurée :",
    "revert": "Annuler",
    "revertedBulkActionId": "ID de l'action en masse rétablie :",
    "saveChanges": "Enregistrer les modifications",
    "scheduledStart": "Démarrage programmé",
    "showErrorLog": "Afficher le journal des erreurs",
    "showImported": "Afficher les produits importés",
    "showStats": "Afficher les statistiques",
    "skipped": "Ignoré",
    "statistics": "Statistiques",
    "statuses": {
      "complete": "Terminer",
      "next-drip": "Goutte-à-goutte suivant",
      "notStarted": "Pas démarré",
      "processing": "Traitement",
      "queueing": "Mise en file d'attente",
      "reading": "Lecture",
      "resumed": "Reprendre",
      "reverted": "rétabli",
      "waiting": "En attente"
    },
    "successful": "Opération réussie",
    "tagsAdded": "Mots-clés ajoutés",
    "tagsRemoved": "Mots-clés supprimés",
    "tagsRestored": "Mots-clés restaurés",
    "timeElapsed": "Temps écoulé",
    "totalExported": "Total exporté",
    "totalMerge": "Total fusionné",
    "unknownError": "Erreur inconnue",
    "updateBatchQuantity": "Mettre à jour la quantité par lot",
    "updated": "Mis à jour",
    "usesDynamicList": "** Utilise une liste dynamique",
    "workflowRequired": "Le flux de travail est obligatoire"
  },
  "business": {
    "addedToCompany": "Contact(s) ajouté(s) à l'entreprise avec succès",
    "cantAddMoreContacts": "Impossible d'ajouter plus de 50 contacts en une fois",
    "cleanerUi": "Interface plus épurée",
    "common": {
      "addContact": "Ajouter un contact",
      "internalServerError": "Erreur de serveur interne",
      "to": "à"
    },
    "companiesNowHave": "Les entreprises disposent maintenant",
    "companyNoteLabsText": "Les notes d'entreprise sont une fonctionnalité Labs",
    "contactRemoveCompany": "Êtes-vous sûr de vouloir supprimer ce contact de l'entreprise ?",
    "moreFunctionalUx": "Expérience plus fonctionnelle",
    "newCompanyUpdate": "Nouvelle mise à jour de l'entreprise !",
    "tabs": "Onglets",
    "tasks": {
      "assignTask": "Attribuer une tâche",
      "assignee": "Responsable",
      "deleteTask": "Supprimer la tâche",
      "editTask": "Modifier la tâche",
      "markAsComplete": "Marquer comme Terminé",
      "markAsPending": "Marquer comme en attente",
      "nameAndDescription": "Nom et Description",
      "noTasksAvailable": "Aucune tâche disponible"
    },
    "visitLabs": "Accéder à Labs"
  },
  "calendar": {
    "googleCalendar": "Google Agenda",
    "noSync": "Pas de synchronisation",
    "outlookCalendar": "Calendrier Outlook"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Activer/Désactiver le débogueur Frontend"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Une erreur s'est produite. Veuillez réessayer",
    "tabs": "Onglets",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "goToHomepage": "Aller à la page d'accueil",
    "leadConnectorHqLogo": "Logo Lead Connector HQ",
    "companyLogo": "Logo de l'entreprise",
    "countries": {
      "australia": "Australie",
      "austria": "Autriche",
      "czechRepublic": "République tchèque",
      "belgium": "Belgique",
      "brazil": "Brésil",
      "canada": "Canada",
      "chile": "Chili",
      "denmark": "Danemark",
      "switzerland": "Suisse",
      "germany": "Allemagne",
      "estonia": "Estonie",
      "spain": "Espagne",
      "finland": "Finlande",
      "france": "France",
      "uk": "Royaume-Uni",
      "hongKong": "Hong Kong",
      "hungary": "Hongrie",
      "ireland": "Irlande",
      "italy": "Italie",
      "japan": "Japon",
      "kenya": "Kenya",
      "lithuania": "Lituanie",
      "mexico": "Mexique",
      "netherlands": "Pays-Bas",
      "newZealand": "Nouvelle-Zélande",
      "norway": "Norvège",
      "philippines": "Philippines",
      "puertoRico": "Porto Rico",
      "poland": "Pologne",
      "portugal": "Portugal",
      "sweden": "Suède",
      "singapore": "Singapour",
      "unitedStates": "États-Unis",
      "vietnam": "Vietnam",
      "southAfrica": "Afrique du Sud"
    },
    "countryshortcodes": {
      "ca": "Californie",
      "eu": "UE",
      "in": "IN",
      "na": "NA",
      "us": "États-Unis"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "Mot de passe à usage unique (OTP)",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "TVA",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Modifier la catégorie de numéro - <strong>{name}</strong>",
      "displayphonenumber": "afficherNuméroTéléphone",
      "js_heap_memory": "Mémoire Heap JS",
      "vuex_store_modules": "Modules Vuex Store",
      "vuex_store_size": "Taille de Vuex Store",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "model-image",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "fichier-image",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://exemple.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com ou utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "La vérification <strong>SHAKEN/STIR</strong> est terminée pour votre sous-compte. Établissez une relation de confiance avec vos clients grâce à des appels vérifiés.",
      "mp3wavfile": "Fichier mp3/wav",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Étape {currentStep} sur {totalSteps}",
    "loadMore": "Charger plus",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segment équivaut à un SMS de 160 caractères. Cliquez sur l'icône pour en savoir plus sur les détails de tarification.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segment équivaut à un SMS de 160 caractères. Cliquez sur l'icône pour en savoir plus sur les détails de tarification.",
    "_email": "/ e-mail",
    "_ip": "/ IP",
    "_min": " / min",
    "_of_total": "% du total",
    "_please_add_a_payment_method_for": "! Veuillez ajouter un mode de paiement pour ",
    "_segment": " / segment",
    "_used": "% utilisé",
    "a_new_twilio_account_needs_to_be_created_before_we": "Un nouveau compte Twilio doit être créé avant que nous puissions débuter la refacturation",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Un sous-compte peut compter jusqu’à 10 objets personnalisés. Si la limite est dépassée, aucun objet personnalisé ne sera créé à partir de cet instantané.",
    "a_twilio_account_is_already_setup_for_this_location": "Un compte Twilio est déjà configuré pour cet emplacement",
    "accountName": "Nom du compte",
    "account_sid": "SID du compte :",
    "action": "Action",
    "actions": "Actions",
    "activate": "Activer",
    "active": "Actif",
    "active_listeners": "Auditeurs actifs",
    "active_subscriptions": "Abonnements Actifs",
    "ad_manager": " Gestionnaire de campagne",
    "add": "Ajouter",
    "addAction": "Ajouter une action",
    "add_eliza": "Ajoutez Eliza",
    "add_image": "Ajouter une image",
    "add_payment_method": "Ajouter un mode de paiement",
    "add_to_account": "Ajouter au Compte",
    "add_user_icon": "Ajouter une icône d'utilisateur",
    "add_your_first_email": "Ajoutez votre première adresse e-mail.",
    "address": "Adresse",
    "adwords_reporting": "Rapports Adwords",
    "affiliate_manager": "Gestionnaire d’affiliation",
    "agency": "Agence",
    "agency_logo": "logo de l'agence",
    "agency_settings": "Paramètres de l'agence",
    "agent_reporting": "Rapports d'agent",
    "ai_employee": " AI Employee ",
    "all": "Tout",
    "allow_subaccounts_to_cancel_their_subscription": "Autorisez les sous-comptes à résilier leur abonnement",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Permettez aux sous-comptes de passer à un forfait supérieur",
    "allowed_format": "Format autorisé :",
    "am": "Matin",
    "announcements_click_to_open_in_new_tab": "Annonces - cliquez pour ouvrir dans un nouvel onglet",
    "answers": "Réponses",
    "app_name": "Nom de l'application",
    "appointments": "Rendez-vous",
    "apps": " applications",
    "ask_ai": "Demander à l'AI",
    "ask_anything": "Posez n'importe quelle question…",
    "assigned_to_another_user": "(Attribué à un autre utilisateur)",
    "at_least_one_location_is_required": "Au moins un emplacement est requis",
    "attach_snapshot": "Joindre un instantané",
    "attribution_reporting": "Rapports d'attribution",
    "authorized_representative": "Représentant autorisé",
    "automation_type": "Type d'automatisation",
    "available_hours": "Heures disponibles",
    "avg_memoryinstance": "Mémoire moyenne/Instance",
    "back": "Retour",
    "base_url": "URL de base",
    "between_10_kb_and_5_mb": " Entre 10 Ko et 5 Mo",
    "birthday_sms": "SMS d'Anniversaire",
    "birthday_sms_with_image": "SMS d'anniversaire avec image",
    "blogging": "Blogs",
    "bounced": "Rejeté",
    "bulk_requests": "Requêtes groupées",
    "business_email": "E-mail d'entreprise",
    "business_hours_configurations": "Configurations des heures d'ouverture",
    "business_industry": "Secteur d'activité de l'entreprise",
    "business_information": "Informations sur l'entreprise",
    "business_logo": "logo de entreprise",
    "business_niche": "Secteur d'activité",
    "business_phone": "Téléphone professionnel",
    "business_physical_address": "Adresse physique de l'entreprise",
    "business_regions_of_operations": "Régions d'opérations de l'entreprise",
    "business_registration_id_type": "Type d'ID d'enregistrement de l'entreprise",
    "business_registration_number": "Numéro d'enregistrement de l'entreprise",
    "business_type": "Type d’entreprise",
    "business_website": "Site Web de l'entreprise",
    "busy": "Occupé",
    "buttons": {
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "deleteAll": "Tout supprimer",
      "view": "Afficher",
      "close": "Fermer",
      "previous": "Précédent",
      "next": "Suivant",
      "clear": "Effacer",
      "save": "Enregistrer",
      "edit": "Modifier",
      "delete": "Supprimer",
      "reset": "Réinitialiser",
      "refresh": "Actualiser",
      "nextLoading": "Suivant...",
      "copied": "Copié",
      "notNow": "Pas maintenant",
      "send": "Envoyer",
      "send1": "Envoyer",
      "download": "Télécharger",
      "sendNow": "Envoyer maintenant",
      "saved": "Enregistré",
      "back": "Retour",
      "update": "Mettre à jour",
      "add": "Ajouter",
      "submit": "Envoyer",
      "submitting": "Envoi",
      "done": "Terminé",
      "manageUsers": "Gérer les utilisateurs",
      "no": "Non",
      "yes": "Oui"
    },
    "calendar": "Calendrier",
    "calendar_groups": "Groupes de calendriers",
    "call": "Appel",
    "call_reporting": "Rapport d'appels",
    "call_tracking_is_disabled": "Le suivi des appels est désactivé",
    "call_voicemail_settings": "Paramètres d'appel et de messagerie vocale",
    "calls": " appels",
    "campaign": "Campagne",
    "campaigns": "Campagnes",
    "cancel": " Annuler ",
    "cancel_subscription": "Annuler abonnement",
    "cancelled": "Annulé",
    "certificates": "Certificats",
    "change": "Modification",
    "changed_data": "Données changées",
    "charge": " Frais",
    "charged_to_customer": "Facturé au client",
    "chat": "Chat",
    "chat_user": "Utilisateur de Chat",
    "chat_widget_icon": "Icône de Widget de chat",
    "chats_will_be_saved_for_2_days": "Les discussions seront sauvegardées pendant 2 jours",
    "check": "vérifier",
    "check_number_validity_before_first_sms_block_incom": "Vérifiez la validité du numéro avant le premier SMS, bloquez les appels indésirables entrants et recherchez les noms des appelants inconnus avant de répondre au téléphone. Des frais supplémentaires s'appliquent",
    "cinque_terre": "Cinque Terre",
    "city": "Ville",
    "clear_history": "Effacer l'historique",
    "click_here": "Cliquer ici",
    "click_on_create_new_snapshot_to_add_one": " Cliquez sur « Créer un nouvel instantané » pour en ajouter un.",
    "click_to_access_the_highlevel_welcome_course": "Cliquez pour accéder au cours de bienvenue HighLevel",
    "click_to_upgrade": "Cliquez pour Mettre à niveau",
    "clicked": "Cliqué",
    "clio": "Clio",
    "cloning": "Clonage",
    "close_debugger": "Fermer le débogueur",
    "close_whatsapp_template_creator": "Fermez le créateur de modèles WhatsApp",
    "collection": "Collection",
    "columns": "Colonnes",
    "coming_soon": "À venir",
    "company_email_": "E-mail de l'entreprise (",
    "complete_component_data": "Données complètes du composant",
    "complete_event_data": "Données complètes de l’événement",
    "complete_query_data": "Données complètes de requête",
    "completed": "Terminé",
    "complimentary_credits": "Crédits gratuits",
    "component": "Composant",
    "component_name": "Nom du Composant",
    "component_type": "Type de composant",
    "components": " composants",
    "condition": "Condition",
    "confirm": "CONFIRMER",
    "confirmation_message": "Message de confirmation",
    "confirmed": "Confirmé",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Contactez un administrateur certifié - cliquez pour ouvrir dans un nouvel onglet",
    "connect_with_us_start_live_chat": "Contactez-nous - démarrez le chat en direct",
    "connect_your_stripe_account": "connecter votre compte Stripe ",
    "connect_zoom": "Connecter Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Laissez le champ vide si vous choisissez d'utiliser le lieu de réunion préconfiguré",
    "contact": "Contact",
    "contact_support": "contacter l'assistance",
    "contact_us_call_highlevel_at_18887324197": "Contactez-nous - appelez HighLevel au +1(888)732-4197",
    "contacts": "Contacts",
    "content_ai": "Content AI",
    "controls": "Contrôles",
    "conversations": "Conversations",
    "copied": "copié",
    "cost_borne_by_you": " à votre charge.",
    "count": "nombre",
    "country": "Pays",
    "createNewFolder": "Créer un nouveau dossier",
    "credit_balance": "SOLDE DE CRÉDIT",
    "current_location_id": "ID de l'emplacement actuel",
    "custom": "Personnalisé",
    "custom_email": "E-mail personnalisé",
    "custom_niche": "Secteur personnalisé",
    "customer_notifications": "Notifications clients",
    "customize": "Personnaliser",
    "customize_chat_widget": "Personnalisez le widget de chat",
    "dashboard_stats": "Statistiques du tableau de bord",
    "data_keys": "Clés de Données",
    "date": "Date",
    "days": "Jours",
    "dedicated_ip": "Adresse IP dédiée ",
    "default": "Par défaut",
    "default_snapshots": "Instantanés par défaut",
    "delete": "Supprimer",
    "deleted": "supprimé",
    "delivered": "Envoyé",
    "description": "description",
    "details": "Informations",
    "disable_gbp_messaging_not_recommended": "désactiver la messagerie GBP (non recommandé)",
    "disable_tracking": "Désactiver le suivi",
    "disabled": "Désactivé",
    "dismiss": "Ignorer",
    "display_name": "Nom d'affichage",
    "do_not_delete": "ne pas supprimer",
    "do_something": "FAITES QUELQUE CHOSE",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Souhaitez-vous conserver le même ou en créer un nouveau ?",
    "download_application_icon": "Icône de téléchargement de la demande",
    "draft": "Brouillon",
    "dropdown_icon": "icône de liste déroulante",
    "duplicate": "Dupliquer",
    "duration": "Durée",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Ignorer l'étiquette Eliza (facultatif)",
    "eliza_is_required": "Eliza est requis.",
    "eliza_service": "Service Eliza",
    "email": "E-mail",
    "email_resell_settings": "Paramètres de revente par e-mail",
    "email_sending": "Envoi d'e-mails",
    "email_signature": "Signature d'e-mail",
    "enable": "Activer",
    "enable_beta": " Activez la Bêta",
    "enable_company_automation": "Activez l'automatisation de l'entreprise",
    "enable_disable_deprecated_features": "Activer/désactiver les fonctionnalités obsolètes.",
    "enable_gbp_call_tracking": " Activer le suivi des appels GBP ",
    "enable_gbp_messaging": "activer la messagerie GBP",
    "enable_signature_on_all_outgoing_messages": "Activer la signature sur tous les messages sortants",
    "enabled": "Activé",
    "notEnabled": "Non activé",
    "enter_a_logical_name": "Veuillez saisir un nom logique",
    "enter_the_exact_business_address_as_it_appears_in_": "Saisissez l’adresse exacte de l’entreprise telle qu’elle apparaît sur la fiche EIN.",
    "enter_the_exact_legal_business_name_as_registered_": "Saisissez la dénomination sociale exacte, telle qu'enregistrée avec l'EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Saisissez l’adresse exacte telle qu’elle apparaît sur la fiche EIN.",
    "enter_user_email": "Saisir l'adresse e-mail de l'utilisateur",
    "enter_user_phone_number": "Veuillez saisir le numéro de téléphone de l'utilisateur",
    "enter_your_business_registration_id_type": "Saisir le type d'ID d'enregistrement de l'entreprise",
    "enter_your_business_vertical_eg_travel": "Entrez votre secteur d'activité (par exemple : voyage)",
    "error_code": "Code d'erreur",
    "error_code_chart": "Tableau des codes d'erreur",
    "error_while_copying_api_key": "Erreur lors de la copie de la clé API !",
    "event": "Événement",
    "event_bus_listeners": "Auditeurs du bus d'événements",
    "events": " événements",
    "everything_in": "Tout dans ",
    "exact": "Exact",
    "execute_this_action_if_the_current_time_falls_in_t": "Exécutez cette action si l'heure actuelle se situe dans cette fenêtre, sinon attendez la fenêtre suivante pour exécuter cette action.",
    "extension": "Extension",
    "facebook": "Facebook",
    "facebook_ads": "Facebook Ads",
    "facebook_ads_reporting": "Rapports des publicités Facebook",
    "facebook_adsets": "AdSets Facebook",
    "facebook_campaigns": "Campagnes Facebook",
    "facebook_icon": "Icône Facebook",
    "facebook_page": "Page Facebook",
    "feature_image": "image en vedette",
    "features": "Fonctionnalités :",
    "feedback": "Commentaires : ",
    "file_path": "Chemin d'accès du fichier",
    "firestore_listeners": "Auditeurs Firestore",
    "forms": "Formulaires",
    "free": "Gratuit",
    "fri": "Ven",
    "friendly_business_name": "Nom non officiel de l'entreprise",
    "from": " de ",
    "funnels": "Entonnoirs",
    "gbp_call_tracking": "Suivi des appels GBP",
    "gbp_configuration": "Configuration GBP",
    "general": "Général",
    "general_information": "Informations générales",
    "generating_link_please_wait": "Génération du lien, veuillez patienter...",
    "google_ads_adgroups": "Groupes d'annonces Google Ads",
    "google_ads_ads": "Annonces Google Ads",
    "google_ads_campaigns": "Campagnes Google Ads",
    "google_ads_keywords": "Mots-clés Google Ads",
    "google_business_messaging": "Messagerie Google Business",
    "google_business_profile": "Fiche d'établissement Google",
    "google_my_business_icon": "Icône Google My Business",
    "hello": "Bonjour ",
    "here": "ici",
    "hhmm_a": "hh:mm A",
    "hi": "Bonjour ",
    "hide": "Masquer",
    "highlevel_events_click_to_open_in_new_tab": "Événements HighLevel - cliquez pour ouvrir dans un nouvel onglet",
    "how_can_i_help_you_today": "Comment puis-je vous aider aujourd'hui ?",
    "how_did_the_call_go": "Comment s'est déroulé l'appel ?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Comment puis-je calculer le coût de mes e-mails ? Cliquez sur l'icône pour en savoir plus",
    "how_does_it_work": "Comment ça marche",
    "htmlElement": "Élément HTML (TODO) :",
    "html_element_todo": "Élément HTML (TODO) : ",
    "id": "ID : ",
    "if": "Si",
    "if_activated_the_sender_information_will_be_automa": "Si activées, les informations sur l'expéditeur seront automatiquement ajoutées au premier message SMS de tous les messages en masse afin d'assurer la conformité et d'augmenter les taux de livraison.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Si activés, des liens de désabonnement seront insérés dans les pieds de page de vos e-mails, afin que les destinataires puissent se désinscrire sans marquer l'e-mail comme un spam.",
    "ignore_this_update": "Ignorez cette mise à jour",
    "image": "image",
    "image_turned_on": "Image activée",
    "imported_date": "Date d’importation",
    "imported_snapshots": "Instantanés importés",
    "inbound": "Entrant",
    "inbound_number": "Numéro entrant",
    "incoming_call_timeout": "Délai d'attente pour appels entrants",
    "instance_id": "ID d’Instance",
    "instances": "Instances : ",
    "instructions_mentioned_in_this_page": "instructions mentionnées sur cette page",
    "internal": "Interne",
    "intro_message": "Message d'Introduction",
    "intro_question": "Question d'Introduction",
    "invalid": "Non valide",
    "invoicing": "Facturation",
    "is_scheduled_for_deletion_on": " est prévue pour être supprimée le ",
    "job_position": "Rôle professionnel",
    "job_title": "Titre du poste",
    "join_our_facebook_group_click_to_open_in_new_tab": "Rejoignez notre groupe Facebook - cliquez pour ouvrir dans un nouvel onglet",
    "jpg_or_png": " JPG ou PNG ",
    "just_one_sec": "Juste une instant...",
    "key_sizes": "Dimensions des clés",
    "label": "intitulé",
    "labels": {
      "sortDirection": "Direction du tri",
      "tableStyling": "Style de tableau",
      "loadingMore": "Chargement...",
      "loading": "Chargement…",
      "filter": "Filtrer",
      "search": "Rechercher...",
      "sortBy": "Trier par",
      "perPage": "Par page",
      "date": "Date",
      "time": "Heure",
      "readMore": "Lire la suite",
      "day": "Jour",
      "slot": "Créneau",
      "template": "Modèle",
      "city": "Ville",
      "country": "Pays",
      "state": "État",
      "customerName": "Nom du client",
      "friendlyName": "Nom associé",
      "required": "* obligatoire",
      "addressLine1": "Ligne d'adresse 1",
      "addressLine2": "Ligne d'adresse 2",
      "postalCode": "Code postal",
      "searchUsers": "Rechercher des utilisateurs",
      "unknown": "Inconnu",
      "businessName": "Nom de l'entreprise"
    },
    "last_updated": "Dernière mise à jour",
    "launchpad_icon": "icône de la launchpad",
    "lead": "prospect",
    "leadconnector": "LeadConnector",
    "learn_how": "(Découvrez comment)",
    "legal_business_name": "Nom légal de l'entreprise",
    "limit_updated_from": " limite mise à jour de ",
    "listeners": " auditeurs",
    "loading_your_conversation_history": "Chargement de votre historique de conversation...",
    "location": "Lieu",
    "locations": " emplacements",
    "logical_name": "Nom Logique",
    "logical_name_is_required": "Nom logique obligatoire.",
    "logo": "Logo",
    "mailgun": "Mailgun",
    "making_calls": "Passer des appels",
    "manage_custom_email": "Gérer l'e-mail personnalisé",
    "marketing": "Marketing",
    "maximize": "Maximisez",
    "me_": "Moi (",
    "member_since": "Membre depuis",
    "membership": "Abonnement",
    "memory_analysis": "Analyse de la mémoire",
    "memory_api_not_available": "API de mémoire non disponible",
    "message": "Message",
    "minimize": "Réduire",
    "minimum_must_be": " Le minimum doit être ",
    "miscellaneous_charges": "Frais divers",
    "missed_call_text_back": "Renvoi vers le texte pour les appels manqués",
    "missed_text_back_call_message": "Message de rappel de communication manquée",
    "model": "Modèle",
    "module": "Module",
    "modules": " modules",
    "mon": "Lun",
    "month": "/mois",
    "monthly": "mensuel",
    "more_emails_in_thread": " e-mails de plus dans le fil",
    "mount_count": "Nombre de montages",
    "mount_time": "Temps de montage",
    "moved_to_calendar_settings": "Déplacé vers les paramètres du calendrier",
    "multiple_locations_using_same_twilio_account": "Plusieurs emplacements utilisant le même compte Twilio",
    "must_be_in_range_of_0": " Doit être compris dans la plage de 0 à",
    "must_be_less_than_monthly_plan_12": " Doit être inférieur au Plan Mensuel * 12 ",
    "my_business_is": "Mon entreprise est ",
    "my_snapshots": "Mes instantanés",
    "name": "Nom",
    "name_of_other_registration_id_type": "Nom de l'autre type d'ID d'enregistrement",
    "newFolder": "Nouveau dossier",
    "new_task_update": "Nouvelle mise à jour de la tâche !",
    "next": "Suivant",
    "no_answer": "Pas de réponse",
    "no_bigger_than_25mb": "pas plus de 2,5 Mo",
    "no_customer_selected": "Aucun client sélectionné",
    "no_error_data_found": "Aucune donnée d'erreur n'a été trouvée",
    "no_payment_method_available": "Aucun mode de paiement disponible",
    "no_provider_found": "Aucun fournisseur n'a été trouvé",
    "no_snapshots_found": "Aucun instantané n'a été trouvé !",
    "noshow": "Non honoré",
    "not": "Non",
    "not_now": "Pas maintenant",
    "not_saved": "Non enregistré",
    "notes": "Remarque",
    "notifications": "Notifications",
    "now": "Maintenant",
    "numbers_and": " nombre(s) et ",
    "objective": "Objectif :",
    "of": "de",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Tutoriels d’intégration vidéo - cliquez pour ouvrir dans un nouvel onglet",
    "online_listings": "Annonces en ligne",
    "only_assigned_data": "Données uniquement assignées",
    "open_performance_debugger": "Débogueur de performance ouvert",
    "opened": "Ouvert",
    "opportunities": "Opportunités",
    "options": {
      "ascending": "Ascendant",
      "descending": "Descendant",
      "none": "-- Aucun --"
    },
    "or_drag_and_drop": "ou glisser-déposer",
    "outbound": "Sortant",
    "pagination": "Pagination",
    "pass_body_content_here": " Transmettez le contenu du corps ici ",
    "password": "Mot de passe",
    "paused": "En pause",
    "payment_links": "Liens de paiement",
    "payment_methods": "Modes de paiement",
    "payment_refund": "Remboursement de paiement",
    "payment_settings_navigation": "Navigation des paramètres de paiement",
    "payments": "Paiements",
    "payments_integration": "Intégration des Paiements",
    "pending": "En attente",
    "per_page": "Par page",
    "percentage": "Pourcentage",
    "permanently_delete_this_email": "Supprimer définitivement cet e-mail",
    "personal_logo": "Logo personnel",
    "phone": "Téléphone",
    "phone_number_with_country_code": "Numéro de téléphone (avec code de pays)",
    "pick_a_niche": "Sélectionner un secteur",
    "pick_a_snapshot": "Sélectionnez un instantané",
    "pick_business_industry": "Sélectionner le secteur d'activité",
    "pick_business_registration_id_type": "Sélectionner le type d'ID d'enregistrement de l'entreprise",
    "pick_business_type": "Sélectionner le type d’entreprise",
    "pick_job_position": "Sélectionner un rôle",
    "plans_pricing": "Forfaits et tarifs",
    "please_enter_a_value_greater_than_20": "Veuillez entrer une valeur supérieure à 20.",
    "pm": "Après-midi",
    "points": "Points",
    "postalzip_code": "Code postal",
    "previous": "Précédent",
    "privacy_policy_url": "URL de la politique de confidentialité",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "L'URL de la politique de confidentialité sera affichée dans les informations de votre agent Google.",
    "process_your_payment": "Traiter votre paiement",
    "profile_picture": "Photo de profil",
    "profit": "Bénéfice",
    "prospecting": " Prospection ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Fournissez des instantanés pré-construits aux nouveaux comptes.",
    "queries": " requêtes",
    "questions": "questions",
    "quick_actions_icon": "Icône des actions rapides",
    "re_generate_key": "Régénérer la clé",
    "read_only": "Lecture seule",
    "receipts_settings": "Paramètres des reçus",
    "receiving_calls": "Recevoir des appels",
    "recent_events": "Événements récents",
    "recommended": "Recommandé",
    "recommended_resolution": "Résolution recommandée :",
    "reconnect": "Reconnecter ",
    "record_payment": "Enregistrer le paiement",
    "registered": " inscrit.",
    "renameFolder": "renommer un dossier",
    "replied": "Répondu",
    "representative_email": "Email du représentant",
    "resell_settings": " Paramètres de revente",
    "reset": "Réinitialiser",
    "resolve_now": "Résoudre maintenant",
    "resource_counts": "Nombre de ressources",
    "restore": "Restaurer",
    "results": "résultats",
    "reviews": "Avis",
    "rollover_unused_credits_to_next_month": "Reporter les crédits inutilisés au mois suivant",
    "row": " ligne",
    "runNow": "Exécutez maintenant",
    "sample_data": "(Données d’exemple)",
    "sat": "Sam",
    "save": "Sauvegarder",
    "save_missed_call_text_settings": "Enregistrer les paramètres de texte pour les appels manqués",
    "save_staging_url": "Enregistrer l'URL de l'environnement de test",
    "saved": "Enregistré",
    "saving": "Enregistrement…",
    "search": "Rechercher",
    "search_active_apps": "Recherche des applications actives...",
    "search_components": "Recherche de composants...",
    "search_customer": "Rechercher le client",
    "search_email": "Rechercher l’e-mail",
    "search_history": "Historique de recherche...",
    "search_icon": "icône de recherche",
    "search_listeners": "Recherche d'auditeurs...",
    "search_modules": "Modules de recherche...",
    "search_queries": "Requêtes de recherche...",
    "see_this_review_on_gbp": "Consulter cet avis sur GBP ",
    "segments": " segments",
    "select": "Sélectionner",
    "select_a_snapshot": "Sélectionner un instantané",
    "monetary": "MONÉTAIRE",
    "pleaseSelectAValue": "Veuillez sélectionner une valeur",
    "select_account": "Sélectionnez le compte",
    "select_an_account": "Sélectionnez un compte",
    "select_eliza_bypass_tag": "Sélectionnez Ignorer l'étiquette Eliza",
    "select_phone_number": "Sélectionner le numéro de téléphone",
    "select_send_to_eliza_tag": "Sélectionnez Envoyer à l'étiquette Eliza",
    "select_snapshot": " Sélectionnez l'instantané",
    "select_upto": "Sélectionnez jusqu'à ",
    "selected": "Sélectionné : ",
    "send": "Envoyer",
    "send_to_eliza_tag_optional": "Envoyer à l'étiquette Eliza (facultatif) ",
    "seo": " SEO ",
    "settings": "Paramètres",
    "setup_pending": "Configuration en attente",
    "share": "partager",
    "shared_snapshots": "Instantanés partagés",
    "shared_type": "Type partagé",
    "shipping_and_delivery": "Expédition et livraison",
    "shipping_origin": "Origine de l’expédition",
    "show": "Afficher",
    "showed": "Honoré",
    "signin_with_single_signon": "Se connecter avec l'authentification unique",
    "size": "Taille",
    "sms_message_sent_to_customer": "Message SMS envoyé au client",
    "snapshot_date": "Date de l'instantané",
    "snapshot_name": "Nom de l'instantané",
    "social_planner": "Planificateur de réseaux sociaux",
    "sortBy": "Trier par",
    "sortOptions": {
      "createdDate": "Date de création"
    },
    "source": "Source",
    "sources": "Sources :",
    "spent": "Dépensé",
    "staging_url_settings_for_db_event": "Paramètres de l'URL de staging (pour Db Event)",
    "state": "État",
    "state_prov_region_": "État / Province / Région *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "Californie",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "District de Columbia",
      "florida": "Floride",
      "georgia": "Géorgie",
      "hawaii": "Hawaï",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiane",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "Nouveau-Mexique",
      "new_york": "New York",
      "north_carolina": "Caroline du Nord",
      "north_dakota": "Dakota du Nord",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvanie",
      "rhode_island": "Rhode Island",
      "south_carolina": "Caroline du Sud",
      "south_dakota": "Dakota du Sud",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginie",
      "washington": "Washington",
      "west_virginia": "Virginie-Occidentale",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Aucun enregistrement trouvé",
      "noEntriesToShow": "Aucune entrée à afficher",
      "unsuccessful": "Échec",
      "pending": "En attente",
      "noUsersFound": "Aucun utilisateur trouvé"
    },
    "status": "Statut",
    "stop_delete_operation": "Arrêter l'opération de suppression",
    "street_address": "Adresse",
    "street_address_as_it_appears_in_the_ein_listing": "Adresse postale telle qu'elle figure dans la liste EIN.",
    "stripe_icon": "Icône Stripe",
    "stripe_integration": "Intégration Stripe",
    "stripe_secret_key": "Clé secrète Stripe",
    "subscriptions": "Abonnements",
    "sun": "Dim",
    "surveys": "Sondages",
    "suspend_subaccount_when_their_saas_subscription_fa": "Suspendre le sous-compte en cas d'échec de son abonnement SaaS",
    "switchAccount": "Changer de compte",
    "switch_off_sections_below_to_disable": "Désactivez les sections ci-dessous pour les désactiver",
    "tags": "mots-clés",
    "tax_settings": "Configuration des taxes",
    "team_management": "Gestion de groupe",
    "team_notifications": "Notifications d'équipe",
    "template": "Modèle",
    "terms_and_conditions": "Conditions générales d'utilisation",
    "test_mobile_no": "Test mobile N°",
    "text_messages": "SMS",
    "the_proposed_size_is_350px_180px": "La taille proposée est de 350 × 180 px.",
    "the_proposed_size_is_512512px": "La taille proposée est de 512 x 512 px",
    "the_selected_language_will_be_used_by_the_system_a": "La langue sélectionnée sera utilisée par le système comme valeur par défaut.",
    "the_welcome_message_automatically_appears_after_a_": "Le message de bienvenue s'affiche automatiquement après qu'un utilisateur commence une nouvelle conversation.",
    "these_are_margins_that_are_billed_to_your_clients_": "Il s'agit de marges qui sont facturées à vos clients en sus des coûts de ",
    "this_data_will_be_used_for_future_compliance_regis": "Ces données seront utilisées pour le futur enregistrement de conformité.",
    "this_is_my_twilio_use_same": "Voici mon Twilio, utilisez le même",
    "this_is_visible_to_both_agency_and_location": "Ceci est visible à la fois pour l'agence et l'emplacement",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Ce nom sera visible pour les prospects qui chattent avec votre entreprise",
    "this_setting_is_applicable_with_only_team_calendar": "Ce paramètre s'applique uniquement aux calendriers d'équipe.",
    "this_stripe_customer_is_already_connected_to_anoth": "Ce client Stripe est déjà connecté à un autre sous-compte.",
    "thu": "Jeu",
    "tiktok": "TikTok",
    "time_signed": " Heure de signature : ",
    "time_zone_": "Fuseau horaire *",
    "timestamp": "Horodatage",
    "title": "Titre",
    "to_resolve_this_problem_follow_the": "Pour résoudre ce problème, veuillez suivre les ",
    "token": "Jeton :",
    "total": "Total : ",
    "trigger_link": "Lien déclencheur",
    "triggers": "Déclencheurs",
    "tue": "Mar",
    "twilio": "Twilio",
    "twilio_setup_pending": "Configuration de Twilio en attente",
    "type": "Type",
    "type_campaign_objective": "Saisir l'objectif de la campagne",
    "type_message": "Saisissez un message",
    "unsavedChangesWarning": "Vos modifications ne seront pas enregistrées. Voulez-vous vraiment quitter ?",
    "unsaved_changes": "Modifications non enregistrées",
    "unsubscribed": "Désinscrit",
    "unsuccessful": "Échec",
    "update_business_profile_details": "Mettre à jour les détails du profil de l'entreprise",
    "update_is_inprogress_visit_integrations_page_to_fi": "La mise à jour est en cours, veuillez consulter la page des intégrations pour en savoir plus.",
    "update_url": "Mettre à jour l'URL",
    "updated_date": "Date de mise à jour",
    "updates": " mises à jour",
    "updating": "Mise à jour…",
    "upgrade_to_agency_pro": "passer à Agence Pro ",
    "upload": "Télécharger",
    "upload_a_file": "Téléverser un fichier",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Utilisez ceci pour l'intégration de Zapier et de l'API.",
    "user_email": "Adresse e-mail de l'utilisateur",
    "user_permissions": "Autorisations utilisateur",
    "user_role": "Rôle utilisateur",
    "user_type": "Type d'utilisateur",
    "valid": "Valide",
    "verification_status": "Statut de vérification",
    "verify": "Vérifier",
    "verify_email_using_otp": "Vérifier l’e-mail en via OTP",
    "view_less": " Afficher moins ",
    "visiblehidden": "Visible/Masqué",
    "visit_our_help_center_click_to_open_in_new_tab": "Visitez notre Centre d’aide - cliquez pour ouvrir dans un nouvel onglet",
    "voicemail": "Messagerie vocale",
    "wave_integration": "Intégration Wave",
    "we_have_found_some_errors_in_your_contact_fields_c": "Nous avons trouvé une ou plusieurs erreurs dans vos champs de contact. Cliquez sur le dossier pour les afficher et les résoudre.",
    "websites": "Sites web",
    "wed": "Mer",
    "welcome_message": "Message de bienvenue",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "Icône WhatsApp",
    "when": "Quand",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Quand les appels sélectionnés seront acheminés vers votre application mobile. (Pris en charge à la fois sur iOS et Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Quand ils seront sélectionnés, les appels seront acheminés vers votre application web.",
    "which_business_do_you_want_to_link_to_this_locatio": "Quelle entreprise souhaitez-vous associer à cet emplacement ?",
    "widget_code": "Code de widget",
    "will_give_you_about": " vous donnera environ",
    "wordpress": "WordPress",
    "wordpress_icon": "Icône WordPress",
    "workflows": "Flux de travail",
    "xero_integration": "Intégration Xero",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Vous devez réaliser quelques étapes simples pour supprimer cet emplacement",
    "you_are_not_authorized_to_perform_this_action_only": "Vous n'avez pas l'autorisation d'effectuer cette action. Seuls les administrateurs d'agence peuvent supprimer des sous-comptes.",
    "your_email_cost": "Le coût de vos e-mails",
    "your_facebook_page_has_been_integrated_however_the": "Votre page Facebook a été intégrée. Cependant, les fonctionnalités suivantes ne fonctionneront pas car LeadConnector ne dispose pas des autorisations requises : ",
    "your_outlook_connection_has_expired_please_disconn": "Votre connexion Outlook a expiré. Veuillez vous déconnecter et puis vous reconnecter à votre compte pour établir la connexion.",
    "zip_code": "Code postal",
    "zoom_connected_please_close_this_modal": "Connexion Zoom établie, veuillez fermer cette fenêtre modale",
    "hidden": "Masqué",
    "messageDetails": "Informations du message",
    "openOptions": "Ouvrir les options",
    "progress": "Progression",
    "close": "Fermer",
    "loading": "Chargement",
    "fullName": "Nom complet",
    "languages": "Langues",
    "phoneNumber": "Numéro de téléphone",
    "phoneNumberWithCountry": "Numéro de téléphone avec code de pays",
    "sendMessage": "message de téléchargement",
    "services": "Services",
    "servicesProvided": "Services fournis",
    "pleaseProvideAValid": "Veuillez offrir un numéro de téléphone valide.",
    "copy": "Copier",
    "editApiKey": "Modifier la clé API",
    "confirmPay": "Confirmer et payer",
    "contactUs": "Contact -nous",
    "decline": "Refuser",
    "deleteSubaccount": "Supprimer le sous-compte",
    "disabled1": "désactivé",
    "purchaseSummary": "Résumé des achats",
    "subscriptionPlan": "Forfait",
    "businessName": "Nom de l'entreprise sur WhatsApp entreprise",
    "chooseOne": "Choisissez un élément..",
    "stateProvRegion": "État/Province/Région",
    "streetAddress": "Adresse postale",
    "timeZone": "Fuseau horaire",
    "website": "Site Web",
    "zipPostalCode": "Code postal",
    "apiKey": "Clé API",
    "createdAt": "Créé à",
    "deleteAllLocationApi": "Supprimer toutes les clés API d'emplacement",
    "deleteApiKey": "Supprimer la clé API",
    "generatedBy": "Généré par",
    "lastUsedAt": "Dernière utilisation à",
    "pageNavigation": "Navigation de la page",
    "somethingWentWrong": "Une erreur s'est produite !",
    "clickHere": "Cliquez ici",
    "emailRebillingActive": "La refacturation des e-mails est active",
    "saasSubscriptionActive": "Abonnement SaaS actif",
    "scheduledForDeletion": "Programmé pour suppression",
    "twilioRebillingActive": "La refacturation Twilio est active",
    "iAcknowledgeThisIs": "Je reconnais qu'il s'agit d'un sous-compte valide et j'ai vérifié le cas d'utilisation de l'envoi de plus de {limit} {type} par jour",
    "iAcknowledgeThisIs1": "Je reconnais qu'il s'agit d'un sous-compte valide et j'ai vérifié le cas d'utilisation de l'envoi, d'où l'ajustement de la limite quotidienne des SMS",
    "emailSentByLocation": "E-mail envoyé par emplacement jusqu'à aujourd'hui.",
    "goToSmsLimit": "Accéder aux paramètres de limite SMS",
    "toIncreaseTheLimit": "Pour accroître la limite, contactez l'équipe d'assistance.",
    "newLimitOfLimit": "La nouvelle limite de {limit} n'est pas valide. Veuillez fournir une valeur comprise entre {min} et {max}",
    "typeLimitUpdatedSuccessfully": "La limite {type} a été mise à jour avec succès",
    "locationsCurrentLimitIs": "La limite actuelle de l'emplacement est {current}. Vous ne pouvez mettre à jour la limite qu'entre {min} et {max} d'ici. Pour toute mise à jour de la limite au-delà de {maxAllowed}, veuillez contacter l'équipe d'assistance.",
    "notNow": "Pas maintenant",
    "smsSentByLocation": "SMS envoyés par emplacement jusqu'à aujourd'hui.",
    "youHaveSuccessfullyUpdated": "Vous avez mis à jour la limite avec succès",
    "willAutoUnlockIn": "Déverrouillage automatique dans",
    "contactType": "Type de contact",
    "createdBy": "Créé par :",
    "createdOn": "Créé le :",
    "dateOfBirth": "Date de naissance",
    "emailAddress": "Adresse e-mail",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "twilioLookupMarkedThis": "Twilio Lookup a marqué ce numéro de téléphone comme non valide.",
    "twilioLookupStatedThis": "Twilio Lookup a indiqué qu'il s'agit d'un numéro {type}. Il ne recevra donc pas de SMS.",
    "accountSnapshot": "Instantané du compte",
    "auditLogs": "Journaux d'audit",
    "account": "Compte",
    "selectAccount": "Sélectionner un compte",
    "facebookUrl": "URL Facebook",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "URL Twitter",
    "youtubeUrl": "URL YouTube",
    "text": "Texte",
    "allTagsLinkedTo": "Tous les mots-clés liés aux contacts sélectionnés doivent être restaurés",
    "automation": "Automatisation",
    "bulkOperation": "Opération en masse",
    "campaign1": "Campagne",
    "created": "Créé",
    "dateTime": "Jour et heure",
    "description1": "Description",
    "drip": "Goutte-à-goutte",
    "edit": "Modifier",
    "someStatsAreNot": "Certaines statistiques ne sont pas disponibles si le fournisseur est SMTP. La précision des statistiques dépend du domaine du destinataire.",
    "error": "Erreur",
    "from1": "De",
    "immediately": "Immédiatement",
    "pause": "Mettre en pause",
    "processed": "Traité",
    "queued": "Mis en file d'attente",
    "restored": "Restauré",
    "resume": "Reprendre",
    "sent": "Envoyé",
    "scheduled": "Programmées",
    "success": "Succès",
    "templateName": "Nom du modèle",
    "total1": "Total",
    "totalAttempted": "Total des tentatives",
    "user": "Utilisateur",
    "viewDetails": "Afficher les informations",
    "workflow": "Flux de travail",
    "company": "Entreprise",
    "note": "Remarque",
    "perPage": "par page",
    "showing": "Affichage",
    "task": "Tâche",
    "tasks": "Tâches",
    "customFields": "Champs personnalisés",
    "dueDate": "Date d'échéance",
    "tryNow": "Essayez maintenant !",
    "archive": "Archiver",
    "markAsRead": "Marquer comme lu",
    "markAsUnread": "Marquer comme non lu",
    "youNeedToAdd": "Vous devez ajouter un calendrier pour commencer à programmer des rendez-vous.",
    "additionalNotes": "Notes supplémentaires",
    "appointmentStatus": "Statut du rendez-vous",
    "appointmentTitle": "Titre du rendez-vous",
    "contactName": "Nom du contact",
    "contactTimezoneUsedFor": "Fuseau horaire du contact (Utilisé pour le rappel)",
    "day": "Jour",
    "editAppointment": "Modifier le rendez-vous",
    "nameRequired": "Nom obligatoire",
    "slotRequired": "Créneau obligatoire",
    "teamMemberIsRequired": "Un membre de l'équipe est obligatoire.",
    "meetingLocation": "Lieu de la réunion",
    "pickTeamMember": "Choisir un membre de l'équipe",
    "phoneNumbers": "Numéros de téléphone",
    "roundRobin": "Répartition tournante",
    "selectCalendar": "Sélectionner un calendrier",
    "selectTeamMember": "Sélectionner un membre de l'équipe",
    "actionRequired": "Action requise",
    "scheduleAppointment": "Programmer un rendez-vous",
    "considerLeavingItBlank": "Laissez ce champ vide si vous choisissez d'utiliser le titre de rendez-vous préconfiguré",
    "assignedTo": "Assigné à",
    "download": "Télécharger",
    "loadingTranscription": "Chargement de la transcription...",
    "mute": "Désactiver le son",
    "playpause": "Lire/Mettre en pause",
    "playbackSpeed": "Vitesse de lecture",
    "remove": "Supprimé",
    "stop": "Arrêter",
    "timePlayedTotalTime": "Temps écoulé : Durée totale",
    "viewTranscript": "Afficher la transcription",
    "below": "sous",
    "calls1": "Appels",
    "liveChat": "Chat en direct",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Conversation par chat assignée",
    "youAreChoosingNot": "Vous choisissez de ne pas supprimer et fermer le sous-compte LC Phone. Cela signifie que son utilisation vous sera facturée, que l'emplacement soit facturé ou non.",
    "thingsAreJustGetting": "Ce n'est que le début ! Découvrons comment GHL peut vous aider à développer votre entreprise.\nEn attendant, vous pouvez conserver l'envoi de messages à votre guise.",
    "wohooConversationsAreFlowing": "Waouh ! Les conversations sont fluides maintenant !",
    "conversationBegan": "La conversation a débuté",
    "fetchOlderMessages": "Récupérer les anciens messages",
    "inboundDndHasBeen": "Fonction DND entrant activée pour ce contact",
    "internalComment": "Commentaire interne",
    "confirmByTyping": "Confirmez en entrant",
    "iConfirmToDisconnect": "Je confirme la déconnexion et la fermeture du compte LC Phone pour cet emplacement. Je sais que cela signifie que tous les numéros et toutes les campagnes A2P seront supprimés et ne pourront pas être récupérés.",
    "iConfirmThatI": "Je confirme que j'en ai parlé avec mon client et que j'ai obtenu son accord pour réaliser cette action",
    "connect": "Se connecter",
    "disputeThisReview": "Contester cet avis",
    "dndIsActiveFor": "Fonction DND active pour les appels",
    "off": "DÉSACTIVÉE",
    "done": "Terminé",
    "downloadFile": "Télécharger le fichier",
    "AddAccount": "+ Ajouter un compte",
    "attachFile": "Joindre un document",
    "clickHereToAdd": "Cliquez ici pour en ajouter un.",
    "customerName": "Nom du client",
    "customerPhone": "Téléphone du client",
    "orEnterAMessage": "Ou saisissez un message",
    "fromEmail": "Adresse e-mail de l'expéditeur",
    "fromName": "Nom de l'expéditeur",
    "youDontHaveAny": "Vous n'avez pas encore de modèles.",
    "requestPayment": "Demander le paiement",
    "schedule": "Programmer",
    "selectATemplate": "Sélectionner un modèle",
    "sendNow": "Envoyer maintenant",
    "smtpProvidersHasSome": "Les fournisseurs SMTP présentent certaines limitations. Cliquez ici pour en savoir plus.",
    "subject": "Objet",
    "useATemplateSnippet": "Utiliser un modèle (Snippet)",
    "deliveredtotalDelivered": "{delivered}/{total} envoyé",
    "countMoreEmailsIn": "{count} e-mails supplémentaires dans le fil",
    "primary": "(Principal)",
    "reply": "Réponse",
    "respond": "Répondre",
    "retry": "Réessayer",
    "to": "À :",
    "fbCommentReplyDm": "Réponse au commentaire FB - DM",
    "fbMessage": "Message FB",
    "theseAttachmentsMayNot": "Ces pièces jointes risquent de ne plus être prises en charge.",
    "urlCannotBeFound": "URL introuvable",
    "activity": "Activité",
    "filters": "Filtres",
    "goToPost": "Accédez à la publication",
    "inboundCall": "Appel entrant",
    "instagramDm": "Instagram DM",
    "internalChat": "Chat interne",
    "search2": "Rechercher...",
    "starred": "Marqué d'une étoile",
    "leftAVoicemail": "A laissé un message vocal",
    "manual": "Manuel",
    "mergeFields": "Fusion des champs",
    "addToDocuments": "Ajouter aux documents",
    "failedToAddAttachments": "Impossible d'ajouter des pièces jointes aux documents",
    "attachmentsAddedToDocuments": "Les pièces jointes ont bien été ajoutées aux documents",
    "newCommentOnPagename": "Nouveau commentaire sur la publication de {pageName}.",
    "outboundCall": "Appel sortant",
    "replyAsDm": "Répondre par DM",
    "replyingAsAPrivate": "Il n'est pas possible de répondre par message privé aux commentaires datant de plus de 7 jours.",
    "reportFeedbackForAi": "Signaler des commentaires pour l'IA",
    "storyMention": "Mention de la Story",
    "storyReply": "Réponse à la Story",
    "bulkRequest": "Demande en masse",
    "eventsAreCurrentlyCaptured": "Les événements ne sont actuellement capturés que pour l'adresse e-mail du contact.",
    "failed": "Échec",
    "gbpMessage": "Message GBP",
    "pageName": "Nom de la page",
    "unknown": "Inconnu",
    "typeAMessage": "Saisir un message",
    "new": "Nouveau",
    "newAppointmentBookedBy": "Nouveau rendez-vous réservé par",
    "customerNameRequired": "Le nom du client est obligatoire",
    "messageIsRequired": "Le message est obligatoire",
    "pickATemplateTo": "Sélectionnez un modèle à utiliser.",
    "newMessage": "Nouveau message",
    "newTask": "Nouvelle tâche",
    "toMakeACall": "Pour passer un appel, veuillez saisir un numéro de téléphone dans ce champ.",
    "primary1": "Principal",
    "provider": "Fournisseur",
    "refresh": "Actualiser",
    "resetPassword": "Réinitialiser le mot de passe",
    "thisReviewHasAlready": "Cet avis a déjà été publié sur {network}. Voulez-vous vraiment le republier ?",
    "seeThisReviewOn": "Consulter cet avis sur GBP",
    "reviewResponse": "Réponse à l'avis",
    "searchUsers": "Rechercher des utilisateurs",
    "sendEmail": "Envoyer un e-mail",
    "sending": "Envoi en cours…",
    "thisSubaccountHasPhonenumberco": "Ce sous-compte a {phoneNumberCount} numéros et {campaignsCount} campagne(s) A2P. La suppression de ce compte entraînera toujours des frais si le compte LC Phone System n'est pas déconnecté et fermé.",
    "thisSubaccountDoesNot": "Ce sous-compte ne possède aucun numéro et aucune campagne A2P. La suspension de ce compte n'occasionnera pas de frais, mais nous vous conseillons de déconnecter et de fermer le compte LC Phone.",
    "summary": "Résumé",
    "unassigned": "Non assigné",
    "viewSubmission": "Afficher l’envoi",
    "contactSupport": "Contacter l'assistance",
    "create": "Créer",
    "illDoThisLater": "Je le ferai plus tard",
    "enterBusinessName": "Saisir le nom de l'entreprise",
    "firstNameOfThe": "Prénom du propriétaire de l'entreprise",
    "mobileBusinessPhone": "Mobile / Téléphone professionnel",
    "iDontHaveA": "Je n'ai pas de site web",
    "clientName": "Nom du client",
    "letUsSetupYour": "Laissez-nous créer votre propre compte ou votre premier client.",
    "clientNameIsRequired": "Le nom du client est obligatoire",
    "pleaseEnterAValid": "Veuillez saisir une adresse e-mail valide",
    "emailAddressIsRequired": "Adresse e-mail obligatoire",
    "firstNameIsRequired": "Le prénom est obligatoire",
    "lastNameIsRequired": "Le nom est obligatoire",
    "phoneNumberIsRequired": "Le numéro de téléphone est obligatoire",
    "copyOfName": "Copie de {name}",
    "goToDashboard": "Accéder au tableau de bord",
    "permissionsNotEnabled": "Autorisations non activées !",
    "createAndSellCustom": "Générez et vendez des produits personnalisés grâce au dropshipping d'impression à la demande.",
    "viewApp": "Afficher l'application",
    "seamlessFulfillmentRealtimeShi": "Traitement fluide et tarifs d'expédition en temps réel pour vos boutiques d'e-commerce",
    "learnMore": "En savoir plus",
    "activateFormMapping": "Déclenchez le mappage des formulaires",
    "avatarName": "Nom d'avatar",
    "formFields": "Champs de formulaire",
    "formName": "Nom du formulaire",
    "mapFields": "Associer les champs",
    "update": "Mise à jour",
    "pauseSubaccount": "Suspendre le sous-compte",
    "pausing": "Mise en pause...",
    "subaccount": "sous-compte",
    "howItWorks": "Comment cela fonctionne",
    "uponCompletingThisAction": "Une fois cette action terminée, la demande de transfert sera envoyée à l'agence destinataire ({relNo}). Le sous-compte sera transféré immédiatement après son acceptation. Veuillez noter que cette action est irréversible.",
    "ejectSubaccount": "Éjecter le sous-compte",
    "newAgencyCreationMail": "Nouvel e-mail de création d'agence envoyé à l'utilisateur sélectionné. L'utilisateur peut créer une nouvelle agence en cliquant sur le lien envoyé dans l'e-mail.",
    "unableToTransferSubaccount": "Impossible de transférer le sous-compte dans cette agence.",
    "nominateAccountOwnerFor": "Désigner le titulaire du nouveau compte",
    "pleaseConfirmOwnershipWill": "Veuillez confirmer que la propriété sera transférée à",
    "scheduledDate": "Jour programmé",
    "thisDateIsBased": "Cette date est basée sur le fuseau horaire de cette entreprise, à savoir {timezone}",
    "campaignName": "Nom de la campagne",
    "copyCampaign": "Copier la campagne",
    "endTime": "Heure de fin",
    "event10xEmail4": "Événement : 10X Email 4 (distribution d'annonce) ",
    "10xEmail1Reviews": "10X Email 1 (Reviews)",
    "fromAddress": "Adresse de provenance",
    "leadValue": "Valeur de prospect",
    "option1": "Option 1",
    "option2": "Option 2",
    "option3": "Option 3",
    "preview": "Prévisualiser",
    "selectCampaign": "Sélectionner une campagne",
    "startTime": "Heure de début",
    "time": "Heure",
    "users": "Utilisateurs",
    "noRecordsFound": "Aucun enregistrement trouvé",
    "pageDetail": "Détail de la page",
    "selectAll": "Sélectionner tout",
    "submission": "Envoi",
    "addProduct": "Ajouter un produit",
    "visitors": "visiteurs",
    "By": " par",
    "conversions": "taux de conversion ",
    "liveReviews": "Avis actifs",
    "liveVisitors": "Visiteurs actifs",
    "pageVisits": "Visites de pages",
    "stream": "Flux",
    "addOneOrMore": "Ajoutez l'URL d'une ou de plusieurs pages ou copiez-la directement depuis votre navigateur web.",
    "WeWillAutomatically": " Nous suivrons automatiquement les visiteurs de votre site en temps réel. ",
    "connectYourLocationsFacebook": "Connectez le compte Facebook de votre emplacement",
    "connected": "Connecté\t!",
    "Contains": " contient ",
    "expression": "Expression",
    "facebookAccount": "Compte Facebook",
    "wowYouDontNeed": "Vous n'avez pas besoin de configurer quoi que ce soit ici, vous pouvez passer à autre chose.",
    "Regex": " regex ",
    "selectUrlMatchType": "Sélectionnez le type de correspondance d'URL",
    "Simple": " simple ",
    "LivePreview": " Prévisualisation en direct",
    "seconds": "secondes",
    "launch": "Lancer ",
    "decorativeVector1": "Vecteur décoratif 1",
    "showingFromToTo": "Affichage de {from} à {to} sur {total} entrées",
    "cloneProduct": "Cloner le produit",
    "connectFacebookInstagram": "Connectez Facebook et Instagram",
    "connectPage": "Connectez la page !",
    "everythingIn": "Tout dans",
    "agentChat25": "Chat avec un agent (temps d'attente d'environ 2 à 5 min)",
    "aiSupportChat": "Chat d'assistance par IA",
    "startChat": "Démarrer le chat",
    "locations1": "emplacements",
    "phone1": "téléphone",
    "slack": "Slack",
    "segments1": "segments",
    "areYouSureYou": "Voulez-vous vraiment supprimer ce dossier ?",
    "verified": "Vérifié",
    "highlevelPrice": "Prix HighLevel",
    "howDoesItWork": "Comment cela fonctionne-t-il ?",
    "payNow": "Payer maintenant",
    "priceMustBeMore": "Le prix doit être supérieur ou égal à celui de HighLevel",
    "saving2": "Enregistrement",
    "yourPrice": "Votre prix",
    "yourProfit": "Votre bénéfice",
    "youNeedToComplete": "Vous devez effectuer quelques étapes de conformité simples pour désactiver le mode SaaS pour cet emplacement",
    "youAreNotAuthorized": "Vous n'êtes pas autorisé à effectuer cette action. Seuls les administrateurs d'agence peuvent l'effectuer.",
    "disableSaasModeFor": "Désactiver le mode SaaS pour {name}",
    "companyBilling": "Facturation de l'entreprise",
    "bccEmailsCommaDelimited": "Adresses BCC (séparées par des virgules)",
    "unableToDeleteMailgun": "Impossible de supprimer le compte Mailgun, veuillez contacter l'assistance.",
    "forwardingAddress": "Adresse de redirection",
    "forwardingAddressesCommaDelimi": "Adresses de transfert (séparées par des virgules)",
    "amount": "Montant",
    "billingDate": "Date de facturation",
    "debugWalletTransactionsTotal": "DÉBOGAGE Transactions du portefeuille numérique, total : {count}",
    "detailedTransactions": "Transactions détaillées",
    "transactionsOnlyAfter26th": "Seules les transactions effectuées après le 26 avril 2022 sont répertoriées et disponibles à l'exportation",
    "someRecordsMayTake": "Certains enregistrements peuvent prendre 24 heures pour être mis à jour ici.",
    "totalBalance": "Solde total",
    "walletTransactions": "Transactions du portefeuille numérique",
    "walletTransactionsAllDate": "Transactions du portefeuille numérique - Tout - {date}",
    "enterMessage": "Entrez un message",
    "applyThisChangeTo": "Appliquez cette modification à tous les sous-comptes.",
    "characters": "Caractères",
    "iConfirmThatI1": "Je confirme que j'en ai parlé avec mon client et que j'ai obtenu son accord.",
    "iConfirmThatI2": "Je confirme que je veillerai à ce que tous les SMS envoyés à partir de ce compte soient conformes à la politique actuelle.",
    "theContentsOfThis": "Le contenu de ce message sera automatiquement ajouté au premier SMS envoyé dans les messages en masse.",
    "iConfirmThatSms": "Je confirme que les messages SMS seront uniquement envoyés aux contacts qui ont donné leur consentement pour recevoir des SMS.",
    "quickTip": "Conseil pratique",
    "messageWillBeAppended": "Un message sera ajouté au premier SMS d'une conversion s'il ne contient pas de demande de désinscription",
    "readMore": "Lire la suite",
    "noncompliantActivityMayLead": "Une activité non conforme peut entraîner la suspension des fonctionnalités SMS et voix de votre compte.",
    "typeConfirmBelowTo": "Saisissez « Enregistrer » ci-dessous pour continuer",
    "products": "Produits",
    "chooseCountry": "Sélectionnez le pays...",
    "email2": "Adresse e-mail*",
    "firstName1": "Prénom*",
    "lastName1": "Nom de famille*",
    "brandDetails": "Informations sur la marque",
    "brandName": "Nom de la marque*",
    "useEitherLegalName": "Utilisez le nom légal de l'organisation qui envoie les messages ou votre propre nom si cette marque n'est pas destinée à une organisation.",
    "businessIndustry": "Secteur d'activité*",
    "chooseVertical": "Sélectionner un secteur…",
    "mobileNumberForOtp": "Numéro de téléphone mobile pour la vérification OTP (avec indicatif de pays)*",
    "pleaseProvideAMobile": "Veuillez fournir un numéro de téléphone mobile auquel vous avez accès afin de pouvoir confirmer la vérification par mot de passe à usage unique. Seuls les numéros américains/canadiens seront acceptés. Vous ne devez pas utiliser un numéro de téléphone CPaaS tel que celui obtenu auprès de LeadConnector. Vous ne pouvez pas utiliser le même numéro de téléphone mobile pour enregistrer plus de 3 marques à propriétaire unique. Cette limite est gérée par TCR.",
    "increasedDeliveryRate": "Taux de livraison accru",
    "sendUpto3000Segments": "Envoyez jusqu'à 3 000 segments par jour",
    "businessDetails": "Informations sur l'entreprise",
    "thereWasSomeIssue": "Un problème est survenu lors de la soumission du profil.",
    "yourProfileSubmissionFailed": "La soumission de votre profil a échoué.",
    "endUserConsent": "Approbation de l'utilisateur final",
    "minLength40Characters": "Longueur minimum : 40 caractères. Longueur maximum : 2048 caractères.",
    "closeExamples": "Fermer les exemples",
    "sampleMessage1": "Message d'exemple #1*",
    "seeExamples": "Voir des exemples",
    "enterCampaignDetails": "Saisissez les informations sur la campagne",
    "youWillReceiveAn": "Vous recevrez un mot de passe à usage unique au numéro de téléphone portable que vous avez fourni pour la vérification TCR. Veuillez répondre Oui dans les 24 heures suivant la réception du SMS.",
    "brandNameIsRequired": "Le nom de la marque est obligatoire.",
    "businessVerticalIsRequired": "Le secteur de l'entreprise est obligatoire.",
    "mobileNumberIsRequired": "Le numéro de portable est obligatoire.",
    "hideDetail": "Masquer les détails",
    "showDetail": "Afficher les détails",
    "people": "personnes",
    "person": "personne",
    "after": "après",
    "before": "avant",
    "hour": "heure",
    "hours": "heures",
    "minute": "minute",
    "minutes": "minutes",
    "triggerLinksEmbeddedIn": "liens déclencheurs (intégrés dans le message) cliqués comme % des messages envoyés",
    "addNewEvent": "Ajouter un nouvel événement",
    "addTask": "Ajouter une tâche",
    "manualCall": "Appel manuel",
    "manualSms": "SMS manuel",
    "messenger": "Messenger",
    "wait": "Attendre",
    "webhook": "Webhook",
    "about": "À propos de",
    "accessRestricted": "Accès restreint",
    "addPartner": "Ajouter un partenaire",
    "addPartnerForm": "Ajouter un formulaire de partenaire",
    "affiliatePortal": "Portail des affiliés",
    "badges": "Badges",
    "aBriefBio": "Une brève biographie",
    "dashboard": "Tableau de bord",
    "experience": "Expérience",
    "industryServed": "Secteur desservi",
    "instagramAccount": "Comptes Instagram",
    "invoiceHistory": "Historique des factures",
    "englishGermanHindi": "Anglais, allemand, hindi",
    "linkToWebsite": "lien vers le site web",
    "linkedinAccount": "Compte LinkedIn",
    "locationId": "ID d'emplacement",
    "partnerName": "Nom du partenaire",
    "partnerStatus": "Statut du partenaire",
    "paymentDetails": "Détails du paiement",
    "paymentHistory": "Historique des paiements",
    "profilePhoto": "Photo de profil",
    "profilePhotoUrl": "URL de la photo de profil",
    "promoterReports": "Rapports des promoteurs",
    "searchPartner": "Partenaire de recherche",
    "twitterAccount": "Compte Twitter",
    "updatePartner": "Actualiser le partenaire",
    "updatePartnerForm": "Mettre à jour le formulaire de partenaire",
    "yearOfExperience": "année d'expérience",
    "youtubeAccount": "Compte YouTube",
    "serviceProvided": "Service fourni",
    "controlTheSubaccountSettings": "Gérer les paramètres du sous-compte",
    "generalInfo": "Informations générales",
    "okay": "OK",
    "proceed": "Poursuivre",
    "addCard": "Ajouter une carte",
    "makeThisCardPrimary": "Définir comme carte principale",
    "nameOnCard": "Nom sur la carte",
    "chargedToCustomer": "Facturé au client",
    "clientBillingPage": "Page de facturation client",
    "companyStripeIntegrationPage": "Page d'Intégration Stripe de l'Entreprise",
    "enableRebilling": "Activer la refacturation",
    "enabling": "Activation en cours...",
    "forMoreDetails": "pour plus d’informations.",
    "youreOnTheFreelancer": "Vous utilisez le forfait Indépendant, qui vous limite à une majoration de 1,05x.",
    "minimumAmountShouldBe": "La quantité minimum doit être comprise entre ${min} et ${max}",
    "beforeEnablingThisFeature1": "Avant d'activer cette fonctionnalité, veuillez connecter votre compte Stripe sur la",
    "planToSetYour": "prévoyez d’augmenter vos marges.",
    "rebillAmount": "Montant de la refacturation",
    "supportDoc": "document d'assistance",
    "10WillGiveYou": "10 $ vous donneront environ",
    "minimumMustBeBetween": "Le minimum doit être compris entre 0,0001 et 0,005.",
    "sorryYouCannotRebillAtTheMarkup": "Désolé ! Vous ne pouvez pas refacturer au taux majoré du forfait Indépendant, veuillez",
    "modifyingTheseSettingsWillChange": "La modification de ces paramètres affectera dorénavant le coût de l'abonnement pour vos clients.",
    "pleaseDoNotModifyThese": "Merci de ne pas les modifier si vous n'en connaissez pas les conséquences.",
    "theseSettingsWillApply": "Ces paramètres s'appliqueront à vos nouveaux clients à l'avenir.",
    "congratulationsYourDedicatedIp": "Félicitations ! La valeur de revente de votre adresse IP dédiée a été enregistrée avec succès.",
    "youHaveAgreedToProvide": "Vous avez accepté de fournir des IP dédiées directement à un sous-compte. L'agence prendra en charge les frais au nom du sous-compte.",
    "youHaveDiscontinuedToProvide": "Vous avez cessé de fournir des adresses IP dédiées directement à un sous-compte. L'agence ne couvrira plus les frais au nom du sous-compte.",
    "oopsSomethingWentWrongAndWeCouldnt": "Oups ! Une erreur s'est produite et nous n'avons pas pu enregistrer votre configuration de revente d'adresses IP dédiées. Veuillez réessayer plus tard.",
    "pleaseAgreeToTheTerms": "Veuillez accepter les conditions",
    "errorWhileFetchingDomains": "Erreur lors de la récupération des domaines",
    "sameStripeCustomerProfileCantBeMapped": "Un même profil client Stripe ne peut pas être mappé à plus d'un sous-compte.",
    "pleasePickADifferentStripeCustomer": "Veuillez choisir un autre profil client Stripe ou utiliser l'option « Partager un lien » afin que nous puissions créer un nouveau profil client Stripe pour ce sous-compte.",
    "clickNextToChooseAPlan": "Cliquez sur « Suivant » pour sélectionner un calendrier et créer un nouvel abonnement",
    "youDontHaveAnyActiveSubscriptions": "Vous n'avez pas d'abonnement actif.",
    "youCanEitherSelectAnExistingSubscription": "Vous pouvez soit sélectionner un abonnement existant, soit créer un nouvel abonnement à l'étape suivante.",
    "useCommasToSeparateMultipleEmails": "Utilisez des virgules pour séparer plusieurs e-mails.",
    "useCommasToSeparateMultiplePhoneNumbers": "Utilisez des virgules pour séparer plusieurs numéros de téléphone.",
    "noUserFoundInThisLocation": "Aucun utilisateur n'a été trouvé à cet emplacement",
    "noPhoneNumberAttached": "Aucun numéro de téléphone joint",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Veuillez utiliser le lien suivant pour joindre votre mode de paiement.",
    "allowDuplicateContact": "Autoriser la duplication des contacts",
    "allowDuplicateOpportunity": "Autoriser la duplication des opportunités",
    "mergeFacebookContactsByName": "Fusionner les contacts Facebook par nom",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Seuls les messages entrants de Facebook seront fusionnés s'ils correspondent au nom d'un contact existant. Les noms sont sensibles à la casse.",
    "disableContactTimezone": "Désactiver le fuseau horaire du contact",
    "markEmailsAsInvalidDueToHardBounce": "Marquer les e-mails comme non valides en raison d'un rejet définitif",
    "contactsEmailsWillBeMarkedAsInvalid": "Les e-mails du contact seront automatiquement marqués comme non valides s'ils sont rejetés définitivement. Les actions par e-mail dans les automatisations seront ignorées pour les contacts avec des adresses e-mail non valides.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Collecter des renseignements sur les numéros de téléphone inconnus",
    "makeSmsCompliantByAddingAnOptOutMessage": "Créer des SMS conformes en ajoutant un message de désinscription.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Si activé, le message de désinscription sera automatiquement ajouté au premier SMS envoyé via les messages en masse pour garantir la conformité et augmenter les taux de livraison.",
    "platformLanguage": "Langue de la plateforme",
    "outboundCommunicationLanguageForCustomValues": "Langue de communication sortante pour les valeurs personnalisées",
    "updateInformation": "Mettre à jour les informations",
    "upgradeToTheAgency": "Mettre à niveau vers Agence Pro",
    "yourCost": "Votre coût",
    "addACalendarTo": "Ajoutez un calendrier pour commencer à réserver des rendez-vous.",
    "addselectAContactTo": "Ajoutez/sélectionnez un contact pour programmer des rendez-vous",
    "appointmentSlotIsNot": "Le créneau de rendez-vous n'a pas encore été sélectionné",
    "loading1": "Chargement en cours…",
    "teamMemberIsRequired1": "Un membre de l'équipe est requis",
    "currentPlan": "Forfait actuel",
    "features1": "Fonctionnalités",
    "upgrade": "mettre à niveau",
    "viewLess": "Afficher moins",
    "viewMoreCount": "Afficher plus (+{count})",
    "cardNumber": "Numéro de carte",
    "expiryDate": "Date d'expiration",
    "paymentMethods": "Modes de Paiement",
    "primaryCard": "Carte principale",
    "removeCurrentCard": "Retirer la carte actuelle",
    "AddBalance": "+ Ajouter du solde",
    "complimentaryCredits": "Crédits gratuits :",
    "expiringOnDate": "Expire le {date}",
    "apiVersion": "Version d'API",
    "application": "Application",
    "ipAddress": "Adresse IP",
    "related": "Lié",
    "request": "Demande",
    "yourAccountIncludingAll": "Votre compte, y compris toutes les activités sortantes telles que les messages programmés et les e-mails, sera immédiatement interrompu.",
    "yourAccountIncludingAll1": "Votre compte, y compris toutes les activités sortantes telles que les messages programmés et les e-mails, sera immédiatement interrompu.",
    "nextBillingDateDate": "Prochaine date de facturation : {date}",
    "scheduledForCancellation": "Programmé pour annulation",
    "abandoned": "Abandonné",
    "add1": "Ajouter",
    "addOpportunity": "Ajouter une opportunité --",
    "addOpportunityName": "Ajouter le nom de l'opportunité",
    "Task": "+ Tâche",
    "bookupdateAppointment": "Réserver/mettre à jour le rendez-vous",
    "companyName": "Nom de l'entreprise",
    "areYouSureYou1": "Êtes-vous sûr de vouloir supprimer cette opportunité ?",
    "contactInfo": "Informations du contact",
    "editOpportunity": "Modifier l'opportunité --",
    "enterValue": "Saisissez une valeur",
    "goToContactDetail": "Accédez à la page des détails de contact",
    "leads": "Prospects",
    "lost": "Perdue",
    "nameIsRequired": "Le nom est obligatoire",
    "youreNotAllowedTo": "Vous n'êtes pas autorisé à modifier le nom d'un client ! Vérifiez votre autorisation auprès de l'administrateur de l'agence.",
    "open": "Ouvrir",
    "opportunity": "Prospect",
    "opportunityAlreadyExistsIn": "L'opportunité existe déjà dans ce pipeline",
    "opportunityInfo": "Informations sur l'opportunité",
    "opportunityName": "Nom du prospect",
    "opportunitySource": "Source de l'opportunité",
    "owner": "propriétaire",
    "pipeline": "Pipeline",
    "removeOwner": "Supprimer le propriétaire",
    "selectPipeline": "Sélectionner un pipeline",
    "selectStage": "Sélectionner une étape",
    "stage": "Étape",
    "countTasks": "{count} tâches",
    "won": "Remportée",
    "and": "et ",
    "addASubscription": "Ajoutez un abonnement",
    "noSaasPlanEnabled": "Aucun plan SaaS activé",
    "per": "par",
    "assignTo": "Attribuer à",
    "assignedTo1": "Attribué à :",
    "areYouSureYou2": "Voulez-vous vraiment supprimer cette tâche ?",
    "due": "Dû :",
    "dueDateIsRequired": "La date d'échéance est obligatoire",
    "dueIn": "Dûe dans",
    "dueToday": "Dû aujourd'hui",
    "late": "En retard",
    "notAssigned": "Non attribué",
    "taskDescription": "Description de la tâche",
    "taskTitle": "Titre de la tâche",
    "annually": "annuellement",
    "attachments": "Pièce(s) jointe(s)",
    "areYouSureYou3": "Voulez-vous vraiment supprimer cette demande en masse ?",
    "startImmediately": "Commencez immédiatement",
    "customers": "Clients",
    "tag": "Mot-clé",
    "pickType": "Sélectionnez le type",
    "whoShouldItRun": "À quoi l'appliquer ?",
    "addBulkRequest": "Ajouter une demande en masse",
    "editBulkRequest": "Modifier une demande en masse",
    "scheduledDateIsRequired": "La date programmée est obligatoire.",
    "newCampaignName": "Nouveau nom de campagne",
    "areYouSureYou4": "Voulez-vous vraiment supprimer cette campagne ?",
    "moveToFolder": "Déplacer vers un dossier",
    "pleaseRename": "veuillez renommer",
    "removeFromFolder": "Effacer du dossier",
    "photoPreview": "aperçu de photo",
    "pleaseWait": "Veuillez patienter.",
    "customValues": "Valeurs personnalisées",
    "whatActionShouldWe": "Quelle action devrions-nous effectuer ?",
    "entitynameName": "Nom de {entityName}",
    "useLcEmail": "Utilisez LC Email",
    "21Jun2018": "21 juin 2018",
    "930Am": "9 h 30",
    "Via": " via ",
    "createdTrackingNumbers": "Numéros de suivi créés",
    "iUnderstandImBuyingadding": "Je comprends que j'achète/ajoute {count} nouveaux numéros de téléphone.",
    "forwardCallsTo": "Renvoyer les appels vers",
    "numberName": "Nom du numéro",
    "numberPoolName": "Nom de la catégorie de numéro",
    "numberToSwap": "Numéro à permuter",
    "sameAsForwardingNumber": "Identique au numéro de renvoi",
    "callFromSource": "Appeler de [Source].",
    "callRecording": "Enregistrement d’appel",
    "84Complete": "84 % terminé",
    "thisCallWillBe": "Cet appel sera enregistré pour garantir la qualité.",
    "whisperMessage": "Message chuchoté",
    "allExceptDirect": "Tous sauf Direct",
    "allExceptDirectOrganic": "Tous sauf Direct et Organique",
    "allSearch": "Toutes les recherches",
    "allVisitorsRecommended": "Tous les visiteurs (recommandés)",
    "bing": "Bing",
    "direct": "Direct",
    "visitorsWithoutAReferring": "Visiteurs sans site web référent",
    "for": "pour",
    "google": "Google",
    "landingPageOrUrl": "Page de destination ou paramètre d'URL",
    "organic": "Organique",
    "paid": "Payé",
    "pickOneYouCan": "Sélectionnez-en un - vous pourrez toujours modifier cela ultérieurement.",
    "ppcSearch": "Recherche PPC",
    "visitorsFromGoogleBing": "Visiteurs provenant des recherches PPC de Google, Bing et Yahoo",
    "referringPage": "Page de renvoi",
    "visitorsFrom": "Visiteurs provenant de",
    "visitorsFromGoogleAds": "Visiteurs de Google Ads",
    "visitorsWhoAreReferred": "Les visiteurs qui sont référés depuis",
    "visitorsWhoLandOn": "Les visiteurs qui arrivent sur",
    "whichVisitorsDoYou": "Quels visiteurs souhaitez-vous suivre ?",
    "yahoo": "Yahoo",
    "17Complete": "17 % complété",
    "callTimeoutS": "Délai(s) d'attente pour les appels",
    "callWhisper": "Message d'appel chuchoté",
    "disableVoicemailDetect": "Désactiver la détection de messagerie vocale",
    "eventName": "Nom de l'événement",
    "timeoutSeconds": "Délai d'attente (secondes)",
    "editCall": "Modifier l'appel",
    "callWillPatchInstantly": "L'appel sera connecté instantanément, nous n'écouterons pas pour vérifier si la messagerie vocale du prospect a pris l'appel. Cela signifie que la campagne sera marquée comme répondue, même si le message vocal est pris.",
    "thisIsTheMessage": "Il s'agit du message que vous souhaitez faire entendre à la personne qui décroche le téléphone. Vous pouvez utiliser des variables personnalisées pour personnaliser ce message.",
    "pleaseCheckTheLinks": "Veuillez vérifier les liens où vous avez une valeur personnalisée. Il y a un %20 supplémentaire entre le {{ et custom_values.",
    "anErrorOcurredPlease": "Une erreur s'est produite, veuillez réessayer.",
    "pleaseInsertATo": "Veuillez insérer une adresse de destination.",
    "pickEmailTemplate": "Sélectionner un modèle d’e-mail",
    "sendTest": "Envoyer le test",
    "composeEmail": "Rédiger un e-mail",
    "composeEmailTemplate": "Composer un modèle d'e-mail",
    "toAddress": "À l'adresse",
    "addFileThroughUrl": "Ajouter un document via URL",
    "appCharacters": "Caractères de l'application :",
    "approximateCost": "Coût estimé :",
    "estimatedCostForUs": "Coût estimé pour les SMS aux États-Unis uniquement.",
    "mobilePhoneNumber": "Numéro de téléphone portable",
    "numSegments": "Nb de segments",
    "pickMessageTemplate": "Sélectionner un modèle de message",
    "pleaseProvideAPhone": "Veuillez indiquer un numéro de téléphone auquel envoyer le test.",
    "composeEventtype": "Composer {eventType}",
    "composeEventtypeTextTemplate": "Composer un modèle de texte pour {eventType}",
    "unsupportedSmsContentType": "Type de contenu SMS non pris en charge {fileType}",
    "countOfTheProvided": "{count} des pièces jointes URL fournies {plural} pas une image. Cela pourrait entraîner des échecs au sein de Twilio. Souhaitez-vous enregistrer quand même ?",
    "dropFileHereOr": "Déposez le document ici ou cliquez pour télécharger",
    "ifYouHaveAdditional": "Si vous avez d'autres questions, veuillez consulter la FAQ sur la messagerie vocale dans la section d'aide.",
    "editVoicemail": "Modifier la messagerie vocale",
    "selectAMp3Or": "Sélectionnez un fichier mp3 ou wav, nous ne prenons pas en charge les autres formats.",
    "voicemailFile": "Fichier de messagerie vocale",
    "warningVoicemailDropsAre": "Avertissement : le dépôt de messages vocaux est le système le plus fiable et fonctionne dans environ 70 % des cas.",
    "youNeedToPick": "Vous devez sélectionner au moins un jour",
    "editWait": "Modifier l'attente",
    "url": "URL",
    "customTime": "Temps personnalisé",
    "executeThisActionIf": "Exécutez cette action si l'heure actuelle se situe dans cette fenêtre ; si l'heure actuelle est en dehors de cette fenêtre, ignorez cette étape et passez à l'action suivante.",
    "pickDays": "Sélectionnez des jours",
    "pickTime": "Sélectionner l'heure",
    "noRecordsFound1": "Aucun enregistrement trouvé.",
    "formAnalyze": "Analyse de formulaire",
    "totalSubmission": "Nombre total d'envois",
    "forgotPassword": "Mot de passe oublié ?",
    "orContinueWith": "Ou continuez avec",
    "signIn": "Se connecter",
    "signIntoYourAccount": "Connectez-vous à votre compte",
    "thePasswordYouPicked": "Le mot de passe que vous avez choisi",
    "yourEmailAddress": "Votre adresse e-mail",
    "newEmailFrom": "Nouvel e-mail de",
    "newMessageFrom": "Nouveau message de",
    "hasLeftANew": "a laissé un nouvel avis.",
    "repliedToTheReview": "a répondu à l'avis.",
    "loaded": "Chargé",
    "snapshot": "Instantané",
    "appointment": "Rendez-vous",
    "appointmentDueInMinutes": "Rendez-vous prévu dans {minutes} minutes pour {contactName}",
    "appointmentReminder": "Rappel de rendez-vous",
    "completedCount": "Terminé : {count}",
    "conversation": "Conversation",
    "facebookReview": "Avis Facebook",
    "failedCount": "Échec : {count}",
    "googleReview": "Avis Google",
    "internalChatMessage": "Message de chat interne",
    "usernameMentionedYouIn": "{userName} vous a mentionné dans une conversation avec {contactName}",
    "newAppointmentAssigned": "Nouveau rendez-vous assigné",
    "aNewAppointmentWith": "Un nouveau rendez-vous avec {contactName} vous a été attribué.",
    "newAppointmentBooked": "Nouveau rendez-vous réservé",
    "youHaveNewAppointment": "Vous avez un nouveau rendez-vous réservé avec {contactName}",
    "newCall": "Nouvel appel",
    "aNewChatWith": "Un nouveau chat avec {contactName} vous a été attribué.",
    "newEmail": "Nouvel e-mail",
    "newMention": "Nouvelle Mention",
    "newReviewReceivedFrom": "Nouvel avis reçu de {contactName}",
    "aNewTypeIs": "Un nouveau {type} a été reçu de {contactName}",
    "notification": {
      "noRecentActivity": "Aucune activité récente"
    },
    "subAccount": "Sous-compte",
    "subaccount1": "Sous-compte :",
    "titleOnDateAt": "{title} le {date} à {time} pour {contactName}",
    "titleDueInDuetime": "{title} dû dans {dueTime} {unitOfTime} pour {contactName}",
    "taskReminder": "Rappel de tâche",
    "youHaveCountTasks": "Vous avez {count} tâches dues aujourd'hui.",
    "youHaveCountTasks1": "Vous avez {count} tâches en retard jusqu'à maintenant",
    "droppedVoicemailTo": "Message vocal déposé à",
    "errorWhileCloningProduct": "Erreur lors du clonage du produit !",
    "productName": "Nom du produit",
    "selectLocations": "Sélectionnez les emplacements",
    "selectUptoMaxselectablelocatio": "Sélectionnez jusqu'à {maxSelectableLocations} emplacements",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "et {count} de plus",
    "emails": "Adresses e-mail",
    "accountNotification": "Notification de compte",
    "customerCare": "Service client",
    "deliveryNotification": "Notification de livraison",
    "fraudAlertMessaging": "Messages d'alerte à la fraude",
    "higherEducation": "Enseignement supérieur",
    "lowVolumeMixedRecommended": "Hybride à faible volume (recommandé)",
    "mixed": "Hybride",
    "pollingAndVoting": "Sondages et votes",
    "publicServiceAnnouncement": "Message d'intérêt public",
    "securityAlert": "Alerte de sécurité",
    "mixedRecommended": "Hybride (recommandé)",
    "australiaCompanyNumberFrom": "Australie : Numéro d'entreprise de l'ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canada : Numéro d'entreprise canadien (NEC)",
    "indiaCorporateIdentityNumber": "Inde : Numéro d'identification de l'entreprise",
    "greatBritainCompanyNumber": "Grande-Bretagne : Numéro d'entreprise",
    "usaEmployerIdentificationNumbe": "USA: Numéro d'identification de l'employeur (EIN)",
    "other": "Autre",
    "israelRegistrationNumber": "Israël : Numéro d’enregistrement",
    "estoniaVatNumber": "Estonie : Numéro de TVA",
    "cooperative": "Coopérative",
    "corporation": "Entreprise",
    "limitedLiabilityCompanyOr": "Société à responsabilité limitée ou entreprise individuelle",
    "nonprofitCorporation": "Entreprise à but non lucratif",
    "partnership": "Partenariat",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Directeur",
    "generalCounsel": "Directeur juridique",
    "onlineTrainingEducation": "Formation en ligne et éducation",
    "financialServices": "Services financiers",
    "fitnessLifestyle": "Fitness et style de vie",
    "healthMedical": "Santé et médecine",
    "homeServices": "Services à domicile",
    "legalServices": "Services Juridiques",
    "marketingAdvertising": "Marketing et publicité",
    "others": "Autres",
    "realEstate": "Immobilier",
    "restaurants": "Restaurants",
    "retailEcommerce": "Commerce de détail et e-commerce",
    "yourInformationHasBeen": "Vos informations ont bien été soumises.",
    "somethingWentWrong1": "Une erreur s'est produite",
    "newPassword": "Nouveau mot de passe",
    "proceedToLogin": "Passer à la connexion",
    "anyTime": "à tout moment.",
    "callUsHighlevelSupport": "Appelez l'assistance HighLevel au",
    "troubleLoggingIn": "Problèmes de connexion ?",
    "sendSecurityCode": "Envoyer le code de sécurité",
    "sendCodeToEmail": "Envoyez le code par e-mail",
    "verifySecurityCode": "Vérifier le code de sécurité",
    "privacyPolicy": "Politique de confidentialité",
    "businessProfile": "Profil d'entreprise",
    "reserveWithGoogleIntegration": "Réserver avec l'intégration Google",
    "friendlyName": "Nom associé",
    "updateCallerId": "Actualiser l'ID d'appelant",
    "internationalFormat": "Format International",
    "localFormat": "Format local",
    "poolNumbers": "Numéros de catégorie",
    "swappingNumbers": "Numéros de permutation",
    "selectField": "Sélectionner un champ",
    "surveyAnalyze": "Analyse de sondage",
    "locationIsRequired": "L'emplacement est obligatoire.",
    "newSurveyName": "Nouveau nom de sondage",
    "copySurvey": "Copier le sondage",
    "primaryCalendar": "Calendrier principal",
    "cloneEntityname": "Dupliquer {entityName}",
    "youHaveSuccessfullySubmitted": "Vous avez soumis les fichiers avec succès",
    "addCustomValue": "Ajouter une valeur personnalisée",
    "value": "Valeur",
    "youHaveSuccessfullyDeleted": "Vous avez supprimé le pack avec succès.",
    "bundleDeletedSuccessfully": "Pack supprimé avec succès",
    "thereIsAnIssue": "Il y a un problème avec l'un de vos documents justificatifs. Veuillez consulter les documents justificatifs et les motifs de rejet.",
    "connect1": "Connectez-vous !",
    "itSeemsEitherThe": "Il semble que la connexion à Google soit interrompue ou qu'elle ne soit pas établie à l'emplacement actuel. Veuillez vérifier les paramètres d'intégration et réintégrer si la connexion existe déjà.",
    "selectPage": "Sélectionner une page",
    "somethingWentWrongPlease": "Une erreur s'est produite. Veuillez réessayer.",
    "accept": "Accepter",
    "moreThan1Phone": "Plusieurs numéros de téléphone autorisés",
    "byContinuingToUse": "En continuant à utiliser la plateforme HighLevel, vous acceptez les {termsLink} et la {privacyLink} mises à jour.",
    "byContinuingToUse1": "En continuant à utiliser la plateforme HighLevel, vous acceptez les nouvelles",
    "termsOfService": "Conditions d'utilisation",
    "weHaveUpdatedOur": "Nous avons mis à jour nos conditions d'utilisation et notre politique de confidentialité : n'hésitez pas à les consulter !",
    "newTriggerName": "Nouveau nom de déclencheur",
    "triggerName": "Nom de déclencheur",
    "disableDndForSpecific": "Désactivez le DND pour des canaux spécifiques",
    "selectAdAccount": "Sélectionner un compte publicitaire",
    "selectAppointmentStatus": "Sélectionnez le statut du rendez-vous",
    "below1": "ci-dessous.",
    "Required": "* obligatoire",
    "whenYouGetA": "Lorsque vous recevez un nouvel avis, nous le publierons automatiquement sur votre page Facebook. La meilleure pratique consiste à ne pas publier plus de trois avis par jour sur votre compte.",
    "skip": "Ignorer",
    "copyShareLink": "Copier le lien de partage",
    "agencyRelationshipNumbers": "Numéros de relation de l'agence",
    "alteast1AgencyRelationship": "Au moins un numéro de relation avec l'agence est requis.",
    "alteast1SubaccountId": "Au moins un ID de sous-compte est requis.",
    "somethingWentWrongWhile": "Une erreur s'est produite lors de l'enregistrement. Veuillez réessayer plus tard !",
    "5PerPage": "5 par page",
    "10PerPage": "10 par page",
    "amountMustGreaterOr": "Le montant doit être supérieur ou égal à 1 dollar AUD.",
    "regions": {
      "africa": "Afrique",
      "asia_pacific": "Asie / Pacifique",
      "europe": "Europe",
      "latin_america": "Amérique latine",
      "usa_and_canada": "États-Unis et Canada",
      "asia": "Asie",
      "latinAmerica": "Amérique latine",
      "usaCanada": "États-Unis et Canada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Aucune entrée à afficher",
    "clear": "Effacer",
    "filter": "Filtrer",
    "test": "Tester",
    "createNewTwilioSubAccountText": "Vous devrez créer un nouveau compte Twilio, mettre à jour les identifiants de ce compte dans les paramètres Twilio et déplacer les numéros de téléphone avant d'activer la refacturation.",
    "viewing": "Affichage",
    "makeSmsCompliantByAddingASenderInformation": "Créez des SMS conformes en ajoutant les informations de l'expéditeur.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Rendre l'e-mail conforme en y ajoutant un lien de désinscription",
    "enableMissedCallTextBack": "Activer le renvoi vers le texte pour les appels manqués",
    "productInventory": "Inventaire des produits",
    "viewProductVariants": "Afficher les variantes du produit",
    "smtpSettings": "Paramètres SMTP",
    "locationOPMTrafficStatis": "Statistiques de trafic OPM de l'établissement",
    "locationGPMTrafficStatis": "Statistiques de trafic GPM de l'établissement",
    "blacklistMonitorReports": "Rapport de surveillance de la liste noire",
    "twoFactorAuthentication": "Authentification à deux facteurs (2FA)",
    "recent": "récent",
    "noPermission": "Vous n'avez pas l'autorisation de gérer les modèles pour ce produit. Redirection vers le tableau de bord.",
    "tasksNowHave": "Les tâches ont désormais",
    "option": "Option",
    "facebookAdsReporting": "Rapports des publicités Facebook",
    "googleAdsReporting": "Rapports Google Ads",
    "adsDatePicker": "Sélecteur de date pour les annonces",
    "feedbackSubmitBtn": "Bouton d'envoi de commentaires",
    "ifYouThinkMistakePleaseContact": "Si vous pensez qu'il s'agit d'une erreur, veuillez contacter",
    "forResolution": "pour trouver une solution.",
    "live": "En direct",
    "payouts": "Paiements",
    "greatChoice": "Excellent choix !",
    "toNavigate": "naviguer",
    "teams": "Équipes",
    "role": "Rôle",
    "searchAccounts": "Rechercher des comptes",
    "searchByNameEmailPhone": "Rechercher par nom, e-mail ou téléphone",
    "addEmployee": "Ajouter un employé",
    "removeFromLocation": "Supprimer de l'emplacement",
    "knowMore": "En savoir plus",
    "usingNumberPool": "Utilisation de la catégorie de numéros",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Évaluateur",
    "cancel1": "Annuler",
    "delete1": "Supprimer",
    "call1": "Appel",
    "message1": "Message",
    "name1": "Nom",
    "voicemail1": "Messagerie vocale",
    "title1": "Titre",
    "choose_one": "Choisissez un élément",
    "select_page": "Sélectionner la page",
    "confirm1": "Confirmer",
    "conversations1": "Conversations",
    "copied1": "Copié",
    "timeOfDay": {
      "am": "Matin",
      "pm": "Après-midi"
    },
    "back1": "Retour",
    "details1": "Informations",
    "month1": "/mois",
    "select1": "Sélectionner",
    "share1": "Partager",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Rapport de surveillance de la liste noire",
      "domainPurchase": "Achat de domaine"
    },
    "confirmDelete": "Voulez-vous vraiment supprimer {name} ?",
    "clicked1": "Cliqué",
    "delivered1": "Envoyé",
    "invalid1": "Non valide",
    "open_options": "Ouvrir les options",
    "_add_account": "Ajouter un compte",
    "setTimezoneWarning": "Veuillez définir le fuseau horaire de votre emplacement pour obtenir les créneaux horaires disponibles appropriés.",
    "save1": "Enregistrer",
    "action1": "Action",
    "actions1": "Actions",
    "all1": "Tout",
    "previous1": "Précédent",
    "results1": "Résultats",
    "next1": "Suivant",
    "payments1": "Paiements",
    "settings1": "Paramètres",
    "total_js_heap": "Total du tas JS",
    "table": {
      "pagination": {
        "previous": "Précédent",
        "next": "Suivant"
      },
      "rowsSelected": "{count} lignes sélectionnées",
      "cantRearrange": "{type} ne peut pas être réorganisé"
    },
    "ivrCall": "Appel IVR",
    "sms": "SMS",
    "username": "Nom d'utilisateur",
    "stay": "Rester",
    "placeholders": {
      "selectCountry": "Sélectionnez votre pays",
      "nameOfBusiness": "Nom de l'entreprise",
      "line1": "Ligne 1",
      "line2": "Ligne 2",
      "enterState": "Saisissez l'État",
      "enterCity": "Saisissez la ville",
      "enterPostalCode": "Saisissez le code postal",
      "chooseCountry": "Sélectionnez le pays..."
    },
    "addressLine1": "Ligne d'adresse 1",
    "addressLine2": "Adresse, ligne 2",
    "postalCode": "Code postal",
    "nameOfBusiness": "Nom de l'entreprise",
    "dispute_this_review": "Contester cet avis",
    "story_mention": "Mention de la Story",
    "story_reply": "Réponse à la Story",
    "no": "Non",
    "yes": "Oui",
    "annual": "annuel",
    "plan": "Plan",
    "errors": {
      "somethingWrong": "Une erreur s'est produite"
    },
    "zero": "0",
    "perMonth": "par mois",
    "emailCheckLinks": "Veuillez vérifier les liens où vous avez une valeur personnalisée. Il y a un %20 supplémentaire entre le {{ et custom_values.",
    "fileSizeTooLarge": "La taille du fichier est supérieure à 5 Mo",
    "fileSizeTooLargeDescription": "Le document que vous essayez de télécharger est trop grand. Veuillez essayer avec un fichier de plus petite taille",
    "minMaxLength40Characters2048Characters": "Longueur minimum : 40 caractères. Longueur maximum : 2048 caractères.",
    "sampleMessage2": "Message d'exemple #2*",
    "pleaseSelectWorkflow": "Veuillez sélectionner un flux de travail",
    "childrens": "Enfants",
    "brandAndCampaignRegistration": "L'enregistrement d'une marque et d'une campagne est facturé 20,95 $. Des frais de campagne supplémentaires pouvant aller jusqu'à 2,25 $ par mois seront appliqués conformément aux règles TCR.",
    "einRequiredForRegistration": "EIN requis pour l'enregistrement",
    "changed_props": "Propriétés modifiées",
    "total_memory": "Mémoire totale",
    "total_store_size": "Taille totale du magasin",
    "total_watchers": "Total de spectateurs",
    "update_count": "Nombre de mises à jour"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Actions en masse",
      "clickHere": "Cliquez ici pour consulter la liste des actions en masse.",
      "mergedMessage": "Cette page a été fusionnée avec la liste des actions en masse.",
      "title": "Demandes de contact"
    }
  },
  "conversations": {
    "noConversationsFound": "Aucune conversation {status} trouvée",
    "create_new": "Créez un nouveau message​",
    "validations": {
      "minCharsRequired": "Minimum 3 caractères requis",
      "twoMoreCharsRequired": "2 caractères supplémentaires requis",
      "oneMoreCharRequired": "1 caractère supplémentaire requis"
    },
    "sortLabels": {
      "latestAllMessages": "Plus récents en premier (tous les messages)",
      "oldestAllMessages": "Plus anciens en premier (tous les messages)",
      "latestManualMessages": "Plus récents en premier (messages manuels)",
      "oldestManualMessages": "Plus anciens en premier (messages manuels)",
      "latestAll": "Les plus récents-Tous",
      "oldestAll": "Les plus anciens-Tous",
      "latestManual": "Les plus récents-Manuel",
      "oldestManual": "Les plus anciens-Manuel",
      "highToLow": "{name} (du plus élevé au plus faible)",
      "manualMessagesTooltip": "L'option de tri s'appliquera aux messages envoyés après le 18 mai 2023."
    },
    "deleteConversation": {
      "title": "Confirmation",
      "confirmWithName": "Voulez-vous vraiment supprimer définitivement la conversation avec {name} ? Cette action est irréversible.",
      "confirmWithoutName": "Voulez-vous vraiment supprimer cette conversation définitivement ? Cette action est irréversible."
    },
    "makeCall": {
      "enterPhoneNumber": "Pour passer un appel, veuillez saisir un numéro de téléphone dans ce champ.",
      "invalidPhoneNumber": "Twilio Lookup a marqué ce numéro de téléphone comme non valide."
    },
    "actions": {
      "markAsStarred": "Marquer comme important",
      "unarchive": "Désarchiver",
      "unmarkAsStarred": "Supprimer le marquage Étoilé"
    },
    "send": {
      "perMonthPerIp": "/mois/IP",
      "perIp": "/ IP",
      "replyingTo": "En réponse à",
      "requestClientsPaymentDetails": "Demander les informations de paiement des clients",
      "saasModeCreditCardRequired": "Le mode SaaS requiert l'enregistrement d'une carte de crédit pour le client.",
      "please": "Veuillez",
      "firstBeforeEnablingSaaS": "d'abord avant d'activer le mode SaaS.",
      "shareALink": "Partagez un lien",
      "shareLinkInstructions": "Partagez un lien avec votre client pour collecter ses informations de paiement.",
      "requestViaEmail": "Demande par e-mail",
      "twilioRebillingDescription": "Refacturez les coûts de Twilio ({twilioCopy}) à vos clients et incluez une majoration",
      "seeHow": "Découvrez comment",
      "phoneRebillingCardInfoRequired": "La refacturation par téléphone nécessite que les informations de carte soient enregistrées pour le client.",
      "clientsCompanyBillingPage": "page de facturation de l'entreprise du client",
      "ifYouPayForTwilioKeepUsing": "Si vous payez pour Twilio, continuez à utiliser le même compte Twilio",
      "ifClientPaysForTwilioCreateNew": "Si le client paie pour Twilio, créez un nouveau compte Twilio",
      "learnHow": "Découvrez comment",
      "createNewTwilioAccountInstructions": "Créez un nouveau compte Twilio pour cet emplacement",
      "learnHowToMovePhoneNumbers": "Apprenez à transférer des numéros de téléphone",
      "thisIsMyClientsTwilioCreateNew": "Ceci est le Twilio de mon client, veuillez créer un nouveau compte",
      "featureUnderDevelopment": "Cette fonctionnalité est en cours de développement",
      "emailRebillingDescription": "Refacturez les coûts des e-mails à vos clients et incluez une majoration",
      "emailRebillingCardInfoRequired": "La refacturation par e-mail nécessite que les informations de carte soient enregistrées pour le client.",
      "emailRebillingMarginsDescription": "Il s'agit de marges qui sont facturées à vos clients en sus des frais d'e-mail",
      "provider": "Fournisseur",
      "morePlanCustomizationsAvailable": "Davantage de personnalisations de forfaits sont disponibles",
      "plansAndPricing": "Forfaits et tarifs",
      "connectYourStripeAccountFirst": "Connectez d'abord votre compte Stripe",
      "createRecommendedPlansOnStripe": "Créez des plans recommandés sur Stripe",
      "createdPlanInStripe": "Plan créé dans Stripe",
      "customizeYourSaasPlans": "Personnalisez vos forfaits SaaS",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Vous pouvez proposer des forfaits recommandés ou créer les vôtres",
      "trialPeriod": "Période d'essai",
      "enterNumberOfDaysForTrial": "Entrez le nombre de jours pour l'essai",
      "nameCantBeEmpty": "Le nom ne peut pas être vide",
      "showStripeProductDetails": "Afficher les détails du produit Stripe",
      "addEmail": "Ajouter une adresse e-mail",
      "resetMountCounts": "Réinitialiser le nombre de montages",
      "connectReconnectGoogleForGbp": "Connectez ou reconnectez Google pour GBP",
      "downloadFile": "Télécharger le fichier",
      "showOnlySlowQueries": "Afficher uniquement les requêtes lentes",
      "gmbMessagingAvailable": "La messagerie GMB est désormais disponible",
      "reconnectGbpPageToEnable": "Reconnectez votre page GBP pour activer la messagerie",
      "failedPaymentsCheckBilling": "Paiements échoués détectés. Veuillez vérifier votre facturation.",
      "onlyAgencyAdminsCanSeeWarning": "Seuls les administrateurs d'agence peuvent voir cet avertissement.",
      "filter": "Filtrer",
      "stopDeleteOperation": "Arrêter l'opération de suppression",
      "summary": "Résumé",
      "enableTracking": "Activer le suivi",
      "exportAll": "Exporter tout",
      "newConversationStarted": "Nouvelle conversation commencée",
      "startNewConversation": "Démarrer une nouvelle conversation",
      "subAccountScheduledForDeletion": "Sous-compte programmé pour suppression",
      "deleteSubAccountOnScheduledTime": "Supprimer le sous-compte à l'heure programmée",
      "componentUpdatesDebuggerAlpha": "Débogueur des mises à jour de composants (Alpha)",
      "componentUpdateTrackingDisabled": "Le suivi des mises à jour des composants est désactivé",
      "deleteSubAccount": "Supprimer le sous-compte",
      "subAccountHasNumbersAndCampaigns": "Ce sous-compte comporte {phoneNumberCount} numéro(s) de téléphone et {campaignsCount} campagne(s).",
      "subAccountNoNumbersOrCampaigns": "Ce sous-compte ne possède aucun numéro de téléphone ni aucune campagne.",
      "areYouSureDeleteSubAccount": "Voulez-vous vraiment supprimer ce sous-compte ?",
      "confirmDiscussedWithClient": "Je confirme avoir discuté de cela avec mon client",
      "understandActionIrreversible": "Je comprends que cette action est irréversible",
      "confirmDisconnectCloseLcPhone": "Je confirme vouloir déconnecter et fermer le compte LC Phone",
      "choosingNotDeleteLcPhoneWarning": "Avertissement : si vous choisissez de ne pas supprimer le compte LC Phone, vous continuerez à être facturé pour les numéros de téléphone associés à ce sous-compte.",
      "deleteAccount": "Supprimer le compte",
      "send": "Envoyer",
      "typeMessage": "Saisissez un message",
      "requestPayment": "Demander le paiement",
      "reply": "Réponse",
      "retry": "Réessayer",
      "analyzeMemory": "Analyser la mémoire",
      "memoryAnalysisApproximate": "🚧 L’analyse de la mémoire est approximative et n'est pas précise à 100 %.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Ce sous-compte a été programmé pour être supprimé. Il sera supprimé d'ici le",
      "youCanChangeYourMindBeforeThisTime": "Vous pouvez changer d'avis avant cette date.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Ignorer",
          "cannotIdentifyContact": "Impossible d'identifier le contact et son emplacement.",
          "contactNotSelected": "Le contact n'est pas sélectionné.",
          "messageRequired": "Assurez-vous d'avoir saisi un message ou sélectionné un modèle.",
          "noPhoneNumber": "Le contact n'a pas de numéro de téléphone.",
          "genericError": "{message}",
          "stayPrompt": "Restez"
        },
        "scheduledSuccess": "E-mail programmé avec succès",
        "confirmDelete": "Voulez-vous vraiment supprimer {name} ?"
      },
      "clear": "Effacer",
      "edit": "Modifier",
      "sendNow": "Envoyer maintenant",
      "schedule": "Programmer",
      "useTemplate": "Utiliser un modèle (Extrait)",
      "mergeFields": "Fusion des champs",
      "customVariablesError": "Vos variables personnalisées ne sont pas formatées correctement, veuillez corriger les problèmes avant d'envoyer.",
      "sendLater": "Envoyer plus tard",
      "scheduledFor": "Programmé le {date}",
      "call": "Appel",
      "leftVoicemail": "A laissé un message vocal",
      "pleaseSelectCampaign": "Veuillez sélectionner une campagne",
      "whatsapp": {
        "no24HourMessage": "Vous pouvez envoyer des messages types uniquement en dehors de la fenêtre de 24 heures. Veuillez sélectionner un modèle."
      },
      "attachFile": "Joindre un document",
      "email": {
        "fromEmail": "Adresse e-mail de l'expéditeur",
        "fromName": "Nom de l'expéditeur",
        "smtpWarning": "Les fournisseurs SMTP présentent certaines limitations. Cliquez ici pour en savoir plus.",
        "subject": "Objet",
        "errors": {
          "cannotIdentifyContact": "Impossible d'identifier le contact et son emplacement.",
          "contactNotSelected": "Le contact n'est pas sélectionné.",
          "genericError": "{message}",
          "bodyRequired": "L'e-mail nécessite un corps de texte pour être envoyé.",
          "noEmailAddress": "Le contact n'a pas d'adresse e-mail."
        },
        "scheduledSuccess": "E-mail programmé avec succès"
      },
      "addCalendarToSchedule": "Vous devez ajouter un calendrier pour commencer à programmer des rendez-vous.",
      "slotRequired": "Créneau obligatoire",
      "teamMemberRequired": "Un membre de l'équipe est obligatoire."
    },
    "added": "ajouté",
    "loadMore": "Charger plus",
    "admin": "Admin",
    "aiEmployee": {
      "popupBlockedAlert": "Vous avez désactivé la fenêtre pop-up. Veuillez autoriser les pop-ups pour que ce site soit automatiquement redirigé vers Zoom call. Veuillez cliquer sur « Join now » pour être directement redirigé vers l'appel Zoom."
    },
    "alsoCloseAssociatedSubAccount": "Également étroitement associé",
    "analyzeMemory": "Analyser la Mémoire",
    "announcements": "Annonces",
    "apply": "Appliquer",
    "appointment": {
      "pickDay": "Sélectionnez un jour",
      "pickSlot": "Veuillez sélectionner un créneau de rendez-vous",
      "selectDate": "Sélectionner une date",
      "selectSlot": "Sélectionner un créneau",
      "slot": "Créneau",
      "day": "Jour"
    },
    "areYouReallySureDeleteSubAccount": "Êtes-vous vraiment sûr de vouloir supprimer ce sous-compte ?",
    "areYouSureDeleteSubAccount": "Voulez-vous vraiment supprimer ce sous-compte ?",
    "assignedContactOwner": "Assigné (propriétaire de {contact})",
    "assignedToMe": "Attribué à moi",
    "audio": {
      "browserNotSupported": "Votre navigateur ne prend pas en charge l'élément audio.",
      "loadingTranscription": "Chargement de la transcription...",
      "viewTranscript": "Afficher la transcription",
      "stop": "Arrêter",
      "playPause": "Lire/Mettre en pause",
      "timePlayed": "Durée de lecture : durée totale",
      "mute": "Désactiver le son",
      "playbackSpeed": "Vitesse de lecture",
      "download": "Télécharger",
      "remove": "Supprimé"
    },
    "automated": "Automatisé",
    "avatar": {
      "aiGenerated": "Ce message a été généré par Conversation AI",
      "messengerAutomation": "Automatisation de Messenger",
      "workflowGenerated": "Ce message a été généré via l'action du flux de travail Conversation AI",
      "messageByAI": "Ce message a été généré par Conversation AI",
      "messageByWorkflow": "Ce message a été généré via l'action du flux de travail Conversation AI",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Rejoignez la communauté à la croissance la plus rapide.",
    "callHighlevelAt": "Appelez HighLevel au +1(888)732-4197",
    "callQueueTooltip": "Cet appel est dans la file d'attente de l'utilisateur pour être exécuté.",
    "callTranscript": "Transcription d'appel",
    "clearFilters": "Effacer les filtres",
    "clientsCompanyBillingPage": "page de facturation de l'entreprise du client",
    "closeChat": "Fermer le chat",
    "closeConversation": "Fermer la conversation",
    "component": {
      "dismissMessage": "IGNORER CE MESSAGE",
      "unblock": "Débloquer",
      "inboundDndActive": "Fonction DND entrant activée pour ce contact",
      "fetchOlderMessages": "Récupérer les anciens messages",
      "conversationBegan": "La conversation a commencé",
      "celebrationTitle": "Waouh ! Les conversations sont fluides maintenant !",
      "celebrationBody": "Ce n'est que le début ! Découvrons comment GHL peut vous aider à développer votre entreprise.\nEn attendant, vous pouvez continuer à envoyer des messages à votre guise."
    },
    "componentUpdateTrackingDisabled": "Le suivi des mises à jour des composants est actuellement désactivé",
    "componentUpdatesDebuggerAlpha": "🚧 Débogueur de mises à jour de composants (Alpha) - En cours de développement",
    "confirmDelete": "Supprimer la ou les conversations ?",
    "confirmDeleteTextLine11": "Voulez-vous vraiment supprimer cette conversation ? Cette action est irréversible.",
    "confirmDeleteTextLine12": "conversations sélectionnées",
    "confirmDeleteTextLine21": "Cette action est irréversible. Voulez-vous quand même continuer ?",
    "confirmDisconnectedAllIntegrations": "Je confirme avoir déconnecté toutes les intégrations comme twilio, mailgun, gmb, domaines, facebook, zoom etc.",
    "confirmStoppedAllAutomations": "Je confirme avoir arrêté toutes les automatisations dans ce sous-compte",
    "connectReconnectGoogleForGbp": "Connectez / Reconnectez votre compte Google pour accéder à la messagerie GBP !",
    "connectWithCertifiedAdmin": "Connectez-vous avec un administrateur certifié",
    "connectWithTeamForHelp": "Contactez notre équipe pour obtenir de l'aide par appel vidéo en direct !",
    "connectWithUs": "Entrez en contact avec nous",
    "connectZoomAccount": "Connectez le compte Zoom",
    "contactEngagementScore": "Score d’engagement de {contact}",
    "dailyBrainstormingSessions": "Séances quotidiennes de brainstorming avec HighLevel",
    "deleteAccount": "Supprimer le compte",
    "deleteSubAccountOnScheduledTime": "Supprimer le sous-compte à l'heure programmée",
    "disableSaasMode": "Désactivez le mode SaaS",
    "dnd": {
      "configure": "CONFIGURER",
      "status": {
        "on": "ACTIVÉE",
        "partial": "Incomplet"
      }
    },
    "editAppointment": {
      "updateButton": "Mettre à jour le rendez-vous",
      "scheduleAppointment": "Programmer un rendez-vous",
      "editAppointment": "Modifier le rendez-vous",
      "calendar": "Calendrier",
      "selectCalendar": "Sélectionner un calendrier",
      "roundRobin": "Round-robin",
      "pickTeamMember": "Choisir un membre de l'équipe",
      "selectTeamMember": "Sélectionner un membre de l'équipe",
      "teamMemberRequired": "Un membre de l'équipe est obligatoire",
      "slotRequired": "Créneau obligatoire",
      "appointmentTitle": "Titre du rendez-vous",
      "appointmentTitleTooltip": "Laissez ce champ vide si vous choisissez d'utiliser le titre de rendez-vous préconfiguré",
      "contactName": "Nom du contact",
      "name": "Nom",
      "nameRequired": "Nom obligatoire",
      "emailAddress": "Adresse e-mail",
      "phoneNumber": "Numéro de téléphone",
      "phoneNumbers": "Numéros de téléphone",
      "dateOfBirth": "Date de naissance",
      "contactTimezone": "Fuseau horaire du contact (utilisé pour le rappel)",
      "chooseOne": "Choisissez un élément.",
      "meetingLocation": "Lieu de la réunion",
      "meetingLocationTooltip": "Laissez le champ vide si vous choisissez d'utiliser le lieu de réunion préconfiguré",
      "status": "Statut",
      "appointmentStatus": "Statut du rendez-vous",
      "additionalNotes": "Remarques supplémentaires",
      "notes": "Remarques",
      "actionRequired": "Action obligatoire",
      "confirmed": "Confirmé",
      "invalid": "Non valide",
      "cancelled": "Annulé",
      "showed": "Honoré",
      "noShow": "Non honoré",
      "busy": "Occupé",
      "free": "Libre",
      "noCalendarMessage": "Vous devez ajouter un calendrier pour commencer à programmer des rendez-vous."
    },
    "email": {
      "errors": {
        "bodyRequired": "L'e-mail nécessite un corps de texte obligatoire pour être téléchargé.",
        "cannotIdentifyContact": "Impossible d'identifier le Contact et son emplacement.",
        "contactNotSelected": "Le contact n'est pas sélectionné.",
        "noEmailAddress": "Le contact ne possède pas d'adresse e-mail."
      },
      "thread": {
        "failedToFetch": "Impossible de récupérer le contenu de l'e-mail",
        "forward": "Transférer"
      },
      "reply": "Répondre",
      "share": "Partager",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Ajouter un compte",
      "respond": "Répondre",
      "retry": "Réessayer",
      "moreEmailsInThread": "{count} e-mails de plus dans le fil",
      "fromName": "Nom de l'expéditeur",
      "fromEmail": "Adresse e-mail de l'expéditeur",
      "subject": "Objet",
      "attachFile": "Joindre un document",
      "useTemplate": "Utiliser un modèle (extrait)",
      "requestPayment": "Demander le paiement",
      "clear": "Effacer",
      "sendNow": "Envoyer maintenant",
      "schedule": "Programmer",
      "send": "Envoyer",
      "smtpWarning": "Les fournisseurs SMTP présentent certaines limitations. Cliquez ici pour en savoir plus.",
      "chooseOne": "Choisissez un élément.",
      "deliveredCount": "{delivered}/{total} envoyé(s)",
      "typeMessage": "Saisissez un message",
      "sendLater": "Envoyer plus tard",
      "scheduledFor": "Programmé pour le {date}"
    },
    "emailRebillingCardInfoRequired": "Pour activer la refacturation par e-mail, vous devez saisir les informations de carte de votre client sur",
    "emailRebillingDescription": "Cela vous permet de refacturer les coûts des e-mails à vos clients et d'inclure une majoration.",
    "emailRebillingMarginsDescription": "Il s'agit de marges qui sont facturées à vos clients en sus des frais d'e-mail qui vous incombent",
    "enableTracking": "Activer le suivi",
    "exploreHighlevelExperts": "Découvrez les experts de HighLevel qui peuvent vous aider à configurer votre système, automatiser vos flux de travail ou personnaliser votre projet.",
    "exportAll": "Exporter tout",
    "facebook": {
      "errors": {
        "generalError": "Une erreur s'est produite. Veuillez réessayer ou vérifier l'intégration à Facebook. Message d'erreur :",
        "noFacebookId": "Le contact n'a pas d'identifiant Facebook."
      }
    },
    "failedPaymentsCheckBilling": "Vous avez un ou plusieurs paiements qui ont échoué. Veuillez vérifier votre historique de facturation.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Supérieur",
      "aiActionLogs": "Journaux d'audit des actions de l'IA",
      "inRange": "Dans la plage",
      "invoice": "Facture",
      "messageDirectionTooltip": "Le filtre s'appliquera aux messages envoyés après le 9 mai 2023",
      "appointments": "Rendez-vous"
    },
    "followed": "Suivi par",
    "followedByMe": "Suivi par moi",
    "followedBySpecificUser": "Suivi par un utilisateur spécifique",
    "follower": "Abonné",
    "followerAssignmentContact": "Abonné (assignation de {contact})",
    "gbp": {
      "errors": {
        "generalError": "Une erreur s'est produite. Veuillez réessayer ou vérifier l'Intégration de Google Business Profile. Message d'erreur :",
        "noGBPId": "Le contact n’a pas d’identifiant GBP."
      }
    },
    "gbpChatNoLongerAvailable": "Google Business Profile Chat n’est plus disponible",
    "getAccessToHighlevelWelcomeCourse": "Accédez au cours de bienvenue HighLevel",
    "getPriorityTroubleshooting": "Bénéficiez d'un dépannage prioritaire, de conseils d'experts et d'un accès direct à notre équipe technique via Slack.",
    "gmbMessagingAvailable": "La messagerie Google Business est disponible pour votre compte.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Évaluation :",
      "replyDate": "Date de la réponse :",
      "replyFrom": "Réponse de :",
      "review": "Vérifier",
      "reviewDate": "Date de l'avis :",
      "reviewFrom": "Avis de :"
    },
    "highlevelEvents": "Événements HighLevel",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Veuillez inclure cette signature avant le texte cité dans les réponses",
    "instagram": {
      "errors": {
        "generalError": "Une erreur s'est produite. Veuillez réessayer ou vérifier l'intégration Instagram. Message d'erreur :",
        "noInstagramId": "Le contact n'a pas d'identifiant Instagram."
      }
    },
    "joinOurFacebookGroup": "Rejoignez notre groupe Facebook",
    "keepUpToDateWithLatestNews": "Suivez l'actualité et les dernières nouveautés !",
    "lastMessageChannel": "Dernier canal de message",
    "lastMessageDirection": "Direction du dernier message",
    "lastOutboundMessageType": "Dernier type de message sortant",
    "learnHow": "Comment apprendre ?",
    "leftComment": "a laissé un commentaire",
    "leftPanel": {
      "recents": "Récents",
      "unread": "Non lu",
      "createNewMessage": "Créer un nouveau message",
      "minCharsRequired": "Minimum 3 caractères requis",
      "twoMoreCharsRequired": "2 caractères supplémentaires sont requis",
      "oneMoreCharRequired": "1 caractère supplémentaire requis"
    },
    "liveChat": {
      "endLiveChat": "Fermer le chat en direct",
      "errors": {
        "generalError": "Une erreur s'est produite. Veuillez réessayer ou vérifier l'intégration de Google My Business. Message d'erreur :"
      },
      "requestContact": "Demander au contact"
    },
    "live_chat_message": "Message de chat en direct",
    "made": "fait",
    "memoryAnalysisApproximate": "🚧 L’analyse de la mémoire est approximative et n'est pas précise à 100 %.",
    "mentioned": "Mentionné à",
    "mentions": "Mentions",
    "mentionsOfMe": "Mentions de moi",
    "mentionsOfSpecificUser": "Mentions d'utilisateur spécifique",
    "message": {
      "replyAll": "Répondre à tout le monde",
      "details": "Informations",
      "reply": "Répondre",
      "unsuccessful": "Échec",
      "pending": "En attente",
      "inboundCall": "Appel entrant",
      "outboundCall": "Appel sortant",
      "ivrCall": "Appel IVR",
      "leftVoicemail": "A laissé un message vocal",
      "storyReply": "Réponse à la Story",
      "storyMention": "Mention de la Story",
      "replyAsDM": "Répondre par DM",
      "newCommentOnPost": "Nouveau commentaire sur la publication de {pageName}.",
      "goToPost": "Accéder à la publication",
      "replyNotAvailable": "Il n'est pas possible de répondre par DM privé aux commentaires datant de plus de 7 jours.",
      "addToDocuments": "Ajouter aux documents",
      "attachmentsAddedSuccess": "Les pièces jointes ont bien été ajoutées aux documents",
      "attachmentsAddedFailed": "Impossible d'ajouter des pièces jointes aux documents",
      "reportFeedbackForAI": "Signaler des commentaires pour l'IA",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Voulez-vous vraiment annuler ce calendrier ?",
      "cancelScheduledMessage": "Voulez-vous annuler le message programmé ?",
      "cancelSend": "Annuler l'envoi",
      "cancelScheduledSuccess": "Le message programmé a bien été annulé",
      "cancelScheduledError": "Une erreur s'est produite lors de l'annulation du message programmé.",
      "cc": "CC",
      "channel": "Canal",
      "createdBy": "Créé par",
      "direction": "Direction",
      "emailCampaign": "Campagne par e-mail",
      "facebookMessage": "Message Facebook",
      "instagramMessage": "Message Instagram",
      "messageId": "ID du message",
      "messageIdLabel": "ID de message : ",
      "trigger": "Déclencheur",
      "unanswered": "Sans réponse",
      "yes": "Oui",
      "messageDetails": "Informations du message",
      "from": "De",
      "fromLabel": "De :",
      "to": "À",
      "toLabel": "À :",
      "unknown": "Inconnu",
      "unknownFrom": "Inconnu de",
      "unknownTo": "Inconnu à",
      "unknownDirection": "Direction inconnue",
      "dateUnknown": "Date inconnue",
      "emailFromUnknown": "E-mail d'un expéditeur inconnu",
      "smsFromUnknown": "SMS d'Inconnu",
      "callFromUnknown": "Appel anonyme",
      "voicemailFromUnknown": "Message vocal d'un expéditeur inconnu",
      "emailToUnknown": "E-mail vers un destinataire inconnu",
      "smsToUnknown": "SMS vers un destinataire inconnu",
      "callToUnknown": "Appel à un inconnu",
      "voicemailToUnknown": "Messagerie vocale vers Inconnu",
      "failed": "Échec",
      "datetime": "Jour et heure",
      "manual": "Manuel",
      "automation": "Automatisation",
      "workflow": "Flux de travail",
      "campaign": "Campagne",
      "bulkRequest": "Demande en masse",
      "delivered": "Envoyé",
      "bounced": "Rejeté",
      "opened": "Ouvert",
      "sent": "Envoyé",
      "scheduled": "Programmé",
      "pageName": "Nom de la page",
      "gbpMessage": "Message GBP",
      "no": "Non",
      "eventsTrackedForContactOnly": "Les événements ne sont actuellement capturés que pour l'adresse e-mail du contact.",
      "completed": "Terminé",
      "voicemail": "Messagerie vocale",
      "busy": "Occupé",
      "pending": "En attente",
      "read": "Lu",
      "nativeIntegrations": "Intégrations natives",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "E-mail",
      "sms": "SMS",
      "phoneCall": "Appel téléphonique",
      "voiceMail": "Messagerie vocale",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Avis",
      "others": "Autres",
      "partialDetailsWarning": "Des informations partielles seront disponibles pour les messages envoyés avant le 15 juillet 2022.",
      "agencySystem": "Système d'agence",
      "reply": "Répondre"
    },
    "multiplePhone": {
      "chooseNumber": "Sélectionnez un nombre pour démarrer le chat :",
      "continue": "Continuer",
      "noPhones": "Aucun numéro de téléphone n'est disponible"
    },
    "myChat": "Mon chat",
    "myInbox": "Ma boîte de réception",
    "newConversationStarted": "Nouvelle conversation commencée",
    "newMessage": {
      "title": "Nouveau message :",
      "errors": {
        "phoneRequired": "Le numéro de téléphone est obligatoire"
      }
    },
    "noConversationSelected": "Aucune conversation sélectionnée",
    "noResultsToShow": "Aucun résultat à afficher",
    "onboardingVideoTutorials": "Tutoriels vidéo d'intégration",
    "onlyAgencyAdminsCanSeeWarning": "Seuls les administrateurs d'agence peuvent voir cet avertissement. Pour plus d'informations",
    "onlyVisibleToUsers": "Visible uniquement pour les utilisateurs",
    "perMonthPerIp": "/mois/IP",
    "phone": {
      "call": "Appelez {name}",
      "callingOptions": "{count} options d'appel",
      "phoneNumbers": "Numéros de téléphone",
      "callOptions": "{count} options d'appel",
      "dndActive": "Fonction DND active pour les appels",
      "primary": "Principal"
    },
    "pleaseDisableSaasMode": "Veuillez désactiver le mode SaaS pour ce sous-compte",
    "pleaseSelectCampaign": "Veuillez sélectionner une campagne",
    "premiumSupport": "Support Premium",
    "quickFilters": "Filtres rapides",
    "reconnectGbpPageToEnable": "Reconnectez votre page GBP pour l’activer.",
    "replyAsDMTooltip": "Répondez à ce commentaire par DM privé.",
    "replyingTo": "En réponse à",
    "resetMountCounts": "Réinitialiser le nombre de montages",
    "review": {
      "errors": {
        "generalError": "Une erreur s'est produite. Message d'erreur :",
        "googleIntegrationError": "Impossible de répondre à cet avis. Il semble qu'il y ait une erreur avec votre intégration Google. Veuillez le reconnecter sous Paramètres -> Intégrations.",
        "noReviewId": "La conversation n'a pas d'ID d'avis."
      },
      "reviewPostTo": "Avis publié sur {network}",
      "sharedOn": "Avis partagé sur {network}",
      "disputeReview": "Contester cet avis",
      "learnHow": "(Découvrez comment)",
      "seeOnGBP": "Consulter cet avis sur GBP",
      "alreadyShared": "Cet avis a déjà été publié sur {network}. Voulez-vous vraiment le republier ?"
    },
    "reviewId": "ID de l'avis",
    "schedule": {
      "sendSchedule": "Envoyer le calendrier",
      "timezone": "Fuseau horaire ({heading})",
      "title": "Programmer votre {type}"
    },
    "scheduling": "Planification…",
    "seeHow": "En savoir plus",
    "selectFilter": "Sélectionner un filtre",
    "selected": "sélectionné",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Objet :",
      "subjectPlaceholder": "Ligne d'objet",
      "to": "À :",
      "sending": "Envoi en cours...",
      "sendButton": "Envoyer un e-mail"
    },
    "setupAccountWithFreeTutorials": "Configurez votre compte avec des tutoriels gratuits",
    "showOnlySlowQueries": "Afficher uniquement les requêtes lentes (>{threshold}ms)",
    "sms": {
      "confirmSending": "Confirmer l'envoi du message",
      "editModal": {
        "compose": "Rédiger un SMS"
      },
      "errors": {
        "customVariablesIssue": "Vos variables personnalisées ne sont pas formatées correctement, veuillez corriger les problèmes avant d'envoyer.",
        "messageOrTemplateRequired": "Assurez-vous d'avoir saisi un message ou sélectionné un modèle.",
        "noPhoneNumber": "Le contact n'a pas de numéro de téléphone."
      },
      "scheduledSuccessfully": "SMS programmé avec succès",
      "sendAnyway": "Envoyer quand même",
      "spamWarning": "Il semblerait que le contenu de votre SMS contienne des références au cannabis, au sexe, à la haine, à l'alcool, aux armes à feu, au tabac, au vapotage ou à d'autres sujets interdits. L'envoi de ce type de contenu via SMS est strictement interdit et peut entraîner des restrictions de compte. Veuillez vérifier attentivement votre contenu avant de continuer.",
      "send": "Envoyer"
    },
    "startNewConversation": "Démarrer une nouvelle conversation",
    "subAccountAndDeleteAllPhoneNumbers": "sous-compte et supprimez tous les numéros de téléphone",
    "subAccountScheduledForDeletion": "Ce sous-compte est programmé pour être supprimé",
    "subAccountScheduledForDeletionItWillBeDeleted": "Ce sous-compte a été programmé pour être supprimé. Il sera supprimé par",
    "teamInbox": "Boîte de réception de l'équipe",
    "threshold": "Seuil",
    "understandActionIrreversible": "Je comprends que cette action est irréversible et que toutes les données de ce sous-compte seront perdues",
    "unstarred": "Sans étoile",
    "use_a_template": "Utilisez un modèle",
    "userAvailability": "Disponibilité utilisateur",
    "userCalendarConfiguration": "Configuration du Calendrier Utilisateur",
    "userInfo": "Informations utilisateur",
    "userRoles": "Rôles utilisateur",
    "viewSupportTickets": "Consultez vos tickets d'assistance, nos articles d'aide et notre FAQ !",
    "visitOurHelpCenter": "Visitez notre centre d'aide",
    "welcomeCourse": "Cours de bienvenue",
    "whatsapp_logo": "Logo WhatsApp",
    "youCanChangeYourMindBeforeThisTime": "Vous pouvez changer d'avis avant cette date.",
    "zoomAccount": "Zoom Account",
    "deleteEmails": "Supprimer {count} e-mail(s)",
    "fileAttachment": {
      "urlNotFound": "URL introuvable",
      "unsupportedAttachment": "Ces pièces jointes risquent de ne plus être prises en charge.",
      "downloadFile": "Télécharger le fichier"
    },
    "composer": {
      "internalComment": "Commentaire interne"
    },
    "dropdown": {
      "openOptions": "Ouvrir les options",
      "messageDetails": "Informations du message"
    },
    "respond": "Répondre",
    "selectTemplate": "Sélectionner un modèle",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Vous avez désactivé la fenêtre pop-up. Veuillez autoriser les pop-ups pour que ce site soit automatiquement redirigé vers Zoom call. Veuillez cliquer sur « Join now » pour être directement redirigé vers l'appel Zoom.",
        "helpAndSupport": "Aide et assistance",
        "summerOfAI": "Summer of AI"
      }
    },
    "celebration": {
      "dismiss": "Ignorer",
      "body": "Ce n'est que le début ! Découvrons comment GHL peut vous aider à développer votre entreprise.\nEn attendant, vous pouvez continuer à envoyer des messages à votre guise",
      "title": "Waouh ! Les conversations sont fluides maintenant !"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "article d'aide ici",
      "message": "Veuillez autoriser les cookies tiers pour afficher cette page correctement. Vous pouvez consulter notre",
      "ok": "OK",
      "title": "Les cookies tiers ne fonctionnent pas"
    }
  },
  "crash": {
    "message": "Nous sommes désolés, mais une erreur inattendue s'est produite. Veuillez actualiser la page.",
    "refresh": "Actualiser la page",
    "title": "Oups ! Une erreur s'est produite"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Annulation de la suppression pour {name}",
      "confirmAbort": "Oui, annuler",
      "keepDeleting": "Non, conserver la suppression",
      "message": "Êtes-vous sûr de vouloir annuler ?",
      "scheduledForDeletion": "Cet emplacement sera supprimé le {date}",
      "title": "Annulez la suppression",
      "warning": "Veuillez noter : l'emplacement sera supprimé à la date programmée, sauf si vous annulez la suppression."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Déposez les fichiers ici pour les télécharger",
      "uploadError": "Erreur de réseau : Impossible d'envoyer une requête à AWS. (Peut-être une erreur CORS)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Ajouter un {entityName}",
      "clonedMessage": "{entityName} cloné ! Accédez au compte où il a été cloné et trouvez-le sous l'onglet de {entityName}.",
      "errorGettingDetails": "Il semble y avoir une erreur lors de l'obtention des détails de {entityName}. Veuillez vérifier l'URL ou réessayer.",
      "permissionError": "Erreur de permission : cet entonnoir est protégé et ne peut pas être créé ici."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "Logo GoogleCalendar"
    },
    "printful": {
      "logo": "Logo Printful",
      "title": "Printful : impression à la demande"
    },
    "printify": {
      "logo": "Logo Printify",
      "title": "Printify : POD"
    },
    "shipStation": {
      "logo": "Logo ShipStation",
      "title": "ShipStation"
    },
    "shippo": {
      "logo": "Logo Shippo",
      "title": "Shippo : Intégration de l'expédition"
    },
    "tikTok": {
      "accountNotConnected": "Compte non connecté",
      "accountNotConnectedMessage": "Votre compte n'est pas connecté à un compte publicitaire TikTok. Terminez l'intégration pour afficher les formulaires et associer les champs.",
      "advertiserId": "ID d'annonceur",
      "companyFields": "{companyName} Champs",
      "editFields": "Modifier les champs",
      "errorSubscribing": "Erreur lors de l'abonnement à la page.",
      "formsNotAvailable": "Formulaires non disponibles",
      "mandatoryFieldsNote": "Remarque : associez l'un ou l'autre des champs obligatoires suivants pour recevoir des prospects dans votre compte. Champs : Prénom, Nom de famille, Adresse e-mail, Numéro de téléphone",
      "noFormsMessage": "Vous n'avez actuellement aucun formulaire de génération de prospects créé dans votre compte publicitaire TikTok. Accédez à votre compte publicitaire TikTok et créez-en un pour commencer.",
      "pageId": "ID de page",
      "selectAdvertiserAccount": "Sélectionner un compte annonceur"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Autre / Je ne sais pas",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Suivez ces quelques étapes simples pour suspendre ce sous-compte"
    },
    "transfer": {
      "chooseDescription": "Choisissez votre mode de transfert",
      "chooseMethod": "Transférer ce sous-compte",
      "eject": {
        "description": "Gagnez 40 % de commission récurrente sur l'abonnement du nouveau compte.",
        "title": "Éjecter en tant que nouveau compte"
      },
      "modal": {
        "confirmDetails": "Veuillez confirmer les informations avant de procéder au transfert",
        "confirmNomineePrefix": "Désigner le titulaire de",
        "confirmTransfer": "Confirmer le transfert",
        "consentText": "J'ai lu et compris le guide ci-dessus et j'accepte toutes les limites",
        "ejectErrorTitle": "Impossible d'éjecter le sous-compte.",
        "ejectGenericError": "Le sous-compte que vous essayez d'éjecter ne peut pas être éjecté. Veuillez contacter l'assistance.",
        "ejectGuidelines": "Directives pour l'éjection des sous-comptes",
        "ejectSubject": "L'éjection du sous-compte est soumise à l'acceptation par l'utilisateur de la demande de création d'une nouvelle agence.",
        "ejectSuccessTitle": "Demande d'éjection d'un sous-compte envoyée à l'utilisateur sélectionné",
        "enterPassword": "Veuillez saisir votre mot de passe pour confirmer",
        "genericError": "Le sous-compte que vous essayez de transférer ne peut pas être transféré. Veuillez contacter l'assistance.",
        "guidelines": "Consignes relatives au transfert de sous-comptes",
        "guidelinesConsent": "Veuillez lire et accepter",
        "hipaaDisclaimer": "Avis de non-responsabilité",
        "hipaaText": "Vous pouvez indiquer à ce sous-compte qu'il bénéficie actuellement d'une couverture HIPAA, mais qu'il ne bénéficiera peut-être pas de la même couverture dans l'agence à laquelle il est transféré.",
        "noUsersDescription": "Aucun utilisateur n'est associé à ce sous-compte. Veuillez ajouter un utilisateur de sous-compte, puis continuer.",
        "noUsersSearch": "Aucun utilisateur trouvé.",
        "noUsersTitle": "Aucun utilisateur trouvé",
        "nomineeInstructions": "Le candidat recevra un lien lui permettant de s'inscrire à HighLevel",
        "passwordError": "Mot de passe non valide",
        "passwordErrorDescription": "Le mot de passe que vous avez saisi n'est pas correct. Veuillez réessayer.",
        "relationshipError": "Veuillez entrer le numéro de relation correct",
        "relationshipNumber": "Numéro de relation de l'agence destinataire",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Demander un transfert",
        "seeAllRequests": "Afficher toutes les demandes",
        "successMessage": "Le sous-compte sera transféré une fois que l'agence réceptrice aura accepté votre demande de transfert.",
        "successTitle": "Demande de transfert du sous-compte envoyée à l'agence réceptrice",
        "title": "Transférer le sous-compte",
        "transferSubject": "Le transfert du sous-compte est sujet à l'acceptation par l'agence destinataire dans son compte.",
        "confirmNomineeSuffix": " à "
      },
      "transferExisting": {
        "description": "Transférer l'intégralité de ce sous-compte vers un autre compte.",
        "title": "Transférer vers un compte existant"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Prochaine exécution",
      "title": "Demandes en masse"
    },
    "campaign": {
      "account": "Compte",
      "accountBuffer": "Limite de compte",
      "accountBufferDescription": "Il n'y a pas de limite au nombre de destinataires ajoutés à cette campagne chaque jour (à partir d'une liste).",
      "accounts": "Comptes",
      "activity": "Activité",
      "acquire": "Acquérir",
      "acquisitionDescription": "Les campagnes d'acquisition de clients vous aident à produire davantage de prospects de vente qui sont prêts à s'engager.",
      "addEvent": "Ajouter un événement",
      "addUser": "Ajouter un utilisateur",
      "allMarket": "Tout le marché",
      "allowMultiple": "Autoriser plusieurs",
      "assignedToTooltip": "Lorsque cette campagne a commencé, ce contact a été attribué à cet utilisateur. Les modifications apportées à l'attributaire du contact se répercuteront sur les événements, mais ne modifieront pas cette valeur initiale.",
      "atLeastOneEvent": "Au moins un événement est requis.",
      "automations": "Automatisations",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Rejeté",
      "buffering": "Mise en mémoire tampon",
      "campaignActivity": "Activité de la campagne",
      "campaignConfiguration": "Configuration de la campagne",
      "campaignConfigurationWarning": "La configuration de la campagne affecte tous les marchés. Assurez-vous que vous devez modifier ces paramètres.",
      "campaignCreation": "Création de campagne",
      "campaignId": "ID de campagne",
      "campaignStatusByRecipients": "Statut de la campagne par destinataire",
      "clickThroughRate": "Taux de clic par ouverture",
      "clickedThrough": "Clic par ouverture",
      "conditionIfExplanation": "Lancez cette campagne ou cet événement si l'heure actuelle se situe dans cette fenêtre. Si l'heure actuelle se situe en dehors de cette fenêtre, ignorez la campagne ou l'événement et passez à la campagne ou à l'événement suivant.",
      "conditionWhenExplanation": "Exécutez les événements de cette campagne lorsque l'heure actuelle tombe dans cette fenêtre, sinon attendez la fenêtre suivante pour exécuter les événements.",
      "createCampaign": " Créer une campagne",
      "ctr": "CTR",
      "customerAcquisition": "Acquisition de clients",
      "dateAdded": "Date d'ajout",
      "dateAddedTooltip": "La date et l'heure exactes auxquelles le contact a été ajouté à cette campagne. L'heure de début du premier événement peut varier en fonction des configurations.",
      "deletedRestorePrompt": "Cette campagne est supprimée. Souhaitez-vous la restaurer ?",
      "delivered": "Envoyé",
      "deliveryRate": "Taux de livraison",
      "draftMode": "Mode Brouillon",
      "draftModeDescription": "Cette campagne est un brouillon. Elle ne peut pas être utilisée tant qu'il n'est pas publié.",
      "dropped": "Abandonnée",
      "emailActivity": "Activité d'e-mail",
      "emailActivityFilterExample": "Activité d'e-mail : clic par ouverture",
      "event": "Événement",
      "eventFilterExample": "Événement : 10X Email 4 (distribution d'annonce)",
      "filters": "Filtres",
      "emailPerformanceByAccount": "Performance des e-mails par compte",
      "emailsNotSentOnDays": "Les e-mails ne seront pas envoyés le samedi et le dimanche.",
      "emailsSentOnDays": "Les e-mails seront envoyés le lundi, le mardi, le mercredi, le jeudi, le vendredi.",
      "eventStartDate": "Date de début de l’événement",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffehouse",
      "exampleDate": "8 mai 2017 13:27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Assurez-vous que les données ne datent pas de plus de 30 jours",
      "exampleEventName": "10X Email 4 (distribution d'annonce)",
      "getMoreCustomers": "Obtenez plus de clients",
      "inProgress": "En cours",
      "includedDays": "Jours inclus",
      "internalSource": "Source Interne",
      "lastUpdate": "Dernière mise à jour",
      "leadValuePlaceholder": "Valeur en $ du prospect",
      "loopDetected": "Cette campagne a été bloquée à l'état de Brouillon, car elle provoque une boucle. Pour activer cette campagne, veuillez contacter le service d'assistance.",
      "market": "Marché",
      "moreDetails": "Plus d'informations",
      "myCampaigns": "Mes Campagnes",
      "na": "S. O.",
      "newFolder": " Nouveau dossier",
      "nextCampaign": "Prochaine campagne",
      "nextExecutionTime": "Horaire de prochaine exécution",
      "opened": "Ouvert",
      "openRate": "Taux d'ouverture",
      "option2": "Option 2",
      "option3": "Option 3",
      "pageNavigation": "Exemple de navigation de page",
      "processed": "Traité",
      "published": "Publié",
      "recipient": "Destinataire",
      "recipients": "Destinataires",
      "sampleCampaign": "Campagne d'exemple ",
      "scheduling": "Programmation",
      "seeHotLeads": "Voir les prospects prometteurs",
      "selectDateRange": "Sélectionner une plage de dates",
      "selectTimeZone": "Sélectionnez le fuseau horaire",
      "separator": " / ",
      "showingCount": "Affichage de {current} sur {total}",
      "spamReport": "Rapport de Spam",
      "startByAddingEvent": "Commencez par ajouter un événement à cette campagne.",
      "stopOnResponse": "Arrêt sur réponse",
      "stopped": "En pause",
      "time": "Heure",
      "timeConditionNote": "Remarque : si la première étape de la campagne est réglée sur « Immédiatement », la condition de temps ne s'applique pas à cette première étape.",
      "timeZoneDescription": "Ce paramètre influe sur la durée d'envoi de votre contenu.",
      "totalLeads": "Total des prospects",
      "undeliverable": "Non distribuable",
      "unsubscribe": "Se désabonner",
      "upNext": "Suivant",
      "utc": "UTC",
      "window": "fenêtre"
    },
    "embed": {
      "copyLinkInstructions": "Copiez le lien ci-dessous et partagez-le facilement où vous le souhaitez.",
      "embed": "Intégrer",
      "iframeEmbed": "Intégration Iframe",
      "integrateInstructions": "Utilise les options suivantes pour intégrer votre formulaire personnalisé dans votre site web",
      "integrateYourForm": "Intégrer votre formulaire",
      "link": "Lien",
      "saveAndExit": "Enregistrez et quittez"
    },
    "jotbox": {
      "deleteSubmission": "Supprimer l'envoi",
      "downloadPdf": "Télécharger le PDF",
      "ofSubmissions": " de {total} envois",
      "pages": "pages",
      "records": "enregistrements",
      "searchPlaceholder": "Recherche par nom, e-mail, téléphone et identifiant de contact",
      "selectYourForm": "Sélectionnez votre formulaire",
      "timeSigned": "Heure de signature :",
      "totals": "Totaux :"
    },
    "survey": {
      "createNewSurvey": "Créer un nouveau sondage",
      "integrateYourSurvey": "Intégrer votre sondage",
      "noSurveysForAnalyze": "Vous n'avez pas encore de sondage. Veuillez d'abord créer une enquête pour voir l'analyse ici.",
      "noSurveysForSubmission": "Vous n'avez pas encore de sondage. Veuillez d'abord créer une enquête pour voir la soumission ici.",
      "noSurveysYet": "Vous n'avez pas encore de sondage.",
      "refreshData": "Actualiser les données",
      "searchSurveys": "Rechercher des sondages",
      "surveyBuilder": "Créateur de sondages",
      "toCreateFirstSurvey": "pour créer votre premier sondage."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Produit cloné ! Accédez au compte où il a été cloné et trouvez-le sous l'onglet Abonnement > Produits.",
      "errorGettingDetails": "Il semble y avoir une erreur lors de l'obtention des détails du produit. Veuillez vérifier l'URL ou réessayer."
    },
    "resetPassword": {
      "title": "Réinitialiser le mot de passe",
      "button": "Réinitialiser le mot de passe",
      "newPassword": "Nouveau mot de passe",
      "generateStrongPassword": "Générez un mot de passe fort",
      "sendEmailNotification": "Envoyez également une notification par email.",
      "errorMessage": "Une erreur s'est produite lors de la réinitialisation du mot de passe. Veuillez réessayer.",
      "updating": "Mise à jour…"
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ par",
      "combo": {
        "signedUp": "se sont inscrits à ProveSource au cours des dernières 24 heures",
        "verifiedBy": "vérifié par "
      },
      "conversions": {
        "recentlyBought": "vous avez récemment acheté ceci",
        "timeAgo": "au cours des 16 dernières minutes ",
        "visitorsCount": "50 visiteurs"
      },
      "pageVisits": {
        "description": "semblent avoir faim, eux aussi.",
        "timeAgo": "au cours des 21 dernières minutes                        ",
        "title": "50 foodies"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessge",
        "rating": "Évaluation 5 étoiles",
        "recently": "Récemment",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "s'est inscrit à ProveSource",
        "location": "(London, Royaume-Uni)",
        "name": "Mike ",
        "timeAgo": "Il y a 40 minutes                        "
      },
      "visitors": {
        "description": "amateurs de musique en ligne"
      }
    },
    "step1": {
      "combo": {
        "description": "Afficher le nombre de personnes ayant effectué une action spécifique sur 24 heures, 7 jours ou 30 jours.",
        "title": "Combinaison"
      },
      "conversions": {
        "description": "Créez une validation sociale en affichant le nombre de clients ayant effectué une action spécifique."
      },
      "liveReviews": {
        "description": "Montrez à vos visiteurs en temps réel les avis 4+ étoiles des 6 derniers mois."
      },
      "liveVisitors": {
        "beta": "Bêta",
        "description": "Affichez combien de visiteurs consultent maintenant votre site complet en temps réel."
      },
      "pageVisits": {
        "description": "Montrez à vos visiteurs qu'ils ne sont pas les seuls à participer à la fête en mettant en évidence les pages visitées récemment."
      },
      "stream": {
        "description": "Quoi de mieux que de mettre un visage sur cette preuve sociale ? Montrez vos clients récents et leurs actions."
      }
    },
    "step2": {
      "captureDescription2": "Chaque URL de page doit comporter un champ pour le formulaire d'e-mail",
      "captureDescription3": " et ProveSource est installé. ",
      "comboType": "Type de combinaison",
      "connectAccounts": "Veillez à connecter les comptes à partir desquels vous souhaitez obtenir des avis.",
      "connectGoogleAccount": "Connectez le compte Google de votre emplacement",
      "formSubmissions": "Envois de formulaires",
      "googleAccount": "Compte Google",
      "howToTrack": "Comment suivre",
      "howToTrackDescription": "Comment suivre vos conversions ?",
      "pageUrl": "URL de la page",
      "productPurchase": "Achat de produit",
      "trackAllUrls": "Repérez toutes les URL de page qui contiennent l'expression suivante. ",
      "trackVisitors": "Suivre les visiteurs",
      "trackVisits": "Suivre les visites",
      "urlTip": " Nous considérons http://, https://, www et non-www comme des variantes de l'URL et de la page. ",
      "urlValidationError": "Vous devez inclure au moins une URL. L'URL n'est pas valide. Veillez à inclure http:// ou https://",
      "userSignup": "Inscription de l’utilisateur",
      "visits": " Visites",
      "webhookDescription": "Appelez le point de terminaison suivant pour nous informer d'un événement ou d'une conversion qui s'est produit de votre côté et qui est lié à cette notification, nous ferons le reste.",
      "webhookRequest": "Demande de webhook",
      "whatToTrack": "Que souhaitez-vous suivre ?",
      "whereToCapture": "Où capturer",
      "whereToCaptureDescription": "Où capturez-vous les conversions ?",
      "whichPagesToTrack": "Quelles pages aimeriez-vous que nous suivions ?",
      "yourWebhookUrl": "Votre URL de webhook"
    },
    "step3": {
      "allPages": " Toutes les pages",
      "displayOnAllPages": "Afficher sur toutes les URL de page qui contiennent l'expression suivante : ",
      "whereToDisplay": "Où afficher",
      "whereToDisplayActivity": "Où souhaitez-vous que nous affichions cette activité ?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "pour de belles icônes (clic droit sur une icône -> Copier l'adresse de l'image)",
      "messageSettings": "Paramètres de message",
      "messageText": "Texte du message",
      "referToVisitorsAs": "Appeler les visiteurs des",
      "visitIcons8": "Visite"
    },
    "step5": {
      "allowUsersToClose": " Permettre aux utilisateurs de fermer la notification ",
      "behavior": "Comportement",
      "bottomLeft": "En bas à gauche",
      "bottomRight": "En bas à droite",
      "clickableNotification": " Notification cliquable ",
      "customizeDescription": "Modifiez les paramètres suivants pour contrôler le comportement et l'apparence de votre notification",
      "design": "Design",
      "displayNotificationFor": "Afficher une notification pour",
      "displayRules": "Règles d'affichage",
      "hideOnMobileScreens": " Masquer sur les écrans mobiles ",
      "linkRelativeNote": " Si http:// est omis, le lien s'ouvrira relativement à la page affichée. ",
      "minimumEventsToDisplay": "Nombre minimum d'événements à afficher",
      "notificationLink": "Lien de notification",
      "notificationPosition": "Position de notification",
      "openLinkInNewTab": "Ouvrir le lien dans un nouvel onglet",
      "selectPosition": "Sélectionnez la position",
      "showOnlyOncePerSession": " Montrer une seule fois par session ",
      "titleBackground": "Arrière-plan du titre",
      "titleColor": "Couleur du titre",
      "topLeft": "En haut à gauche",
      "topRight": "En haut à droite",
      "typeUrlHere": "Tapez l'URL ici"
    },
    "step6": {
      "identifyNotification": "Identifiez votre notification",
      "launchMessage": "Le lancement est imminent, veuillez prendre place et attacher votre ceinture.",
      "notificationName": "Nom de la notification",
      "notificationNamePrompt": "Quel est le nom de votre notification ?",
      "wellDone": "Bravo."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Abonnement créé avec succès",
      "youCanNowSetupWordPress": "Vous pouvez maintenant configurer votre site WordPress",
      "subscriptionFailed": "Échec de l'abonnement",
      "resubscriptionSuccessful": "Réabonnement réussi",
      "successfullyReactivated": "Votre abonnement WordPress a bien été réactivé",
      "reactiveSub": "Impossible de réactiver l'abonnement",
      "resubscriptionFailed": "Échec du réabonnement"
    },
    "v2": {
      "viewDetails": "Afficher les informations",
      "chatConversationAssigned": "Conversation par chat assignée",
      "internalChat": "Chat interne",
      "newTask": "Nouvelle tâche",
      "appointmentReminder": "Rappel de rendez-vous",
      "facebookReview": "Avis Facebook",
      "googleReview": "Avis Google",
      "internalChatMessage": "Message de chat interne",
      "newAppointmentAssigned": "Nouveau rendez-vous assigné",
      "newAppointmentBooked": "Nouveau rendez-vous réservé",
      "newCall": "Nouvel appel",
      "newEmail": "Nouvel e-mail",
      "newMention": "Nouvelle mention",
      "newReviewReceived": "Nouvel avis reçu de {contactName}",
      "taskReminder": "Rappel de tâche",
      "completed": "terminé",
      "failed": "échec",
      "subAccount": "Sous-compte",
      "newMessage": "Nouveau message",
      "newAppointmentBookedWith": "Nouveau rendez-vous pris avec {contactName}",
      "newAppointmentAssignedTo": "Nouveau rendez-vous attribué à {contactName}",
      "appointmentDueIn": "Rendez-vous prévu dans {minutes} minutes avec {contactName}",
      "newTypeReceived": "Nouveau {type} reçu de {contactName}",
      "newChatAssigned": "Nouveau chat attribué depuis {contactName}",
      "taskDueDate": "Tâche « {title} » à effectuer le {date} à {time} pour {contactName}",
      "tasksDueToday": "{count} tâches à effectuer aujourd'hui",
      "tasksOverdue": "{count} tâches en retard",
      "taskDueIn": "Tâche « {title} » à effectuer dans {dueTime} {unitOfTime} pour {contactName}",
      "mentionedInConversation": "{userName} vous a mentionné(e) dans une conversation avec {contactName}",
      "now": "maintenant"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Logo de l'entreprise"
      },
      "bestExperience": "la meilleure expérience.",
      "optimizedFor": "Cette page est optimisée pour",
      "portraitMode": "mode portrait",
      "toGiveYou": "pour vous donner le"
    }
  },
  "pagination": {
    "goToFirstPage": "Allez à la première page",
    "goToLastPage": "Aller à la dernière page",
    "goToNextPage": "Passer à la page suivante",
    "goToPreviousPage": "Aller à la page précédente",
    "itemsSelected": "{count} éléments sélectionnés",
    "showingEntries": "Affichage de {from} à {to} sur {total} entrées"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "! Veuillez ajouter un mode de paiement pour",
    "_segment": "/ segment",
    "ad_manager": "Gestionnaire de campagne",
    "add": "[AJOUTER :",
    "ai_employee": "AI Employee",
    "billing": {
      "incompleteBillingInfo": "Vous avez des informations de facturation incomplètes sur ce compte. Veuillez les mettre à jour immédiatement.",
      "updateNow": "Mettre à jour maintenant"
    },
    "charge": "Frais",
    "contactLimit": {
      "message": "Vous avez atteint la limite de votre plan actuel pour l'ajout de {contact}. Pour continuer, veuillez mettre à niveau votre plan et débloquer une capacité supplémentaire.",
      "upgradeNow": "Mettre à niveau",
      "warningMessage": "Vous avez {current} contact(s) alors que votre plan ne prévoit que {limit}.",
      "warningTitle": "L'utilisation du compte est supérieure à la limite. Veuillez effectuer une mise à jour pour continuer à travailler sans interruption."
    },
    "cost_borne_by_you": "à votre charge",
    "dedicated_ip": "Adresse IP dédiée",
    "electeditem": "electedItem",
    "feedback": "Commentaires :",
    "hello": "Bonjour",
    "helpDrawer": {
      "aiSupportAssistant": "Assistant d'IA",
      "clickToCopy": "Cliquez pour copier le numéro de relation",
      "clickToCopyToClipboard": "Cliquez pour copier le nombre de relation dans le presse-papiers",
      "companyRelationshipNumber": "Numéro de relation de l'entreprise",
      "hiImHighly": "Bonjour, je suis Highly !",
      "implementation": "mise en œuvre",
      "joinImplementationVideo": "Participer à un appel vidéo de mise en œuvre",
      "joinTrialZoom": "Rejoindre l'appel Zoom d'essai",
      "kickoff": "de lancement",
      "needHelpChatVideo": "Vous avez besoin d'aide ? Démarrez un chat ou appelez-nous en vidéo dès maintenant !",
      "openAIAssistant": "Ouvrir l'assistant d'IA",
      "premium": "Premium",
      "priority": "Priorité",
      "raiseSupportTicket": "Créer un ticket d'assistance",
      "raiseTicket": "Soumettre un ticket",
      "relationshipNumber": "Numéro de relation",
      "startAISupportChat": "Démarrer le chat d'assistance par IA",
      "startAgentChatWait": "Démarrer le chat avec un agent (temps d'attente de 2 à 5 minutes)",
      "startChatChoose": "Commencez à discuter - choisissez entre l'assistance par IA ou la discussion avec un agent",
      "startImplementationVideo": "Démarrer l'appel vidéo de mise en œuvre",
      "startZoom": "Démarrer Zoom",
      "startZoomCall": "Démarrer un appel Zoom",
      "subtitle": "Que vous souhaitiez échanger avec nous, interagir avec la communauté ou apprendre par vous-même, nous avons ce qu'il vous faut !",
      "title": "Aide et assistance",
      "trialExperience": "expérience d'essai",
      "useButtonsBelow": "Utilisez l'un des boutons ci-dessous pour obtenir de l'aide !",
      "videoCallReward": "Participez à un appel vidéo pour créer votre compte - et recevez {amount} en crédits sur votre portefeuille lors de votre participation.",
      "videoCallType": "Participez à un appel vidéo avec moi pour votre appel {type}.",
      "yourPremiumSupportSpecialist": "Votre expert d'assistance en {type}",
      "yourSpecialist": "Votre expert en {type}",
      "yourSupportSpecialist": "Votre spécialiste de l'assistance",
      "videoCall": "Appel vidéo",
      "active": "Actif",
      "announcementsAria": "Annonces - cliquez pour ouvrir dans un nouvel onglet",
      "chat": "Chat",
      "accessWelcomeCourseAria": "Cliquez pour accéder au cours de bienvenue HighLevel",
      "clickToUpgrade": "Cliquez pour Mettre à niveau",
      "connectCertifiedAdminAria": "Contactez un administrateur certifié - cliquez pour ouvrir dans un nouvel onglet",
      "connectWithUsAria": "Contactez-nous - démarrez le chat en direct",
      "contactUsAria": "Contactez-nous - appelez HighLevel au +1(888)732-4197",
      "copied": "Copié",
      "highlevelEventsAria": "Événements HighLevel - cliquez pour ouvrir dans un nouvel onglet",
      "joinFacebookGroupAria": "Rejoignez notre groupe Facebook - cliquez pour ouvrir dans un nouvel onglet",
      "onboardingVideoTutorialsAria": "Tutoriels d’intégration vidéo - cliquez pour ouvrir dans un nouvel onglet",
      "recommended": "Recommandé",
      "visitHelpCenterAria": "Visitez notre centre d’aide - cliquez pour ouvrir dans un nouvel onglet",
      "contactUs": "Contactez-nous",
      "agentChatWaitTime": "Chat avec un agent (temps d'attente d'environ 2 à 5 min)",
      "aiSupportChat": "Chat d'assistance par IA",
      "startChat": "Démarrer le chat",
      "announcements": "Annonces",
      "fastestGrowingCommunity": "Rejoignez la communauté à la croissance la plus rapide.",
      "callHighlevelPhone": "Appelez HighLevel au +1(888)732-4197",
      "connectCertifiedAdmin": "Contactez un administrateur certifié",
      "connectTeamVideoCall": "Contactez notre équipe pour obtenir de l'aide par appel vidéo en direct !",
      "connectWithUs": "Entrez en contact avec nous",
      "dailyBrainstormingSessions": "Séances quotidiennes de brainstorming avec HighLevel",
      "certifiedAdminDescription": "Découvrez les experts de HighLevel qui peuvent vous aider à configurer votre système, automatiser vos flux de travail ou personnaliser votre projet.",
      "getAccessWelcomeCourse": "Accédez au cours de bienvenue HighLevel",
      "premiumSupportDescription": "Bénéficiez d'un dépannage prioritaire, de conseils d'experts et d'un accès direct à notre équipe technique via Slack.",
      "highlevelEvents": "Événements HighLevel",
      "joinFacebookGroup": "Rejoignez notre groupe Facebook",
      "onboardingVideoTutorials": "Tutoriels vidéo d'intégration",
      "premiumSupport": "Assistance Premium",
      "setupAccountFreeTutorials": "Configurez votre compte avec des tutoriels gratuits",
      "viewSupportTicketsArticles": "Consultez vos tickets d'assistance, nos articles d'aide et notre FAQ !",
      "visitHelpCenter": "Visitez notre centre d'aide",
      "welcomeCourse": "Cours de bienvenue",
      "beta": "Bêta",
      "closeHelpSupportDrawer": "Fermer le tiroir Aide et assistance",
      "upgradePlanToEnable": "Vous devez passer à un forfait supérieur pour activer cette fonctionnalité",
      "premiumSupportActive": "Votre assistance premium est active",
      "premiumSupportClickUpgrade": "Support Premium - Cliquez pour mettre à niveau votre forfait",
      "premiumSupportActiveAria": "Assistance premium – Votre assistance premium est active",
      "keepUpToDateNews": "Suivez l'actualité et les dernières nouveautés !"
    },
    "hi": "Bonjour",
    "is_scheduled_for_deletion_on": "est prévue pour être supprimée le",
    "k": "K",
    "limit_updated_from": "limite mise à jour de",
    "minimum_must_be": "Le minimum doit être",
    "more_emails_in_thread": "Plus de courriels dans le fil de discussion",
    "multipleUsers": {
      "chooseAccount": "Choisissez un compte pour continuer"
    },
    "must_be_in_range_of_0": "Doit être compris dans la plage de 0 à",
    "numbers_and": "nombre(s) et",
    "premiumSupport": {
      "assigningManager": "Affectation d'un gestionnaire de compte technique...",
      "bookCall": "Fixer un rendez-vous téléphonique",
      "hiIm": "Bonjour, je suis {name}",
      "joinZoomNow": "Rejoignez l'appel Zoom maintenant",
      "quickActions": "Actions d'assistance rapide",
      "quickLinks": "Liens rapides",
      "raiseFeatureRequest": "Soumettre une demande de fonctionnalité",
      "slackChannelCreating": "Un instant — votre canal Premium Slack est en cours de lancement ! 🚀",
      "technicalAccountManager": "Responsable de compte technique",
      "viewRoadmap": "Afficher la feuille de route du produit"
    },
    "prospecting": "Prospection",
    "reloadPopup": {
      "message": "Nous avons remarqué que vous n'avez pas actualisé la page depuis un certain temps. Veuillez recharger pour profiter au mieux de l'application.",
      "refreshNow": "Actualiser maintenant"
    },
    "resell_settings": "Paramètres de revente",
    "row": "ligne",
    "select_upto": "Sélectionnez jusqu'à",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Bénéficiez d'une assistance dédiée au moment qui vous convient le mieux.",
      "title": "Planifiez un appel avec l'assistance Highlevel"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Il s'agit de marges qui sont facturées à vos clients en sus des coûts de",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Laissez-nous gérer Twilio pour vous",
        "benefit2": "Notre équipe d'assistance s'occupe de vos problèmes Twilio",
        "button": "Faites-le pour moi",
        "drawback": "Payez {price} de plus sur l'assistant virtuel que si vous le faisiez vous-même.",
        "title": "Nous le ferons pour vous"
      },
      "lowCreditsMessage": "Vous devez connecter un compte Twilio pour gérer les appels et les textos, qui sont envoyé/reçus sur HighLevel.",
      "lowCreditsTitle": "Vous êtes à court de crédits Twilio gratuits, mais nous sommes là pour vous !",
      "selfSetup": {
        "benefit1": "Gérez vos dépenses",
        "benefit2": "Contrôlez mieux votre service Twilio",
        "button": "Je vais gérer",
        "drawback1": "Engagez quelqu'un pour gérer le service Twilio",
        "drawback2": "Contactez l'assistance Twilio si quelque chose ne fonctionne pas.",
        "title": "Faites-le vous-même"
      },
      "wip": {
        "button": "Configurer Twilio",
        "fallback": "Pour l'instant, vous devrez gérer votre propre compte Twilio.",
        "message": "Merci de vous avoir choisis, mais nous travaillons toujours à développer cette fonctionnalité. Nous vous contacterons dès que nous pourrons la mettre en œuvre pour votre compte.",
        "title": "Nous y travaillons encore !"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Chargement de plus d'options...",
      "noElementsFound": "Oups ! Aucun élément trouvé Envisagez de modifier la requête de recherche.",
      "noLocationsFound": "Aucun lieu trouvé Essayez une autre recherche.",
      "typeToSearch": "Saisissez votre recherche",
      "enterUserEmail": "Saisissez l'adresse e-mail de l'utilisateur"
    },
    "updating": "Mise à jour",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Utiliser le modèle"
    },
    "validEmail": {
      "andYouCan": "Et vous pouvez",
      "as": "comme",
      "canReverify": "Vous pouvez revérifier votre e-mail",
      "emailIs": "Cet e-mail est",
      "emailMarkedAs": "Cet email a été marqué comme",
      "markedAsInvalid": "Cet email est marqué comme",
      "notVerified": "Non vérifié",
      "reverifyHere": "Revérifiez ici",
      "verifyHere": "Vérifiez ici"
    },
    "will_give_you_about": "Je vais vous donner environ",
    "checkout": {
      "confirm": "Confirmer",
      "cardInformation": "Informations de carte",
      "cardNumberInvalid": "Votre numéro de carte n'est pas valide.",
      "commitment": "engagement",
      "paymentConsent": "En confirmant, vous autorisez LeadConnector à débiter votre carte pour ce paiement.",
      "subscriptionConsent": "En confirmant votre abonnement, vous autorisez LeadConnector à débiter votre carte pour ce paiement et les paiements futurs de cet abonnement.",
      "endingIn": "finissant par",
      "month": "mois",
      "pay": "Payer",
      "payWithCard": "payer par carte",
      "paymentBeingProcessed": "Le paiement est en cours de traitement. Merci de ne pas recharger ou appuyer sur le bouton retour",
      "proceedWithExistingCard": "Continuer avec la carte en cours",
      "proceedWithNewCard": "Continuer avec une nouvelle carte",
      "purchase": "achater",
      "subscribe": "S’abonner",
      "subscribeTo": "S'abonner à",
      "pleaseUpdateCardDetails": "Veuillez mettre à jour les détails de la carte",
      "zip": "code postal",
      "retry": "réessayer",
      "initialChargesProrated": "Les frais initiaux sont calculés au prorata et la facturation régulière commencera à partir de",
      "youWillBeChargedFor": "Vous serez facturé pour",
      "days": "jours",
      "rightNowForPeriodTill": "dès maintenant pour la période allant jusqu'au",
      "startGettingChargedFullAmount": "et commencez à être facturé du montant total de",
      "perMonthStartingFrom": "/mois à partir du",
      "nameOnCard": "Nom du titulaire",
      "somethingWentWrong": "Une erreur s'est produite",
      "errorImg": "img erreur",
      "networkError": "Erreur réseau, veuillez réessayer plus tard",
      "paymentCouldNotBeProcessed": "Le paiement n'a pas pu être traité. Veuillez essayer d'ajouter une carte à nouveau."
    },
    "deleteLocation": {
      "back": "Retour",
      "delete": "Supprimer",
      "completeStepsToDelete": "Vous devez réaliser quelques étapes simples pour supprimer cet emplacement",
      "alsoCloseAssociated": "Également étroitement associé",
      "scheduling": "Planification…",
      "subAccountAndDeletePhoneNumbers": "sous-compte et supprimez tous les numéros de téléphone",
      "somethingWentWrongTryAgain": "Une erreur s'est produite... Veuillez réessayer plus tard",
      "deleteSubAccount": "Supprimer le sous-compte",
      "scheduleForDeletion": "Calendrier de suppression"
    },
    "productRebilling": {
      "enableRebilling": "Activer la refacturation",
      "ratesMayDifferUK": "Les tarifs peuvent différer selon la région. Les calculs indiqués tiennent compte des tarifs pour le Royaume-Uni,",
      "examplePricingGpt4oMini": "Exemple de tarification – GPT-4o Mini",
      "input": "Entrée",
      "output": "Résultat",
      "supportDoc": "document d'assistance",
      "unsavedChanges": "Modifications non enregistrées",
      "to": "à",
      "chargedToCustomerLower": "Facturé au client",
      "model": "Modèle",
      "profit": "Bénéfice",
      "saving": "Enregistrement…",
      "type": "Type",
      "updating": "Mise à jour…",
      "clickHere": "Cliquez ici",
      "chargedToCustomer": "Facturé au client",
      "enabling": "Activation en cours...",
      "forMoreDetails": "pour plus d’informations.",
      "tenDollarsWillGive": "10 $ vous donneront environ",
      "yourCost": "Votre coût",
      "seeHow": "Découvrez comment",
      "clientCompanyBillingPage": "page de facturation de l'entreprise du client",
      "connectStripeToEnable": "Pour activer la refacturation, vous devez connecter votre compte Stripe sur",
      "companyStripeIntegrationPage": "page d'intégration Stripe de l'entreprise",
      "enterClientCardInfo": "Pour activer la refacturation, vous devez saisir les informations de carte bancaire de votre client sur",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(pour 750 000 mots)",
      "words": "mots",
      "yourCostLower": "Vos frais",
      "and": "et",
      "or": "ou",
      "minimumMustBeBetween": "Le minimum doit être compris entre",
      "upgradeToAgencyPro": "passer à Agence Pro",
      "planToSetMargins": "prévoir de définir des marges"
    },
    "m": "m",
    "label": "Étiquette",
    "company_email_": "E-mail de l'entreprise (",
    "me_": "Moi (",
    "automation_type": "Type d’automatisation",
    "calendar_groups": "Groupes de calendriers",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Aucun produit n'est disponible.",
    "selectProduct": "Sélectionnez un produit"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Les messages {product} supplémentaires ne seront pas facturés aux sous-comptes. Pour refacturer le client, activez le mode SaaS et la fonction de refacturation.",
      "agreementPrefix": "J'accepte d'activer",
      "agreementSuffix": "pour ce client sans revente et je reconnais que je serai facturé(e)",
      "buildResellerOffer": "Créer l'offre de revente",
      "deployDirectlyDescription": "Utilisez cette option si vous proposez {product} dans le cadre de votre offre ou si vous souhaitez facturer votre client séparément",
      "deployPrefix": "Déployer",
      "directlySuffix": "Directement",
      "learnMore": "En savoir plus.",
      "offerPrefix": "Offre",
      "resellPrefix": "Revendre",
      "resellingPrefix": "Revente",
      "subscriptionRestriction": "Impossible de modifier le paramètre, car l'emplacement est déjà abonné",
      "zero": "0",
      "highlevelPrice": "Prix HighLevel",
      "howDoesItWork": "Comment cela fonctionne-t-il ?",
      "payNowButton": "Payer maintenant",
      "priceValidationError": "Le prix doit être supérieur ou égal à celui de HighLevel",
      "saving": "Enregistrement",
      "yourPrice": "Votre prix",
      "yourProfit": "Votre bénéfice"
    },
    "whatsapp": {
      "inboundMessagesInfo": "La réception de messages entrants et la réponse avec du texte libre dans la fenêtre de conversation sont gratuites. Des frais de traitement supplémentaires seront facturés pour l'envoi de messages de modèles sortants.",
      "whatsappLocation": "Emplacement WhatsApp"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Impossible de modifier la configuration, car l'emplacement est déjà abonné",
        "offerPrefix": "Offre ",
        "poweredByPrefix": " (Optimisé par Search Atlas)",
        "toggleTooltipDisable": "Cette action désactivera l'outil SEO pour tous les sous-comptes.",
        "toggleTooltipEnable": "Cette action activera l'outil SEO pour tous les sous-comptes.",
        "resellPrefix": "Revendre ",
        "howDoesItWork": "Comment cela fonctionne-t-il ?",
        "buildResellerOffer": "Créer l'offre de revente",
        "yourPrice": "Votre prix",
        "highlevelPrice": "Prix HighLevel",
        "yourProfit": "Votre bénéfice",
        "priceValidationError": "Le prix doit être supérieur ou égal à celui de HighLevel",
        "saving": "Enregistrement",
        "save": "Enregistrer",
        "deployPrefix": "Déployer ",
        "directlySuffix": "Directement",
        "deployDirectlyDescription": "Utilisez cette option si vous proposez le SEO dans le cadre de votre offre ou si vous souhaitez facturer votre client séparément",
        "agreementPrefix": "J'accepte d'activer ",
        "agreementSuffix": " pour ce client sans revente et je reconnais que je serai facturé(e)",
        "payNowButton": "Payer maintenant",
        "subscriptionCreating": "L'abonnement est en cours de création.<br/>Merci de ne pas actualiser la page ou cliquer sur le bouton Retour",
        "subscriptionCreated": "Abonnement créé avec succès. Veuillez patienter.",
        "subscriptionError": "Impossible de créer l'abonnement, veuillez contacter l'assistance"
      },
      "adManager": {
        "subscriptionRestriction": "Impossible de modifier le paramètre, car l'emplacement est déjà abonné",
        "offerPrefix": "Offre ",
        "resellingPrefix": "Revente",
        "resellPrefix": "Revendre ",
        "howDoesItWork": "Comment cela fonctionne-t-il ?",
        "bookACall": "Réserver un appel",
        "bookCallTooltip": "Programmez un appel avec notre équipe pour en savoir plus sur le gestionnaire de campagne",
        "buildResellerOffer": "Créer l'offre de revente",
        "yourPrice": "Votre prix",
        "highlevelPrice": "Prix HighLevel",
        "yourProfit": "Votre bénéfice",
        "priceValidationError": "Le prix doit être supérieur ou égal à celui de HighLevel",
        "loading": "Chargement...",
        "save": "Enregistrer",
        "deployPrefix": "Déployer ",
        "directlySuffix": "Directement",
        "deployDirectlyDescription": "Utilisez cette option si vous proposez Ad Manager dans le cadre de votre offre ou si vous souhaitez facturer votre client séparément",
        "agreementPrefix": "J'accepte d'activer ",
        "agreementMiddle": " pour ce client sans revente et je reconnais que je serai facturé(e)",
        "agreementSuffix": " par mois",
        "stripeNotConnectedLocationWarning": "Stripe n'est pas connecté pour cet emplacement. Veuillez connecter Stripe pour activer cette fonctionnalité.",
        "stripeNotConnectedAgencyWarning": "Stripe n'est pas connecté pour cette agence. Veuillez connecter Stripe pour activer cette fonctionnalité.",
        "underSubAccountReselling": "par mois dans le cadre de la revente de sous-comptes"
      },
      "dedicatedIp": {
        "description": "Cela vous permet de refacturer une adresse IP dédiée (utilisée pour l'envoi d'e-mails sortants) à vos clients et d'inclure une majoration",
        "numberOfIps": "Nombre d'adresses IP :",
        "yourCost": "Votre coût :",
        "chargedToCustomer": "Facturé au client :",
        "profit": "Bénéfice :",
        "monthlyProfit": "Bénéfice mensuel :",
        "loading": "Chargement…",
        "save": "Enregistrer",
        "revokeDedication": "Révoquer l'autorisation",
        "revokeDescription": "Utilisez cette option pour arrêter de proposer de nouvelles adresses IP dédiées à votre client sans frais.",
        "existingSubscriptionsNote": "Les abonnements à des adresses IP en cours ne seront pas affectés",
        "revoke": "Révoquer",
        "provideDirectlyTitle": "Fournissez une adresse IP dédiée pour l'envoi direct d'e-mails",
        "provideDirectlyDescription": "Utilisez cette option pour donner une adresse IP dédiée à votre client sans la lui facturer",
        "agreeToProvideText": "J'accepte de fournir l'adresse IP de ce client sans vente incitative",
        "acknowledgeChargeText": "Je reconnais que le montant de 59 $/mois par adresse IP me sera facturé",
        "agree": "Accepter",
        "yourMonthlyCost": "Vos frais d'adresse IP mensuels :",
        "monthlyChargeToCustomer": "Frais mensuels de votre client :",
        "resellingSettingsSuffix": " Paramètres de revente",
        "ipRebillingAmount": "Montant de refacturation IP"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Je confirme que j'en ai parlé avec mon client et que j'ai obtenu son accord",
        "confirmQuestion": "Voulez-vous vraiment désactiver le mode SaaS pour ce compte ?",
        "dataLossAck": "Je reconnais que toutes les données de refacturation, les données d'abonnement SaaS et le registre des transactions seront perdus",
        "disableSaas": "Désactiver SaaS",
        "irreversibleAck": "Je comprends que cette action est irréversible"
      },
      "confirmationModal": {
        "cancelSubscription": "Résiliez également l'abonnement SaaS associé",
        "confirmDisable": "Confirmer la désactivation",
        "confirmQuestion": "Voulez-vous vraiment désactiver le mode SaaS ?",
        "somethingWentWrong": "Une erreur s'est produite... Veuillez réessayer plus tard"
      },
      "processingModal": {
        "closeNow": "Fermer maintenant",
        "closeWindowInstructions": "Vous pouvez fermer cette fenêtre, nous vous informerons par e-mail une fois le processus terminé.",
        "title": "Le SaaS sera bientôt désactivé pour cet emplacement.",
        "typicalTime": "Cela prend généralement 10 minutes ou moins."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Ajouter un champ personnalisé",
      "fieldKey": "Clé de champ",
      "fieldName": "Nom du champ",
      "idWillBeAdded": "L'ID sera ajouté après la création de la raison de perte",
      "lostReasonID": "ID de la raison de la perte",
      "placeholder": "Paramètre fictif"
    },
    "locationMailGun": {
      "bccAddress": "Adresse BCC",
      "clearError": "Effacer l'erreur",
      "deleteConfirmationMessage": "Cette action supprimera la connexion Mailgun.",
      "deleteConnection": "Supprimer la connexion",
      "domain": "Domaine",
      "domainsAvailable": "{count} disponible",
      "invalidApiKey": "Clé API invalide",
      "selectDomain": "Sélectionnez un domaine"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Échec lors de la récupération des informations de la transaction",
      "transactions": "Transactions"
    },
    "noShowSMS": {
      "smsWithImage": "SMS de rendez-vous non honoré avec image",
      "title": "Personnaliser le SMS d'avis"
    },
    "optOut": {
      "addKeywords": "Veuillez inclure l'un des mots-clés de désinscription suivants : STOP, STOPALL, UNSUBSCRIBE, CANCEL, END ou QUIT.",
      "customizeTitle": "Personnaliser le message de désinscription",
      "disableConfirm": "Voulez-vous vraiment désactiver le message de désinscription ?",
      "disableOptOut": "Désactiver la désinscription",
      "disableTitle": "Voulez-vous désactiver le message de désinscription ?",
      "optInConfirmClient": "Je confirme que je m'assurerai que les SMS seront uniquement envoyés aux contacts qui ont donné leur consentement.",
      "quickTipMessage": "Le message initial que vous envoyez à une personne doit inclure l'un des mots-clés de désinscription standard suivants : STOP, STOPALL, UNSUBSCRIBE, CANCEL, END ou QUIT.",
      "reallyDisableConfirm": "Voulez-vous vraiment désactiver le message de désinscription ?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Corps de la requête POST",
        "requestQueryParameters": "Paramètres de requête",
        "responseBody": "Corps de la réponse"
      },
      "logs": "Journaux",
      "logsPage": {
        "clearAll": "Effacer tout",
        "loadMore": "Charger plus",
        "price": "Prix",
        "product": "Produit",
        "tabsAriaLabel": "Onglets de journaux de paiement"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Ajoutez le texte général au",
      "beginning": "Début",
      "complianceConfirm": "Je confirme que je veillerai à ce que tous les SMS envoyés à partir de ce compte soient conformes à la politique actuelle.",
      "customizeTitle": "Personnaliser le texte général",
      "disableConfirm": "Êtes-vous sûr de vouloir désactiver SenderID ?",
      "disableSenderID": "Désactiver SenderID",
      "disableTitle": "Désactiver SenderID ?",
      "end": "Fin",
      "pleaseAdd": "Veuillez ajouter {text} comme indiqué dans l'astuce rapide.",
      "quickTipMessage": "Le message initial que vous envoyez à une personne doit inclure les informations d'identification de l'expéditeur. Veuillez ajouter {text} dans la zone de texte général.",
      "reallyDisableConfirm": "Êtes-vous vraiment sûr de vouloir désactiver SenderID ?",
      "senderID": "ID de l'expéditeur"
    },
    "shopify": {
      "adminApiAccessToken": "Jeton d'accès à l'API Admin",
      "apiTokenRequired": "Un jeton d'accès API est requis",
      "checkDocumentation": "Veuillez consulter cette documentation pour plus d'informations",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Jeton d'accès personnalisé à l'API App",
      "deleteWarning": "La suppression de cet élément supprimera la connexion existante.",
      "existStoreAlertTitle": "L'intégration de la boutique Shopify existe déjà",
      "integration": "Intégration de Shopify",
      "integrationHealth": "Santé de l'intégration",
      "orders": "Commandes",
      "scopePermissionsWarning": "Assurez-vous que votre application bénéficie des autorisations marquées d'une croix rouge.",
      "scopes": "Portées",
      "scopesDescription": "Les portées d'autorisation sont nécessaires pour accéder aux informations de Shopify. En raison de changements récents dans Shopify, la fonction read_customers est maintenant nécessaire pour obtenir les informations complètes des clients, en raison des données clients protégées par Shopify.",
      "storeConnectedMessage": "La boutique Shopify est déjà connectée au sous-compte {locationName}",
      "storeNameHelp": "Le nom de votre boutique est situé dans l'URL de votre compte Shopify, après https:// et avant .myshopify.",
      "storeNameLabel": "Nom de votre boutique Shopify",
      "storeNamePlaceholder": "nom de la boutique",
      "storeNameRequired": "Le nom de la boutique est obligatoire",
      "typeRemoveConfirm": "Tapez « REMOVE » pour confirmer",
      "webhooks": "Webhooks",
      "webhooksDescription": "Pour recevoir tous les événements de Shopify, nous devons enregistrer ces webhooks Shopify au cours du processus d'intégration. Ces webhooks sont essentiels pour assurer le bon fonctionnement des fonctionnalités de Shopify."
    },
    "slack": {
      "accountConnected": "compte connecté",
      "accountsConnected": "comptes connectés",
      "accountsList": "Liste de tous les comptes Slack",
      "added": "Ajouté {date}.",
      "connectChannel": "Connectez votre canal Slack",
      "description": "Recevez des notifications instantanées sur votre canal Slack. Cliquez sur « Connecter » pour ajouter un canal Slack.",
      "manage": "Gérer",
      "manageAccounts": "Gérez les comptes Slack",
      "noIntegrations": "Aucune intégration Slack n'a été trouvée."
    },
    "smtpService": {
      "addFirstService": "Ajoutez votre premier SMTP service.",
      "addService": "Ajouter un service",
      "bccEmails": "Adresses e-mail en BCC",
      "cannotDeleteDefaultProvider": "Vous ne pouvez pas supprimer le fournisseur par défaut.",
      "contactDeveloper": "Contactez le développeur de cette application.",
      "customProvider": "Fournisseur personnalisé",
      "defaultProvider": "Fournisseur par défaut",
      "defaultProviderUpdated": "Le fournisseur par défaut a été mis à jour avec succès !",
      "emailDomain": "Email / Domaine",
      "emailService": "Services de messagerie",
      "enableReplyTracking": "Activer le suivi des réponses",
      "forwardToAssignedUser": "Transférer à l'utilisateur assigné",
      "providerType": "Type de fournisseur",
      "smtpConnectionIssue": "Il y a un problème avec cette connexion SMTP. Veuillez reconnecter cette intégration.",
      "useLcEmailMessage": "Utilisez LC Email pour envoyer des e-mails à votre agence et à vos clients."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Publication automatique activée",
      "dailyPostLimit": "Limite quotidienne de publications",
      "directoriesDescription": "Lorsque vous recevez un nouvel avis, nous le publions automatiquement dans plus de 80 annuaires en ligne qui contribuent automatiquement au développement de votre marque et à votre SEO.",
      "directoriesTitle": "80+ annuaires et sites web",
      "fivePosts": "5 publications",
      "fiveStars": "5 étoiles",
      "fourPosts": "4 publications",
      "fourStars": "4 étoiles",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Personnalisez le moment et la manière dont vos avis sont automatiquement publiés sur chacun de vos réseaux sociaux.",
      "manageSettingsTitle": "Gérer vos paramètres de publication sur les réseaux sociaux",
      "postReviewsForRating": "Publiez les avis pour cette évaluation par étoiles ou une valeur plus élevée.",
      "searchEngines": "Moteurs de recherche",
      "threePosts": "3 publications",
      "threeStars": "3 étoiles",
      "title": "Publication sur les réseaux sociaux"
    },
    "tags": {
      "addNewTag": "Ajouter une nouvelle étiquette",
      "allTags": "Toutes les étiquettes",
      "deletedTags": "Étiquettes supprimées",
      "here": "ici.",
      "newTag": "Nouvelle étiquette",
      "noTagsYet": "Aucun mot-clé à afficher pour le moment",
      "searchTags": "Rechercher des mots-clés",
      "viewDeletedTags": "Vous pouvez visualiser et restaurer les étiquettes supprimées sur la page Journaux d'audit"
    },
    "templateMessage": {
      "addEmailTemplate": "Ajouter un modèle d'e-mail (extrait)",
      "addTemplate": "Ajouter un modèle (extrait)",
      "addTextTemplate": "Ajouter un modèle de texte (extrait)",
      "body": "Corps",
      "deleteTemplateConfirmation": "Voulez-vous vraiment supprimer ce modèle ?",
      "templatesCount": "{count} modèles",
      "title": "Modèles de message (extraits)"
    },
    "unsubscribe": {
      "content": "Contenu",
      "contentTooltip": "Le contenu de ce message sera automatiquement ajouté à tous les e-mails.",
      "customizeTitle": "Personnaliser le contenu de désinscription",
      "disableConfirm": "Voulez-vous vraiment désactiver le lien de désinscription dans l'e-mail ?",
      "disableTitle": "Désactiver le lien de désinscription ?",
      "disableUnsubscribe": "Désactiver l'option de désinscription",
      "pleaseAddTag": "Veuillez inclure la balise /*unsubscribe*/",
      "reallyDisableConfirm": "Voulez-vous vraiment désactiver le lien de désinscription figurant dans les e-mails ?",
      "subscribedConfirm": "Je confirme que les e-mails seront envoyés uniquement aux contacts qui se sont inscrits pour en recevoir.",
      "subscribedConfirmClient": "Je confirme que je veillerai à ce que les e-mails ne soient envoyés qu'aux contacts qui se sont abonnés pour recevoir des e-mails.",
      "suspensionWarning": "Une activité non conforme peut entraîner la suspension des fonctionnalités e-mail de votre compte.",
      "tagRequirement": "L'e-mail initial que vous envoyez à une personne doit inclure la balise /*unsubscribe*/."
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Ceci est le message vocal par défaut pour tous les numéros Twilio de l'emplacement, sauf s'il est personnalisé sous",
      "forwardCallsToWebApp": "Transférez les appels vers l'application web",
      "forwardCallsToMobileApp": "Transférez les appels vers l'application mobile",
      "dedicatedNumberRequiredInfo": "Ceci n'est obligatoire que si les utilisateurs ont besoin d'un numéro dédié. Non requis pour la messagerie vocale ou pour acheminer l'appel vers l'utilisateur qui a été attribué.",
      "voicemailMessageInfo": "Ce message vocal sera diffusé à la place de celui de l'opérateur téléphonique. Nous recommandons un délai de 20 secondes ou moins.",
      "noTimeout": "Aucun délai d'attente",
      "10Secs": "10 secondes",
      "20Secs": "20 secondes",
      "voicemailMessageDuration": " Nous enregistrerons un message vocal si l'appel n'est pas pris avant cette durée",
      "saveCallSettings": "Enregistrer les paramètres d'appel"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Lorsque cette étiquette est présente sur le contact, ces messages ne seront PAS livrés à Eliza.",
      "sendToElizaNote": "Par défaut, toutes les conversations seront livrées à Eliza. Si cette étiquette est configurée, <br />alors les nouvelles conversations seront envoyées à Eliza uniquement lorsque cette étiquette est présente sur un contact.<br /> Si les balises Contourner Eliza et Envoyer à Eliza sont toutes deux configurées, seule la balise Envoyer à Eliza sera prise en compte.",
      "permissionNote": "Vos autorisations utilisateur ne sont pas activées pour cette page. <br />Veuillez contacter votre administrateur.",
      "addFAQ": "Ajoutez une FAQ"
    },
    "locationSettings": {
      "ownCardWarning": "N'ajoutez pas votre propre carte aux sous-comptes !",
      "addClientCardWarning": "Veuillez ajouter la carte de votre client (sous-compte) et non la vôtre, car cette carte sera utilisée pour facturer votre client en votre nom.",
      "stripeConnectMissing": "Connexion Stripe manquante",
      "pleaseContactAgencyToAddPaymentMethods": "Veuillez contacter l'agence ({email}) pour ajouter des modes de paiement"
    },
    "integrations": {
      "connectWaveAccount": "Connectez le compte Wave de votre emplacement",
      "connectXeroAccount": "Connectez le compte Xero de votre établissement"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "Le suivi des appels GBP est activé sur un autre sous-compte. Le suivi des appels peut être activé sur un seul sous-compte à la fois.",
      "gbpCallTrackingEnabledOnAnotherPage": "Le suivi des appels GBP est activé sur une autre page ({pageName}). Le suivi des appels peut être activé sur un seul sous-compte et une seule page par emplacement à la fois.",
      "gbpCallsProperlySetup": "Les appels GBP sont correctement configurés et les appels arrivent de",
      "tooManyEditsToPrimaryPhone": "Vous avez apporté trop de modifications au numéro de téléphone principal de cette entreprise. Veuillez réessayer plus tard.",
      "setupTwilioToStartCallTracking": "Configurez Twilio pour commencer le suivi des appels",
      "twoSecondaryNumbersSetupAlready": "Vous avez déjà configuré deux numéros secondaires. Vous ne pouvez pas échanger les numéros",
      "yourAgentIDIs": "Votre identifiant d'agent est"
    },
    "numberPool": {
      "title": "Ce qu'il faut suivre",
      "tracking": {
        "percentComplete": "34 % terminé",
        "searchLower": "recherche"
      },
      "create": {
        "title": "Créer un numéro de suivi"
      }
    },
    "phoneNumbers": {
      "title": "Ce qu'il faut suivre",
      "tracking": {
        "percentComplete": "34 % terminé",
        "heading": "Créer un numéro de suivi"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Saisissez une valeur",
      "selectOption": "* Choisissez une option"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Au moins 1 {filterName} est obligatoire",
      "select": "Sélectionnez {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Horodatage"
    },
    "recordsNav": {
      "clickToReloadList": "Cliquez pour recharger la liste"
    },
    "reviewRequestActions": {
      "emailReviewReq": "Demande d'avis par e-mail",
      "smsReviewReq": "Demande d'avis par SMS",
      "whatsappReviewReq": "Demande d'avis de WhatsApp"
    },
    "smartListFilters": {
      "clearAllFilters": "Effacer tous les filtres",
      "noneFound": "aucun élément trouvé",
      "saveChangesToList": "Enregistrer les modifications du filtre dans cette liste intelligente",
      "saveCombinationAsNew": "Enregistrer l'Intégration de filtres, de colonnes et de tri comme Nouvelle liste Intelligente",
      "saveCurrentAsNew": "Enregistrer les filtres en cours comme nouvelle liste intelligente",
      "searchAndAddFilter": "Rechercher et ajouter un filtre",
      "searching": "recherche en cours...",
      "undoUnsavedChanges": "Annuler les modifications non enregistrées"
    },
    "smsStatsPanel": {
      "smsStats": "Statistiques SMS"
    },
    "manageDuplicates": "Gérez les doublons",
    "emailAction": {
      "attachFiles": "Joindre des fichiers",
      "customValues": "Valeurs personnalisées",
      "triggerLinks": "Liens déclencheurs"
    },
    "atLeastOneRequired": "* Au moins 1 {filterName} est obligatoire",
    "arrayInput": {
      "searchPlaceholder": "Rechercher {filterName}",
      "searching": "Recherche en cours…"
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Erreur lors de la récupération du contenu de l'instantané",
      "overwriteAll": "Écraser tout",
      "skipAll": "Ignorer tout",
      "somethingWentWrongWhileFindingConflicts": "Une erreur est survenue lors de la recherche des conflits",
      "step": "Étape"
    },
    "confirmOverwrite": {
      "confirmButton": "Confirmer l'écrasement",
      "description": "Cette action est irréversible et peut modifier les configurations des campagnes, des opportunités, des entonnoirs, etc. Veuillez confirmer votre action en tapant ce qui suit dans le champ de saisie.",
      "title": "Voulez-vous vraiment écraser les statistiques sélectionnées ?"
    },
    "conflicts": {
      "noConflictsDetected": "Aucun conflit détecté",
      "overwrite": "Écraser"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Ressources trouvées associées",
      "checkingConflicts": "Vérification des conflits",
      "chooseSnapshot": "Sélectionner un instantané",
      "copyingDataNotification": "Copie des données vers les emplacements sélectionnés. Veuillez patienter.",
      "linkedLocations": "Emplacements associés",
      "noConflictsFound": "Aucun conflit n'a été trouvé",
      "notAuthorizedMessage": "Seuls les administrateurs d'agence peuvent effectuer cette action",
      "overwriteConflicts": "Conflits d'écrasement",
      "pickSnapshot": "Sélectionner un instantané",
      "response": "Réponse",
      "selectAssetsToPush": "Sélectionner les ressources à transférer",
      "selectLocationsToUpdate": "Sélectionner les emplacements à mettre à jour",
      "snapshotNotAuthorized": "Cet instantané n'est pas autorisé pour cet emplacement",
      "snapshotNotSelected": "Instantané non sélectionné"
    },
    "share": {
      "agencyRestrictedLink": "Lien privé de l'agence",
      "deleteShareLink": "Supprimer le lien de partage",
      "editShareLink": "Modifier le lien de partage",
      "permanentLink": "Lien permanent",
      "subaccountRestrictedLink": "Lien privé du sous-compte"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Ajouter une virgule (<span class='text-base font-bold'> , </span>) après chaque numéro de relation)",
      "addCommaAfterEachSubAccount": "(Ajouter une virgule (<span class='text-base font-bold'> , </span>) après chaque ID de sous-compte)",
      "atLeast1EmailRequired": "Au moins une adresse e-mail est obligatoire.",
      "emailShareLink": "Lien de partage par e-mail",
      "enterOnePerLine": "(saisissez-en une par ligne)",
      "errorGettingLink": "Une erreur s’est produite lors de l'obtention du lien, veuillez réessayer plus tard.",
      "getAgencyRestrictedLink": "Obtenir un lien réservé à l'agence",
      "getLink": "Obtenir le lien",
      "getOneTimeLink": "Obtenir un lien de partage unique",
      "getPermanentLink": "Obtenir un lien permanent",
      "getSubAccountRestrictedLink": "Obtenir un lien réservé au sous-compte",
      "shareType": "Type de partage",
      "title": "Partager l'instantané"
    },
    "snapshot": {
      "copySnapshotID": "Copier l'identifiant de l'instantané",
      "deleteSnapshot": "Supprimer l'instantané",
      "editSnapshot": "Modifier l'instantané",
      "pushUpdate": "Pousser la mise à jour vers les comptes liés",
      "refreshSnapshot": "Actualiser l'instantané"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Ajouter une virgule après chaque numéro de relation)",
      "addCommaAfterEachSubAccount": "(Ajouter une virgule après chaque ID de sous-compte)",
      "title": "Actualiser le lien de partage"
    }
  },
  "socialMedia": {
    "engagement": "Engagement",
    "potentialReach": "Portée potentielle",
    "storiesCreated": "Stories créées",
    "recentPosts": "Publications récentes",
    "notConnected": "Non connecté (Connectez-vous maintenant !)",
    "totalAudience": "Audience totale",
    "activeAudience": "Audience active",
    "socialMediaOverview": "Aperçu des réseaux sociaux"
  },
  "suspendModal": {
    "currentStatus": "Statut actuel de l'abonnement : en pause",
    "instructions": "Vous devez réaliser quelques étapes simples pour {action} ce sous-compte",
    "nextBillingDate": "Jour de facturation suivant :",
    "noKeepCharging": "Non, continuer à facturer le client.",
    "pauseSubscriptionQuestion": "Voulez-vous également suspendre l'abonnement avec le sous-compte ?",
    "resumeSubAccount": "Réactiver le sous-compte",
    "resuming": "Reprise...",
    "saasSubscriptionActive": "Ce sous-compte dispose d'un abonnement SaaS actif.",
    "saasSubscriptionResumed": "L'abonnement SaaS de ce compte sera réactivé.",
    "yesPause": "Oui, suspendre l'abonnement"
  },
  "table": {
    "perPageOptions": {
      "5": "5 par page",
      "10": "10 par page",
      "15": "15 par page",
      "20": "20 par page",
      "25": "25 par page",
      "50": "50 par page",
      "100": "100 par page"
    },
    "filterPlaceholder": "Rechercher...",
    "emptyText": "Aucun enregistrement trouvé",
    "loading": "Chargement…",
    "showingEntries": "Affichage de {from} à {to} sur {total} entrées",
    "noEntriesToShow": "Aucune entrée à afficher"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Chargement des données de compte…",
      "toContinueWith": "pour continuer avec"
    },
    "switcherModal": {
      "comingSoon": "À venir !",
      "multiLocationMessage": "Cette fonction n'est actuellement disponible que pour les comptes individuels. Nous travaillons dur pour que cette fonctionnalité soit bientôt disponible pour les comptes multi-emplacements."
    },
    "importedMessage": "{productName} importé ! Naviguez vers la bibliothèque de modèles et trouvez-le sous l'onglet de {productName}.",
    "permissionErrorMsg": "Cette option n'est disponible que sur des forfaits plus élevés. Mettez à niveau maintenant pour la débloquer.",
    "errors": {
      "sourceDeleted": "Erreur : le modèle source a été supprimé. Il n'est plus disponible. Veuillez vérifier le statut du modèle ou contacter la source pour obtenir de l'aide.",
      "sourceDraft": "Erreur : le modèle source a été déplacé vers Brouillon. Veuillez vérifier le statut du modèle ou contacter la source pour obtenir de l'aide.",
      "linkedDeleted": "Erreur : Le modèle source, lié au modèle partagé, a été supprimé. Veuillez vérifier le statut du modèle ou contacter la source pour obtenir de l'aide.",
      "fetchError": "Il semble y avoir une erreur lors de la récupération des détails de {productName}. Veuillez vérifier l'URL ou réessayer.",
      "sameAgency": "Impossible de partager le modèle au sein de la même agence"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "L'action d'ajout d'une étiquette de contact nécessite une étiquette.",
    "addNotesRequiresData": "L'action d'ajout de remarque nécessite des données de remarque.",
    "addTaskRequiresFields": "L'action d'ajout d'une tâche nécessite un titre et une date d'échéance.",
    "addToCampaignRequiresCampaign": "L'action Ajouter à campagne nécessite une campagne.",
    "addToCustomAudienceRequires": "L'action Ajouter à une audience personnalisée nécessite un compte publicitaire et une audience personnalisée.",
    "addTrigger": "Ajouter un déclencheur",
    "anyAction": "Toute Action",
    "anyCondition": "Toute condition",
    "brokenCustomVariables": "Certains champs contiennent des variables personnalisées erronées, veuillez les corriger avant d'enregistrer.",
    "conditionCannotBeEmpty": "Le statut « {condition} » ne peut pas être vide",
    "confirmDeleteTrigger": "Êtes-vous sûr de vouloir supprimer ce déclencheur ?",
    "customDateFieldRequired": "Le filtre du champ de date personnalisée est nécessaire pour le déclencheur de rappel de date personnalisée.",
    "detailPage": {
      "chooseTriggerPlaceholder": "Sélectionner un déclencheur",
      "lastUpdate": "Dernière mise à jour :",
      "loopIdentifiedWarning": "Ce déclencheur a été bloqué à l'état de Brouillon, car il provoque une boucle. Pour activer ce déclencheur, veuillez contacter le service d'assistance.",
      "ruleNotActiveWarning": "Cette règle ne s'appliquera pas tant que vous ne l'aurez pas activée.",
      "triggerCreation": "Création de déclencheur :",
      "triggerDeletedPrompt": "Ce déclencheur a été supprimé ! Voulez-vous le restaurer ?",
      "triggerRunDailyTooltip": "Déclencheur exécuté à 08 h 00 AM Quotidiennement",
      "whatTriggersRule": "Qu'est-ce qui devrait déclencher cette règle ?",
      "whichEventTriggersAutomation": "Quel événement devrait déclencher cette automatisation ?"
    },
    "dndContactRequiresState": "L'action de contact DND nécessite l'activation de l'état DND.",
    "emptyConditionNotAllowed": "Une condition vide n'est pas autorisée.",
    "emptyFieldNotAllowed": "Un champ vide n'est pas autorisé.",
    "executeWebhookRequiresUrl": "L'exécution d'une action webhook nécessite une URL de webhook.",
    "fieldCannotBeEmpty": "{field} ne peut pas être vide",
    "fillRequiredFields": "Veuillez remplir tous les champs obligatoires dans les actions.",
    "googleAdwordsRequiresConversion": "L'action Ajouter à Google Adwords nécessite une conversion.",
    "googleAnalyticsRequiresFields": "L'ajout à Google Analytics nécessite un ID de suivi, un type d'action et une catégorie d'action",
    "membershipGrantOfferRequiresOffer": "L'action d'octroi d'offre d'adhésion nécessite une offre.",
    "membershipRemoveOfferRequiresOffer": "L'action de retrait d'offre d'adhésion nécessite une offre.",
    "newBasicRule": "Nouvelle règle de base",
    "opportunitiesRequirePipeline": "Les actions d'opportunités nécessitent de sélectionner un pipeline.",
    "opportunityLoopWarning": "Ce déclencheur provoquera une boucle de création d'opportunités. Veuillez supprimer l'option Autoriser la duplication des opportunités ou modifier l'étape à laquelle vous faites référence.",
    "removeContactTagRequiresTag": "L'action Supprimer l'étiquette de contact nécessite une étiquette.",
    "removeFromCampaignRequiresCampaign": "L'action Retirer de la campagne nécessite une campagne.",
    "removeFromCustomAudienceRequires": "L'action Supprimer de l'audience personnalisée nécessite un compte publicitaire et une audience personnalisée.",
    "rulesBasedOn": "règles basées sur",
    "selectUserForNotification": "Sélectionnez l'utilisateur pour l'envoi de la notification.",
    "sendEmailRequiresFields": "L'action d'envoi d'un e-mail requiert un expéditeur, une destinataire, un objet et un message.",
    "sendNotificationRequiresFields": "L'action d'envoi de la notification nécessite un titre, un corps et un type d'utilisateur pour l'envoi de la notification.",
    "sendSmsRequiresFields": "L'action d'envoi de SMS nécessite un numéro de téléphone et un message.",
    "stripeMinAmountUSD": "Le montant doit être supérieur ou égal à 50 centimes USD.",
    "stripeRequiresFields": "L'action de prélèvement unique Stripe requiert l'ID du client, le montant et la devise.",
    "thatWillFire": "qui va déclencher",
    "triggerCannotBeEmpty": "Le déclencheur ne peut pas être vide.",
    "updateContactFieldRequires": "Le champ de mise à jour du contact doit avoir au moins 1 champ défini."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Payez ${amount} et abonnez-vous",
      "commitment": "Sans engagement ; résiliez à tout moment",
      "features": {
        "billedOnUsage": "Facturation sur la base de la consommation après dépassement de la limite",
        "externalAI": "Exclut les activités des modèles d'IA externes, qui seront facturées séparément",
        "leadingPricing": "La tarification la plus compétitive du secteur !",
        "monthlyPurchase": "Valable pour un achat par mois",
        "premiumActions": "S'applique aux activités et déclencheurs premium"
      },
      "planDetails": "Informations sur le forfait",
      "subscribeAndSave": "Abonnez-vous et économisez dès aujourd'hui !",
      "title": "${amount} pour {executions} exécutions par mois"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Ce paramètre a été déplacé vers la page des calendriers.",
    "toNavigate": "ici pour naviguer. Cette page sera bientôt supprimée."
  },
  "attribution": {
    "description": "La première interaction est simplement le premier point de contact avec l'utilisateur. Ainsi, si quelqu'un vous a découvert par le biais d'une annonce de recherche payante (PPC), c'est ce canal qui sera crédité en cas de conversion. D'autre part, la dernière interaction serait le dernier canal.",
    "firstInteraction": "Première interaction",
    "lastInteraction": "Dernière interaction",
    "title": "Attribution"
  },
  "campaign": {
    "addEvent": "Ajouter un événement",
    "a2p": {
      "address": {
        "chooseState": "Sélectionner l'état...",
        "city": "Ville*",
        "postalCode": "Code postal*",
        "streetAddress": "Adresse postale*",
        "streetAddressHelper": "Doit être une adresse valide liée à votre entreprise.",
        "title": "Adresse de l'entreprise"
      },
      "addressError": {
        "title": "L'envoi de l'adresse a échoué"
      },
      "authorizedRep": {
        "jobPosition": "Poste*",
        "jobTitle": "Titre du poste*",
        "title": "Informations du représentant autorisé"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Marque à propriétaire unique",
          "point1": "Un seul numéro de téléphone est autorisé",
          "point2": "EIN/SSN/DUNS non requis"
        },
        "solePropCampaign": {
          "heading": "Campagne de propriétaire unique",
          "point1": "Un seul numéro peut être associé à une campagne à propriétaire unique.",
          "point2": "Une fois approuvé, votre numéro par défaut sera automatiquement lié",
          "infoText": "Vous pouvez également mettre à jour le numéro après l'approbation",
          "warningText": "Un seul numéro peut être associé à une campagne à propriétaire unique. Une fois approuvé, votre numéro par défaut sera automatiquement lié. Vous pouvez également mettre à jour le numéro après l'approbation."
        },
        "solePropSubtitle": "Informations sur la marque et la campagne à propriétaire unique",
        "standardBrand": {
          "heading": "4,41 $ - Une fois",
          "point1": "EIN/SSN/DUNS requis",
          "point2": "Plusieurs numéros de téléphone autorisés"
        },
        "standardCampaign": {
          "heading": "16,54 $ - Une fois",
          "point1": "Plus d'un numéro peut être lié à une campagne standard.",
          "point2": "EIN/SSN/DUNS requis",
          "infoText": "Des frais de campagne supplémentaires pouvant aller jusqu'à 12 $ par mois seront appliqués conformément aux règles TCR."
        },
        "standardSubtitle": "Informations sur la marque et la campagne standard",
        "title": "Informations sur la marque et la campagne"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Coordonnées",
          "contactInfoSubtitle": "Il peut s'agir de toute personne pouvant répondre à des questions sur cette marque, le cas échéant. Veuillez noter que vous ne pouvez pas réutiliser les coordonnées d'une marque à l'autre. Chaque marque que vous créez doit avoir des coordonnées uniques.",
          "emailHelper": "N'utilisez pas la même adresse e-mail pour plus de 5 marques.",
          "phoneNumberHelper": "N'utilisez pas le même numéro de téléphone pour plus de 5 marques.",
          "profileName": "Nom de l'entreprise ou vos nom et prénom*",
          "profileNameHelper": "Utilisez le nom légal de l'organisation qui envoie les messages, ou votre propre nom si cette marque n'est pas destinée à une organisation.",
          "nextLoading": "Suivant...",
          "invalidPhoneNumber": "Numéro de téléphone non valide",
          "phoneNumberWithCountryCode": "Numéro de téléphone (avec code de pays)*",
          "phoneNumberRequired": "Le numéro de téléphone est obligatoire.",
          "emailRequired": "Adresse e-mail obligatoire.",
          "profileNameRequired": "Le nom de profil est obligatoire."
        },
        "standard": {
          "businessType": "Type d'entreprise*",
          "legalBusinessName": "Nom légal de l'entreprise*",
          "legalBusinessNameHelper": "Saisissez le nom exact de l'entreprise, tel qu'enregistré auprès du gouvernement et mentionné dans vos documents fiscaux (CP 575). Par exemple, Leadconnector LLC plutôt que Leadconnector.",
          "regionsOfOperations": "Régions d'opérations de l'entreprise*",
          "registrationNumber": "Numéro d'enregistrement de l'entreprise*",
          "registrationNumberHelper": "Numéro utilisé pour identifier votre entreprise. Dans le cas d'un EIN américain, il doit s'agir d'un numéro à 9 chiffres, par exemple 12-3456789.",
          "registrationType": "Type d'ID d'enregistrement d'entreprise*",
          "website": "Site Web de l'entreprise*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Étape {currentStep} sur {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Votre profil d'entreprise a bien été soumis.",
        "startA2P": "Démarrer l'inscription A2P",
        "title": "Profil d'entreprise soumis avec succès",
        "tooltips": {
          "agency": "Les utilisateurs de l'agence peuvent commencer l'enregistrement A2P",
          "location": "Les utilisateurs de l'établissement peuvent commencer l'enregistrement A2P"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Fermer l'exemple",
          "optInKeywords": "Mots-clés d'adhésion*",
          "optInKeywordsHelper": "Longueur maximum : 255 caractères.",
          "optInKeywordsPlaceholder": "Mots clés séparés par une virgule, Exemple : ABONNEMENT, DÉMARRER.",
          "optInMessage": "Message d'adhésion*",
          "optInMessageInfo": "Doit contenir le nom de l'entreprise et le mot-clé de désinscription",
          "optInMessagePlaceholder": "Exemple : Vous avez accepté de recevoir des notifications et des SMS promotionnels de la part de company_name. Répondez STOP si vous souhaitez vous désinscrire à l'avenir.",
          "placeholder": "Exemple : Les utilisateurs finaux s'inscrivent en accédant au site Web https://www.mycompany.com/book et en remplissant leurs coordonnées. Les utilisateurs cochent une case pour accepter de recevoir des notifications et des messages promotionnels de notre part. Les utilisateurs finaux peuvent également envoyer START par SMS au +1 (213) 725-2867.",
          "question": "Comment les utilisateurs finaux consentent-ils à recevoir des messages ?*",
          "seeExample": "Voir l'exemple"
        },
        "messageDetails": {
          "embeddedLink": "Le message comprendra un lien intégré",
          "phoneNumbers": "Les messages contiendront des numéros de téléphone",
          "sampleMessage1Placeholder": "Exemple : Bonjour John ! Je suis Jane de company_name. Notre rendez-vous du 20 juillet à 11 h 00 est confirmé. Veuillez contacter le +1(213) 725-2867 si vous devez reporter votre rendez-vous. Répondez STOP pour vous désinscrire.",
          "sampleMessage2Placeholder": "Exemple : Bonjour Brian ! C'est Jane de company_name. Je constate que vous n'avez pas pu honorer notre rendez-vous. Voulez-vous le reporter ? - https://www.mycompany.com/book. Répondez STOP pour vous désinscrire.",
          "sampleMessageInfo": "Doit inclure le nom du prospect, votre nom, le nom de l'entreprise et la langue de désinscription",
          "subtitle": "Ajouter des messages d'exemple"
        },
        "useCaseDetails": {
          "explainInDetail": "Veuillez fournir une explication détaillée",
          "pickUseCase": "Choisissez un cas d'utilisation de la campagne",
          "solePropLabel": "Propriétaire unique",
          "subtitle": "Saisir les informations et la description de la campagne",
          "useCase": "Cas d'utilisation de campagne*",
          "useCaseDescription": "Description du cas d'utilisation*",
          "useCaseDescriptionPlaceholder": "Exemple : Cette campagne envoie des informations sur les rendez-vous (confirmation et messages de rappel à nos clients une fois qu'ils ont pris rendez-vous avec nous sur notre site Web et qu'ils ont choisi de recevoir des SMS promotionnels et de notification de notre part)."
        }
      },
      "einModal": {
        "disableNoEINText": "Seules les entreprises disposant d'une adresse valide aux États-Unis et au Canada sont autorisées à enregistrer une marque A2P sans numéro d'identification fiscale.",
        "hasEIN": "Oui, l'entreprise que j'enregistre possède un numéro d'identification fiscale (p. ex, EIN, CCN etc.).",
        "infoText": "Vous trouverez votre EIN américain sur votre formulaire CP 575.",
        "noEIN": "Non, l'entreprise que j'enregistre n'a pas de numéro d'identification fiscale (p. ex. EIN, CCN etc.).",
        "question": "L'entreprise que vous enregistrez dispose-t-elle d'un numéro d'identification fiscale (p. ex. EIN, CCN etc.) ?*",
        "title": "Déterminer les besoins de la marque A2P"
      },
      "exampleModal": {
        "examples": "Exemples"
      },
      "otpError": {
        "message": "Un problème est survenu lors de l'envoi du mot de passe à usage unique.",
        "title": "Échec du renvoi du mot de passe à usage unique"
      },
      "otpSuccess": {
        "title": "Votre mot de passe à usage unique a été envoyé avec succès."
      },
      "validation": {
        "cityRequired": "La ville est obligatoire.",
        "countryRequired": "Le pays est obligatoire.",
        "invalidMobileNumber": "Numéro de téléphone mobile non valide",
        "postalCodeRequired": "Le code postal est requis.",
        "stateRequired": "L'État est requis.",
        "streetAddressRequired": "L'adresse postale est requise."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Propriétaire d'agence",
      "agencyOwnerAndAdmins": "Propriétaire d'agence et administrateurs",
      "contactAgencyOwner": "Si vous avez besoin d’aide, veuillez contacter votre",
      "firstPromoterAccessMessage": "Ce rapport FirstPromoter est uniquement accessible par les",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Impossible de trouver un partenaire correspondant à vos filtres. Cliquez",
      "paymentDetailsAccessMessage": "Cette section sur les détails du paiement n'est accessible et modifiable que par le",
      "toApplyPartner": "pour faire une demande d’adhésion au programme de partenariat."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Document"
      },
      "loading": "Chargement",
      "legalBusinessNameHelper": "Saisissez le nom exact de l'entreprise, tel qu'enregistré auprès du gouvernement et mentionné dans vos documents fiscaux (CP 575). Par exemple, Leadconnector LLC plutôt que Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Cliquez <span class='font-semibold'>sur Ouvrir HighLevel</span> pour lancer l’application de bureau.<br>Cela ne fonctionne pas ? Vous pouvez également <a href=\"/\" class='!text-blue-700 hover:underline'>utiliser HighLevel dans votre navigateur</a>",
        "launchingTitle": "Lancement de HighLevel Desktop",
        "launchButtonText": "Ouvrir HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Cliquez <span class='font-semibold'>sur Ouvrir LeadConnector</span> pour lancer l’application de bureau.<br>Cela ne fonctionne pas ? Vous pouvez également <a href=\"/\" class='!text-blue-700 hover:underline'>utiliser LeadConnector dans votre navigateur</a>",
        "launchingTitle": "Lancement de LeadConnector Desktop",
        "launchButtonText": "Ouvrir LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Sélectionnez une action",
        "destination": "Destination",
        "removeFromAllCampaigns": "Cette action supprimera les prospects de toutes les campagnes, à l'exception de la campagne en cours.",
        "triggerLinks": "Liens déclencheurs"
      },
      "importTemplate": {
        "errorImporting": "Erreur lors de l'importation du modèle",
        "importTemplate": "Importer un modèle",
        "importing": "Importation",
        "title": "Importer le modèle {entityName}",
        "unnamedEntity": "Copie sans nom de {entityName}"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "sous",
          "confirmByTyping": "Veuillez confirmer en saisissant",
          "confirmWord": "CONFIRMER",
          "existingNotMoved": "Si votre client a déjà une configuration Mailgun ou SMTP, elle ne sera pas transférée.",
          "notNow": "Pas maintenant",
          "pricingInfo": "LC Email est moins cher que Mailgun et vous coûtera environ 0,68 $ pour 1 000 e-mails.",
          "setAsDefault": "Définissez LC Email comme fournisseur par défaut pour votre agence et vos clients qui n'ont pas encore Mailgun ou SMTP.",
          "thisWill": "Cela aura pour effet de :",
          "title": "Vous migrez vers Lead Connector Email",
          "useLcEmail": "Utilisez LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Glissez ou déposez des médias ici",
        "editPost": "Modifier la publication",
        "enterText": "Saisissez le texte ici",
        "exampleComment": "Très cool ! J'ai hâte !",
        "exampleName": "Test Tech",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Besoin d'un avis ?",
        "network": "Réseau",
        "photo": "photo",
        "previewPost": "Aperçu de la publication",
        "selectNetwork": "Sélectionnez un réseau social",
        "sizeExample": "245 ko",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Vous avez créé un jeu de {count} numéros pour suivre les visiteurs sur votre site. <br />Vos appels seront transférés vers",
          "createdSingle": "Vous avez créé {count} numéro pour suivre les visiteurs de votre site web. <br />Vos appels seront transférés vers",
          "percentComplete": "100 % complété"
        },
        "create": {
          "correctErrors": "Corrigez ces erreurs !",
          "forwardHelp": "Indiquez-nous quel téléphone doit sonner lorsque le client appelle votre numéro de suivi. Il s'agit généralement du numéro de téléphone principal de votre entreprise. Exemple : 404-555-1212",
          "heading": "Catégorie de numéros et transfert d'appels",
          "nameHelp": "Le « {name} » est la manière dont nous désignerons ce numéro de suivi dans votre compte. Choisissez un nom bref et facile à retenir.",
          "newTrackingNumbers": "nouveaux numéros de suivi.",
          "nextTracking": "Suivant : options de suivi",
          "percentComplete": "50 % complété",
          "pleaseConfirm": "Veuillez confirmer :",
          "poolSize": "Taille de la catégorie",
          "poolSizeError": "Saisissez une taille comprise entre 4 et 30 numéros de suivi.",
          "poolSizeHelp": "La taille de votre réserve de numéros détermine le nombre de visiteurs simultanés que nous pouvons suivre sur votre site web à tout moment. La taille de votre catégorie doit correspondre à un quart du trafic horaire maximal indiqué dans Google Analytics, avec un minimum de 4 numéros.",
          "swappingHelp": "Dites-nous quel numéro de téléphone nous devons permuter sur le site web. Par exemple : 404-555-1212",
          "swappingNumber": "Numéros de permutation",
          "validationError": "Une erreur s'est produite lors de la validation du formulaire"
        },
        "features": {
          "activateNumber": "Activer le numéro",
          "address": "Adresse {type}",
          "addressHelp": "L'achat de numéros pour certains pays requiert une adresse. Veuillez contacter l'assistance si vous avez besoin d'aide pour ajouter une adresse.",
          "heading": "Fonctionnalités des numéros",
          "leaveBlank": "Laisser vide si aucun message",
          "recordingDescription": "Activez l'enregistrement des appels et diffusez un court message à l'appelant.",
          "recordingHelp": "Certaines juridictions exigent que les deux parties consentent à l'enregistrement d'une conversation. Pour faciliter le respect de ces lois, vous pouvez activer un message d'accueil informant l'appelant que l'appel peut être enregistré.",
          "whisperDescription": "Un court message est diffusé avant l'appel. L'appelant ne peut pas entendre ce message."
        },
        "tracking": {
          "heading": "Options de suivi",
          "nextCreatePool": "Suivant : Générer une catégorie",
          "percentComplete": "34 % terminé",
          "searchLower": "recherche"
        },
        "whatToTrack": {
          "heading": "Que voulez-vous suivre sur votre site web ?",
          "trackCampaign": "Suivez une campagne marketing",
          "trackCampaignDescription": "Créez un numéro de téléphone unique qui suit tous les appelants d'une seule campagne marketing.",
          "trackVisitor": "Suivre l’activité des visiteurs",
          "trackVisitorDescription": "Créez plusieurs numéros qui mettent en corrélation les appels avec les visiteurs du site web, les mots-clés CPC, et plus encore."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "Cliquez ici pour actualiser.",
      "issuesLoadingApp": "Si vous avez des difficultés à charger l'application",
      "loadingFreshData": "Chargement des nouvelles données...",
      "loadingNewSubAccountData": "Chargement des nouvelles données de sous-compte..."
    },
    "login": {
      "bySigningInYouAgree": "En vous connectant, vous acceptez nos <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Conditions générales d'utilisation</a>",
      "newPasswordSent": "Un nouveau mot de passe est envoyé à votre adresse e-mail."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Par :"
        },
        "affiliates": {
          "partnerBadgeAlt": "Badge de partenaire"
        },
        "checkout": {
          "cardInformation": "Informations de carte",
          "cardNumberInvalid": "Votre numéro de carte n'est pas valide.",
          "commitment": "engagement",
          "consentOneTime": "En confirmant, vous autorisez LeadConnector à débiter votre carte pour ce paiement.",
          "consentSubscription": "En confirmant votre abonnement, vous autorisez LeadConnector à débiter votre carte pour ce paiement et les paiements futurs de cet abonnement.",
          "defaultIntervalCount": "1",
          "endingIn": "finissant par",
          "errorImageAlt": "Illustration d'erreur",
          "intervalSuffix": "(s)",
          "month": "mois",
          "pay": "Payer",
          "payWithCard": "payer par carte",
          "paymentProcessing": "Le paiement est en cours de traitement. Merci de ne pas actualiser la page ou cliquer sur le bouton Retour",
          "proceedWithExistingCard": "Continuer avec la carte en cours",
          "proceedWithNewCard": "Continuer avec une nouvelle carte",
          "prorationDetails": "Vous serez facturé pour {days} jours dès maintenant pour la période allant jusqu'au {billingEnd}, et commencerez à être facturé du montant total de ${amount}/mois à partir du {billingDate}.",
          "prorationMessage": "Les frais initiaux sont calculés au prorata et la facturation régulière commencera à partir de {billingDate}",
          "purchase": "achat",
          "subscribe": "S’abonner",
          "subscribeTo": "S'abonner à",
          "updateCardDetails": "Veuillez mettre à jour les détails de la carte",
          "zip": "code postal"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Étape {currentStep} de 8",
          "successDescription": "Votre marque et votre campagne A2P ont été soumises.",
          "successMessage": "Remarque : Vous recevrez un mot de passe à usage unique au numéro de téléphone portable que vous avez fourni pour la vérification TCR. Veuillez répondre Oui dans les 24 heures suivant la réception du SMS.",
          "successWaitDays": "7 jours",
          "successWaitPrefix": "Cela pourrait prendre jusqu'à ",
          "successWaitSuffix": " pour l'approbation de votre marque et 4 à 5 semaines supplémentaires pour l'approbation de la campagne."
        },
        "reminder": {
          "noReplyYet": "Aucune réponse pour l'instant",
          "patientConfirmed": "Patient confirmé"
        },
        "sendGrid": {
          "apiKeyRequired": "Clé API requise"
        },
        "update": {
          "brandNameHelper": "Utilisez le nom légal de l'entreprise qui envoie les messages.",
          "businessVerticals": "Secteurs de l'entreprise*",
          "resendOTP": "Renvoyer le mot de passe à usage unique",
          "retryOTPTitle": "Réessayer la vérification OTP"
        }
      },
      "addCustomEmailModal": {
        "title": "Ajouter un e-mail personnalisé"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Ajouter un fournisseur",
        "clickHereForInfo": "Cliquez ici pour obtenir plus d'informations.",
        "clickHereToFindOut": "Cliquez ici pour les découvrir.",
        "createProviderError": "Une erreur s'est produite lors de la création du fournisseur !",
        "gmailLimitations": "Gmail présente certaines limitations.",
        "needHelp": "Besoin d'aide pour trouver le serveur SMTP et le numéro de port ?",
        "port25NotSupported": "Le port 25 n'est pas pris en charge ! Veuillez utiliser le port 2525 à la place.",
        "providerExists": "Un fournisseur avec cet e-mail/nom d'utilisateur existe déjà.",
        "providerName": "Nom du fournisseur",
        "selectProvider": "Sélectionner un fournisseur",
        "smtpPortNumber": "Numéro de port SMTP",
        "smtpProvider": "Fournisseur SMTP",
        "smtpServer": "Serveur SMTP",
        "username": "Nom d'utilisateur",
        "usernameOrEmailRequired": "Vous devez indiquer votre nom d'utilisateur ou votre e-mail.",
        "verifySmtpAccount": "Vérifier le compte SMTP"
      },
      "addTagModal": {
        "addTag": "Ajouter un tag",
        "editTag": "Modifier l'étiquette",
        "tagAlreadyExists": "L'étiquette {tag} existe déjà"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Ce rapport FirstPromoter est uniquement accessible par les <strong>administrateurs et le propriétaire de l'agence</strong>. Si vous avez besoin d'aide, veuillez contacter votre <strong>propriétaire d'agence ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "Tableau de bord FirstPromoter",
        "noPartnersFound": "Impossible de trouver un partenaire correspondant à vos filtres. Cliquez <a href='javascript:void(0);'>ici</a> pour demander à devenir partenaire.",
        "paymentDetailsAccessMessage": "Cette section sur les détails du paiement n'est accessible et modifiable que par le <strong>propriétaire de l'agence</strong>. Si vous avez besoin d'aide, veuillez contacter votre <strong>propriétaire d'agence ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Détails du rendez-vous"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Charger l'instantané :",
        "loadSnapshotWarning": "Souhaitez-vous charger l'Instantané associé à ce plan ? <br /> <strong class='text-danger'>Les données existantes peuvent être perdues</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Modifier le mot de passe",
          "confirmPassword": "Confirmez le nouveau mot de passe",
          "expired": "Votre lien de réinitialisation du mot de passe a expiré.",
          "regenerateLink": "Régénérer le lien",
          "success": "Mot de passe modifié avec succès",
          "title": "Définir un nouveau mot de passe",
          "passwordMismatch": "Les mots de passe ne correspondent pas"
        },
        "forgotPassword": {
          "contactAgency": "contactez votre agence.",
          "contactSupport": "Contactez HighLevel Support 24/7 en appelant le",
          "supportMessage": "Si vous n'avez pas accès à cette boîte mail, veuillez",
          "successMessage": "Un lien de réinitialisation du mot de passe a été envoyé à votre adresse e-mail.",
          "rateLimitError": "Trop de demandes de réinitialisation de mot de passe. Veuillez réessayer plus tard."
        },
        "login": {
          "inactivityMsg": "Nous avons remarqué que votre compte est inactif depuis un certain temps. Pour votre sécurité, nous vous avons donc déconnecté(e).",
          "loginButton": "Se connecter",
          "resetPasswordMsg": "Un lien de réinitialisation du mot de passe est envoyé à votre adresse e-mail.",
          "signInWithGoogle": "Se connecter avec Google",
          "contactHighLevelSupport": " contacter HighLevel Support 24/7 en appelant le"
        },
        "logout": {
          "loggingOut": "Déconnexion en cours..."
        },
        "otp": {
          "enterBackupCode": "Entrez votre code de secours",
          "resend": "Renvoyer",
          "resendIn": "Renvoyer dans",
          "sendToPhone": "Envoyer le code au numéro de téléphone",
          "sending": "Envoi",
          "useAuthenticator": "Utilisez l'application d'authentification",
          "useBackupCode": "Utilisez le code de secours",
          "verifyButton": "Vérifiez avec le code de secours"
        },
        "sso": {
          "agreeTerms": "En vous connectant, vous acceptez nos <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Conditions générales d'utilisation</a>",
          "and": ", et",
          "loginDifferentMethod": "Connectez-vous via une autre méthode",
          "loginSuccessRedirecting": "Connexion réussie, redirection en cours...",
          "processing": "Traitement de votre demande...",
          "redirecting": "Redirection en cours...",
          "redirectingToDashboard": "Redirection vers le tableau de bord...",
          "signedIn": "Connecté",
          "signingIn": "Connexion en cours...",
          "testFailedRedirecting": "Le test a échoué, redirection...",
          "testSuccessRedirecting": "Test réussi, redirection en cours..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Adresse de l'entreprise : {address}",
        "businessDetailsText": "Les informations d'entreprise suivantes seront soumises aux annonces Local Services de Google pour l'intégration Réserver avec Google. Veuillez vérifier et confirmer ou {link} pour mettre à jour votre profil d'entreprise.",
        "businessInfoRequired": "Les informations d'entreprise énumérées ci-dessus sont nécessaires pour l'intégration, {link} pour mettre à jour les détails commerciaux manquants/incorrects.",
        "businessName": "Nom de l’entreprise : {name}",
        "businessNiche": "Secteur d'activité : {niche}",
        "city": "Ville : {city}",
        "confirmDetails": "Je confirme par la présente que les informations mentionnées ci-dessus sont correctes.",
        "country": "Pays : {country}",
        "mustConfirmDetails": "Vous devez confirmer les détails mentionnés ci-dessus.",
        "phoneNumber": "Numéro de téléphone : {phone}",
        "state": "État : {state}",
        "zipCode": "Code postal : {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Ajoutez des heures",
        "applyAll": "Appliquer tout"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Répondez à l'appel et entrez ce code de vérification :",
          "leadConnectorCalling": "Lead Connector vous appelle...",
          "title": "Ajouter un ID d'appelant par téléphone",
          "waitingForVerification": "En attente de la vérification..."
        },
        "callerIdVerificationStatus": {
          "failed": "La vérification de l'ID d'appelant a échoué. Veuillez réessayer.",
          "success": "Vous avez bien vérifié <strong>{contact}</strong>"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Ajouter un ou des numéros existants",
          "areaCode": "Indicatif régional :",
          "checkAvailability": "Vérifier la disponibilité",
          "checkingAvailability": "Vérification de la disponibilité du numéro.",
          "chooseAreaCode": "Veuillez sélectionner un indicatif régional",
          "choosePhoneNumbers": "Sélectionnez un ou plusieurs numéros de téléphone",
          "goBack": "Retour",
          "localNumbers": "Local {type}",
          "nextNumberFeatures": "Suivant : Fonctionnalités des numéros",
          "noExistingNumbers": "Aucun numéro existant à ajouter",
          "noNumbersAvailable": "Aucun numéro disponible",
          "notEnoughNumbers": "Pas assez de numéros disponibles",
          "numbersAvailable": "Numéros disponibles",
          "numbersDifferentArea": "Numéros dans un indicatif régional différent",
          "numbersLocalTo": "Numéros locaux pour le <strong>{number}</strong>",
          "problemChecking": "Problème de vérification de la disponibilité du numéro, veuillez vérifier la connexion réseau ou contacter l'assistance.",
          "somethingWentWrong": "Une erreur s'est produite. Veuillez vérifier les identifiants de votre compte Twilio et envoyez un message à l'assistance si le problème persiste.",
          "tollFreeNumbers": "Numéros verts (supplément de 2 $ par numéro et par mois)",
          "percentageComplete": "67 % terminé"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Je comprends les conséquences, supprimez la catégorie",
          "confirmText": "Veuillez saisir <b>{name}</b> pour confirmer",
          "title": "Supprimer la catégorie de numéro - <strong>{name}</strong>",
          "warning": "Cette action est irréversible. Cela supprimera définitivement le(s) numéro(s) de votre compte Twilio ainsi que la catégorie de numéro de notre base de données. Par ailleurs, si vous supprimez la catégorie de numéros en raison d'un problème, n'hésitez pas à contacter notre équipe d'assistance."
        },
        "editNumberFormatModal": {
          "description": "Vous pouvez mettre à jour le formatage du/des numéro(s) de permutation et du/des numéro(s) de catégorie à votre guise. Veuillez vous assurer que le ou les numéros de permutation apparaissent dans le même format sur le site web.",
          "title": "Mettre à jour le format de numéro - <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Ajouter/modifier l'ID de groupe",
          "callConnectTooltip": "Cette fonction exige que le destinataire appuie sur une touche pour connecter l'appel, ce qui se traduira par une plus grande précision dans les rapports d'appel.",
          "createGroupIdDescription": "Créer/ajouter un ID de groupe unique pour utiliser plusieurs catégories de numéro avec un seul extrait de code JavaScript.",
          "enableCallConnect": "Enregistrer la fonctionnalité de connexion d'appel",
          "groupId": "ID de groupe",
          "outboundCallTimeout": "Délai d'expiration des appels sortants",
          "passCallerID": "Transmettre le numéro appelé comme ID de l'appelant",
          "passCallerIDTooltip": "Par défaut, le système transmet le numéro de l'appelant, mais si vous souhaitez que l'ID de l'appelant soit plutôt le numéro composé par l'appelant, activez cette fonction.",
          "selectCallerID": "Sélectionner l’ID d’appelant",
          "timeDuration": "Durée en seconde(s)",
          "titleNumber": "Numéro - <strong>{number}</strong>",
          "updateWhisperWarning": "Mettez à jour le message chuchoté, car cette fonctionnalité nécessite que le destinataire appuie sur une touche pour établir la connexion de l'appel.",
          "useVerifiedNumber": "Utilisez votre numéro vérifié comme ID d'appelant pour les appels sortants",
          "useVerifiedNumberTooltip": "S'applique uniquement aux numéros de téléphone vérifiés. Vous pouvez vérifier un numéro de téléphone dans Paramètres > Numéros de téléphone > Ajouter un ID d'appelant vérifié"
        },
        "emailOTPModal": {
          "confirmCode": "Confirmer le code",
          "resendCode": "Si vous n'avez pas reçu le code, cliquez ici pour le renvoyer",
          "unexpectedIssue": "Un problème inattendu est survenu"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Informations sur les Champs Personnalisés",
          "customFieldTooltip": "Info-bulle de champ personnalisé : {options}",
          "field": "Champ {companyName}",
          "trackingParameters": "Paramètres de suivi",
          "zipCode": "Code postal"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Ajouter des numéros de permutation",
          "addingSnippets": "Ajout d'extraits JavaScript",
          "groupSnippet": "Extrait pour le groupe « {id} »",
          "normalSnippet": "Extrait normal",
          "noswapDescription": "Si vous ne souhaitez pas que nous échangions le numéro à un certain endroit, ajoutez une classe « noswap ».",
          "notReplacing": "Ne pas remplacer à un certain emplacement",
          "requiredSteps": "Étapes obligatoires",
          "snippetsDescription": "Copiez l'extrait de code ci-dessous et ajoutez-le juste au-dessus de la balise fermante <body> de chaque page dans laquelle vous souhaitez remplacer les chiffres.",
          "swappingDescription": "Utilisez les numéros ci-dessous pour l'échange de numéros de téléphone. Sélectionnez un format local ou international, ou les deux."
        },
        "newPhoneNumberModal": {
          "areaCode": "Indicatif régional",
          "availableNumbers": "Numéros disponibles",
          "bundle": "Pack",
          "chooseAddress": "Sélectionner l'adresse...",
          "chooseBundle": "Sélectionnez un pack...",
          "createRegulatory": "Créez un ensemble réglementaire/une adresse ici.",
          "monthlyFee": "Frais mensuels",
          "noNumbersFound": "Aucun numéro trouvé, veuillez essayer un autre indicatif régional.",
          "selectAddress": "Veuillez sélectionner « Adresse » pour acheter le numéro.",
          "selectBundle": "Veuillez sélectionner « Pack » pour acheter le numéro.",
          "title": "Ajouter un numéro de téléphone",
          "upgradeAccount": "Veuillez mettre à niveau votre compte Twilio, seuls les comptes mis à niveau peuvent acheter des numéros de téléphone et passer des appels téléphoniques.",
          "cardAuthenticationFailed": "L'authentification de la carte a échoué !"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Vous devez accepter les conditions d'utilisation et de confidentialité.",
          "clickingProceed": "En cliquant sur Continuer, vous ouvrirez la page de liaison Annonces Local Services dans un nouvel onglet.",
          "configureCalendar": "Configurez au moins un calendrier pour procéder à l'intégration de la Reserve avec Google.",
          "configureCalendarBtn": "Configurez le calendrier",
          "linkOneAccount": "Assurez-vous de ne lier qu'un seul compte. Contactez le service d'assistance si vous ne parvenez pas à afficher la page figurant dans la capture d'écran ci-dessus.",
          "readInstructions": "J'ai lu les instructions ci-avant"
        },
        "updateTrackingModal": {
          "title": "Mettre à jour l'option de suivi"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Ceci n'est visible que par les administrateurs de l'agence)",
          "updatedEvery24Hours": "(mis à jour toutes les 24 heures)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Calendrier non sélectionné pour la synchronisation",
          "check": "Vérifiez {email}",
          "checkForConflicts": "Vérifier les conflits",
          "checkForConflictsTooltip": "Configurez le ou les calendriers pour détecter les conflits et éviter les doubles réservations.",
          "contactCreationAllowed": "Création de contact autorisée",
          "googleCalendar": "Logo Google Agenda",
          "noGoogleAccounts": "Aucun compte Google/Outlook n'a encore été ajouté dans les paramètres d'intégration",
          "noGoogleAccountsTeamMember": "Aucun compte Google/Outlook n'a été ajouté pour ce membre d'équipe à l'emplacement actuel. Demandez au membre de se connecter avec son compte et d'ajouter une connexion Google dans ses paramètres d'intégration.",
          "outlookCalendar": "Calendrier utilisateur Outlook",
          "primaryCalendarTooltip": "Définissez le calendrier auquel vous souhaitez ajouter de nouveaux événements au fur et à mesure qu'ils sont programmés.",
          "runTriggerAllowed": "Exécution du déclencheur autorisée"
        },
        "warningModal": {
          "contactAgency": "Veuillez contacter votre agence pour modifier les paramètres d'e-mail.",
          "title": "Avertissement"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Assistance par chat 24 h/24 et 7 j/7 plus rapide",
            "faster247Ticket": "Assistance prioritaire pour les tickets 24 h/24, 7 j/7 et temps de réponse plus rapide"
          },
          "highlight": {
            "description": "Nous l'avons compris, vous devez aller plus vite. Quand vous avez une question ou un problème, vous souhaitez qu'on y réponde le plus rapidement possible ! Avec la mise à niveau d'assistance prioritaire, vous pouvez gagner du temps et faire passer automatiquement vos demandes en première ligne.",
            "heading": "Êtes-vous prêt(e) pour le traitement VIP ?"
          },
          "name": "Assistance prioritaire",
          "success": {
            "description": "L'assistance prioritaire a été activée sur votre compte. Plus d'attente pour vous.",
            "heading": "Vous êtes maintenant un client prioritaire !"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Dupliquer {entityName}",
        "cloning": "Duplication...",
        "cloningLimit": "La duplication est limitée à 3 emplacements à la fois",
        "error": "Erreur lors de la duplication de l'entonnoir !",
        "locationsLabel": "Sélectionnez les emplacements",
        "nameLabel": "Nom pour le {entityName} cloné",
        "namePlaceholder": "Entrez le nom du {entityName} cloné",
        "selectUpTo": "Sélectionnez jusqu'à {maxSelectableLocations} emplacements",
        "title": "Dupliquer {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Avec le CNAM, le nom de votre entreprise apparaît sur l'identification de l'appelant, ce qui rend vos appels instantanément reconnaissables et renforce la confiance. Faites savoir à vos clients que c'est vous qui les appelez à chaque fois.",
          "title": "Faites en sorte que vos appels se démarquent !"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Confirmer et s’inscrire",
          "description": "Affichez le nom de votre entreprise pour les destinataires de l'appel afin d'augmenter la confiance et le taux de réponse aux appels.",
          "title": "Renforcez la confiance dans les appels avec le CNAM",
          "warning": "L'affichage du nom de l'entreprise n'est pas garanti, en particulier sur les téléphones portables."
        },
        "submitted": {
          "checkStatus": "Vérifier l'état du CNAM",
          "description": "Le nom de votre entreprise devrait être visible des contacts concernés dans un délai de 3 à 5 jours.",
          "subtitle": "Votre demande de CNAM a été soumise.",
          "title": "Félicitations !"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Confirmer la suppression",
        "confirmation": "Confirmation"
      },
      "createAddress": {
        "successTitle": "Adresse soumise avec succès",
        "underReview": "L'adresse soumise est en cours d'examen"
      },
      "createEndUser": {
        "dateFormat": "Le format de la date doit être AAAA-MM-JJ.",
        "phoneExample": " Par exemple : +14155552671",
        "title": "Informations sur l'entreprise :"
      },
      "customValueModal": {
        "changingNameWarning": "Changer le nom n'affectera pas la clé du champ.",
        "editCustomValue": "Modifier la valeur personnalisée",
        "fieldKeyCreatedWarning": "La clé de champ sera créée en fonction du nom et ne pourra pas être modifiée ultérieurement.",
        "nameRequired": "Le champ Nom est obligatoire",
        "nameValidation": "Le nom doit être alphanumérique et contenir au moins un caractère",
        "valueRequired": "Le champ Valeur est obligatoire"
      },
      "details": {
        "addressName": "Nom de l'adresse",
        "addressTitle": "Détails de l'adresse",
        "bundleName": "Nom du pack",
        "bundleTitle": "Informations sur le pack réglementaire",
        "countryFlag": "Drapeau {country}",
        "id": "ID",
        "organisation": "Organisation",
        "rejectionReason": "Motif de refus",
        "status": {
          "approved": "Accepté",
          "notValidated": "Non validé",
          "rejected": "Rejeté",
          "validated": "Validé"
        },
        "typeOfNumber": "Type de numéro"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Sélectionner un bureau",
        "whichOffice": "Quel bureau souhaitez-vous rattacher à ce compte ?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Autoriser la création de contacts :",
        "allowTrigger": "Autoriser le déclencheur :",
        "doNotSync": "Ne pas synchroniser les nouveaux événements avec le calendrier principal",
        "primaryCalendarTooltip": "Vous ne pouvez sélectionner qu'un calendrier avec accès en écriture que vous n'avez pas sélectionné pour vérifier les conflits.",
        "selectDefaultCalendar": "Sélectionnez le calendrier par défaut",
        "whichCalendar": "Quel calendrier devons-nous utiliser pour synchroniser (lire et écrire) les événements ?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Vérifiez ces places pour détecter d'éventuels conflits",
        "howToCheckConflicts": "Comment devons-nous vérifier les conflits ?"
      },
      "ejectModal": {
        "agencyClosing": "Le compte de l'agence Elite Marketing avec Highlevel va fermer. Pour conserver votre compte, veuillez contacter {userName} pour migrer votre compte directement vers Highlevel.",
        "cancelWarning": "Veuillez noter que votre compte sera officiellement résilié le 30 juin 2025 et que nous ne pourrons pas récupérer vos données après cette date si le transfert n'est pas effectué.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Si vous avez des questions, n'hésitez pas à nous contacter à",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Pour vous soutenir durant cette transition, nous vous offrons {months} d'accès gratuit à votre nouvel abonnement.",
        "intro": "En raison de violations répétées des conditions d'utilisation de HighLevel, Elite Marketing Authority (EMA) a été définitivement retiré de la plateforme HighLevel.",
        "platformCommitment": "En tant que plateforme alimentant les services de l'EMA, HighLevel s'engage à maintenir un environnement sûr, conforme et digne de confiance pour tous les utilisateurs. Pour éviter toute perturbation de votre compte, nous sommes là pour vous aider à effectuer une transition en douceur, soit vers un autre fournisseur de marque blanche, soit directement vers HighLevel.",
        "questions": "Si vous avez des questions,",
        "retainAccess": "Pour conserver l'accès à vos données et outils existants, cliquez sur le bouton ci-dessous et suivez les instructions pour lancer le transfert.",
        "speakWithTeam": "pour parler à notre équipe.",
        "startTransfer": "Commencez votre transfert gratuit",
        "title": "Attention Clients d'Elite Marketing",
        "viewFaqs": "Voir les FAQ ici :",
        "whiteLabel": "Si vous préférez accéder à HighLevel par l'intermédiaire d'un autre fournisseur de marque blanche, nous serons heureux d'accommoder ce changement via notre système de tickets de support après que vous ayez transféré votre compte directement à HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Créé",
        "updatedOn": "Mis à jour le"
      },
      "error": {
        "title": "Échec de l’envoi du pack réglementaire"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Plusieurs pages possèdent cette URL. Modifiez le chemin d'accès de cette page pour qu'elle fonctionne.",
          "urlNotFound": "Oups, nous ne trouvons pas l'URL que vous cherchiez."
        },
        "productRebilling": {
          "requestFailed": "Échec de la demande"
        },
        "template": {
          "categoryNotFound": "Oups, nous ne trouvons pas la catégorie que vous cherchiez.",
          "internalError": "Une erreur interne s'est produite !"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "Le sous-compte que vous essayez de transférer est compatible avec la loi HIPAA et ne peut pas être transféré à une agence non-HIPAA."
          },
          "limitExceeded": {
            "message": "L'agence vers laquelle vous essayez de transférer le sous-compte a atteint sa limite d'utilisation et ne peut pas obtenir plus de sous-comptes.  Veuillez lui demander de supprimer un sous-compte qui n'est pas utilisé ou de passer à un forfait d'agence supérieur afin d'obtenir ce sous-compte."
          },
          "pendingRequest": {
            "heading": "Une demande de transfert pour ce sous-compte est déjà en attente.",
            "message": "Veuillez annuler la demande de transfert existante pour ce sous-compte avant d'en créer une nouvelle."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Vous ne trouvez pas la page que vous cherchez ? Veuillez consulter vos paramètres et vous assurer que toutes les pages sont sélectionnées.",
        "instagramAvailable": "Instagram est disponible pour ce compte !",
        "noPages": "Vous n'avez aucune page sous ce compte.",
        "title": "Sélectionnez la page Facebook que vous souhaitez lier à cet emplacement."
      },
      "googleLocationSelect": {
        "closeButton": "Fermer",
        "enableCallTracking": "Activer le suivi des appels GBP",
        "noBusinesses": "Vous n'avez aucune entreprise connectée associée à ce compte."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Plus efficace",
          "faster": "Plus rapide",
          "itsText": "C’est",
          "smoother": "Plus fluide",
          "title": "Une nouvelle expérience d'importation est disponible !",
          "warningMessage": "L'activation de la nouvelle expérience d'importation active Labs pour ce sous-compte et active la fonctionnalité bêta."
        },
        "validateEmails": "Valider les e-mails ?"
      },
      "initBundle": {
        "numberType": "Type de numéros que vous avez prévu d'utiliser",
        "numberTypes": {
          "local": "Numéros locaux",
          "mobile": "Mobile",
          "tollfree": "Gratuit"
        },
        "selectCountry": "Sélectionnez votre pays",
        "selectUserType": "Sélectionner le type d'utilisateur",
        "userTypes": {
          "business": "Entreprise",
          "individual": "Individuel"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Dernier crédit ajouté le :",
        "currentBalance": "Solde actuel",
        "debitBalance": "- Solde débiteur",
        "depositComplimentaryCreditsOf": "Dépôt de crédits gratuits de",
        "manageBalance": "Gérer le solde",
        "mustBeValidInteger": "Doit être un entier valide",
        "nextDate": "Prochaine date :",
        "perMonth": "par mois",
        "remainingWalletBalance": "Solde restant du portefeuille numérique de ce sous-compte",
        "rolloverCredits": "Reportez les crédits au mois suivant",
        "toManageMonthlyCredits": "Pour gérer les crédits mensuels,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Ajouter un nouvel abonnement"
      },
      "manualActions": {
        "confirmDelete": "Voulez-vous vraiment supprimer cette action ?",
        "confirmDeleteAll": "Voulez-vous vraiment supprimer toutes les actions manuelles sur cette page ?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Générez un mot de passe fort",
          "sendEmailNotification": "Envoyez également une notification par email."
        }
      },
      "modal": {
        "description": "Pour utiliser les systèmes téléphoniques, vous devez suivre quelques étapes simples de conformité",
        "submit": "Envoyer",
        "title": "Service téléphonique Lead Connector"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Visiteurs de la page d'accueil",
          "launched": "Lancé",
          "newNotification": "Nouvelle notification",
          "startMessage": "Commencez à augmenter vos conversions en créant votre première notification.",
          "types": {
            "combination": "Combinaison"
          }
        },
        "page": {
          "createTitle": "Créer une nouvelle notification",
          "steps": {
            "display": "Affichage",
            "track": "Suivre"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Informations supplémentaires",
          "calendarEvent": "Événement de calendrier",
          "hideAssignedTo": "Masquer l'attribution",
          "hideTags": "Masquer les mots-clés"
        },
        "filters": {
          "dateAddedAsc": "↑ Date d'ajout (ASC)",
          "dateAddedDesc": "↓ Date d'ajout (DESC)",
          "orderBy": "OrderBy"
        },
        "getStarted": "commencer !",
        "noPipelines": "Oups ! On dirait qu'aucun pipeline n'est configuré. Créez un nouveau pipeline pour"
      },
      "pages": {
        "pageMoved": {
          "title": "Les annonces en ligne ont été déplacées"
        }
      },
      "recentlyVisited": {
        "prices": "{count} prix"
      },
      "reminders": {
        "appointmentReminders": "Rappels de rendez-vous",
        "apptTime": "Heure du rendez-vous",
        "defaultDateRange": "Dim, 1er avr. 2018 - Lun, 31 avr. 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "En attente",
        "rebillingOnHoldWarning": "Ce compte a déjà des configurations de refacturation en attente. Le forfait SaaS ne peut être attaché qu'après que le client a ajouté un mode de paiement.",
        "subscriptionId": "ID d'abonnement :"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Confirmer et poursuivre",
        "documents": {
          "acceptedDocuments": "Documents acceptés",
          "acceptedDocumentsLabel": "Documents acceptés :",
          "additionalInfo": "Informations complémentaires :",
          "createAddressLink": "Créez une adresse.",
          "createAddressPrompt": "Veuillez d'abord créer une adresse, puis procédez à la création du pack.",
          "documentInfo": "PNG, JPG, PDF jusqu'à 5 Mo",
          "documentType": "Type de document",
          "option": "Option {number}",
          "selectAddress": "Sélectionner l'adresse :",
          "selectDocumentType": "Sélectionnez le type de document :",
          "selectFile": "Sélectionner un fichier",
          "title": "Fichiers obligatoires :",
          "updateDocuments": "Mettre à jour les documents"
        },
        "everythingIn": "Tout dans <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "d'ajouter une carte de crédit ici",
          "message": "Veuillez demander à votre client de",
          "title": "L'emplacement doit d'abord inclure une méthode de paiement."
        },
        "noSaasPlan": {
          "linkText": "créer vos plans SaaS ici.",
          "message": "Veuillez",
          "title": "Vous n'avez configuré aucun plan SaaS."
        },
        "saasModeSetupPendingWarning": "Le forfait SaaS sera activé dès que le client aura ajouté un mode de paiement. En attendant, l'accès à leur compte sera restreint.",
        "skipForNow": "Ignorer pour maintenant",
        "skipPlan": "Ignorer le plan",
        "success": {
          "title": "Pack réglementaire soumis avec succès",
          "underReview": "Pack soumis à examen"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Cette option ajoutera une nouvelle adresse à votre compte",
          "label": "Pack d'adresses"
        },
        "regulatoryBundle": {
          "description": "Cette option vous aidera à créer un nouveau pack réglementaire",
          "label": "Pack réglementaire"
        },
        "title": "Choisissez le pack que vous souhaitez ajouter"
      },
      "settings": {
        "billing": "Facturation",
        "calendars": "Calendriers",
        "customEmails": "E-mails personnalisés",
        "domains": "Domaines",
        "domainsAndUrlRedirects": "Domaines et redirections d'URL",
        "facebookFormFieldsMapping": "Mappage des champs de formulaire Facebook",
        "groups": "Groupes",
        "integrations": "intégrations",
        "labs": "Labs",
        "media": "Média",
        "noShowSMS": "SMS d’absence",
        "pipelines": "Pipelines",
        "profile": "Profil",
        "smtpAndMailGunService": "Service SMTP et MailGun",
        "templates": "Modèles",
        "urlRedirects": "Redirections d'URL"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Vos appels sont maintenant vérifiés !"
        },
        "modal": {
          "andThe": " et le ",
          "certification": "Je certifie que le profil d'entreprise associé est à l'origine des appels téléphoniques et que je contribuerai aux activités de traçage, y compris celles initiées par le",
          "failedTitle": "Échec de l’envoi",
          "friendlyNamePlaceholder": "Ex : 24 novembre SHST à 19:47:14",
          "linkInfo": {
            "description": "Tous les numéros actuellement disponibles et les futurs numéros achetés seront automatiquement enregistrés auprès de SHAKEN/STIR.",
            "title": "Tous les numéros seront automatiquement liés"
          },
          "stiPa": "Administrateur de la politique d'identité téléphonique sécurisée (STI-PA)",
          "subtitle": "Entrez les informations et la description",
          "successMessage": "Votre demande d'enregistrement SHAKEN/STIR a été soumise. L'approbation peut prendre jusqu'à <b>3 ou 4 jours</b>. Le statut sera bientôt mis à jour.",
          "successTitle": "Appels de confiance SHAKEN/STIR activés.",
          "title": "Activer l'appel de confiance SHAKEN/STIR",
          "tracebackGroup": "US Telecom Traceback Group"
        },
        "withCnam": {
          "cnamPromo": "Vous voulez aller plus loin ? Affichez le nom de votre entreprise sur les appels avec le CNAM.",
          "registerCnam": "Inscrivez-vous au CNAM",
          "title": "Renforcez la confiance de vos clients et augmentez le taux de réponse aux appels"
        },
        "successMessage": "Votre demande d'enregistrement SHAKEN/STIR a été soumise. L'approbation peut prendre jusqu'à <b>3 ou 4 jours</b>. Le statut sera bientôt mis à jour."
      },
      "shopify": {
        "selectLocation": "Sélectionnez l'emplacement que vous souhaitez associer à cette boutique Shopify"
      },
      "signup": {
        "accountType": "Type de compte",
        "agencyProAccount": "Compte Agence Pro (497 $/mois)",
        "agencyTestAccount": "Compte de test d'agence",
        "freeTrialMessage": "Bénéficiez d'un essai <strong>gratuit</strong> de 14 jours en vous inscrivant dès maintenant.",
        "freelancerAccount": "Compte Indépendant (297 $/mois)",
        "getStartedForFree": "Commencez gratuitement !",
        "pickPassword": "Sélectionnez un mot de passe",
        "signUp": "Inscrivez-vous",
        "starterAccount": "Compte Starter (97 $/mois)",
        "termsAndConditions": "En vous inscrivant, vous acceptez nos <a href='https://www.gohighlevel.com/privacy' target='_blank'>Conditions générales d'utilisation</a>",
        "yourCompanyName": "Nom de votre entreprise",
        "yourFullName": "Votre nom complet"
      },
      "standardPlan": {
        "description": "Nous proposons les forfaits suivants pour les enregistrements de marque standard.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN requis pour l'enregistrement",
            "moreThan1Phone": "Plusieurs numéros de téléphone autorisés"
          },
          "highVolume": {
            "heading": "Standard à haut volume",
            "point3": "Jusqu'à 600 000 segments par jour",
            "infoText": "L'enregistrement d'une marque et d'une campagne est facturé 20,95 $. Des frais de campagne supplémentaires pouvant aller jusqu'à 2,25 $ par mois seront appliqués conformément aux règles TCR.",
            "point2": "Envoyez jusqu'à 3 000 segments par jour",
            "point1": "EIN requis pour l'enregistrement"
          },
          "lowVolume": {
            "heading": "Standard à faible volume",
            "recommended": "Recommandé",
            "point3": "Jusqu'à 6 000 segments par jour",
            "infoText": "L'enregistrement d'une marque et d'une campagne est facturé 20,95 $. Des frais de campagne supplémentaires pouvant aller jusqu'à 2,25 $ par mois seront appliqués conformément aux règles TCR.",
            "point2": "Envoyez jusqu'à 3 000 segments par jour",
            "point1": "EIN requis pour l'enregistrement"
          }
        },
        "title": "Sélectionnez votre forfait de marque standard"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Informations sur la réservation",
          "form": "Formulaire",
          "quiz": "Quiz",
          "submissionDetail": "Détail de l'envoi",
          "survey": "Sondage"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Seuls les administrateurs/utilisateurs d'agence ont accès à ce sous-compte. Actuellement, vous et les autres administrateurs/utilisateurs du compte n'avez pas accès à ce sous-compte.",
          "heading": "Ce sous-compte a été mis en pause."
        },
        "temporarily": {
          "description": "Toutes vos données sont protégées et les déclencheurs/campagnes, etc. reprendront leur fonctionnement après l'activation.",
          "heading": " Votre compte a été temporairement suspendu."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Appliquer uniquement aux contacts non attribués",
          "splitTraffic": "Diviser le trafic",
          "trafficWeightage": "Pondération du trafic",
          "userRequired": "L'utilisateur doit être sélectionné",
          "weightage": "pondération"
        },
        "birthdayFilters": {
          "afterDays": "Après le nombre de jours",
          "beforeDays": "Avant le nombre de jours",
          "dayIs": "Le jour est",
          "daysInNumber": "Jours en nombre",
          "hasTag": "A une étiquette",
          "monthIs": "Le mois est",
          "selectDay": "Sélectionner le jour",
          "selectMonth": "Sélectionner le mois"
        },
        "botConversation": {
          "enterTimeout": "Entrez un délai d'attente (heures)",
          "selectEliza": "Sélectionnez Eliza",
          "selectThankyouTemplate": "Sélectionnez le modèle de remerciement",
          "selectWelcomeTemplate": "Sélectionner le modèle de bienvenue"
        },
        "contactField": {
          "addField": "Ajouter des champs",
          "defineFilters": "Définir les filtres"
        },
        "copyModal": {
          "title": "Copier le déclencheur"
        },
        "detailModal": {
          "actionsPerform": "Quelles actions devrions-nous effectuer ?",
          "campaignNameRequired": "Le champ Nom de la campagne est obligatoire",
          "campaignsDeprecation": "Les campagnes ne sont plus maintenues. Pour assurer une transition en douceur, veuillez convertir vos campagnes existantes en flux de travail.",
          "folderName": "Nom du dossier",
          "mustSelectFolder": "Vous devez sélectionner un dossier.",
          "newFolderName": "Nouveau nom de dossier",
          "selectFolder": "Sélectionnez un dossier",
          "triggerNameRequired": "Le champ Nom du déclencheur est obligatoire",
          "triggersDeprecation": "Les déclencheurs ne sont plus maintenus. Pour garantir une transition fluide, veuillez convertir vos Triggers existants en Workflows.",
          "triggerName": "Nom de déclencheur"
        },
        "dnd": {
          "disableAll": "Désactiver le DND pour tous les canaux",
          "disableSpecific": "Désactivez le DND pour des canaux spécifiques",
          "enableAll": "Activer le DND pour tous les canaux",
          "enableSpecific": "Activer le DND pour des canaux spécifiques",
          "selectAction": "Sélectionner une action"
        },
        "email": {
          "sendTestEmail": "Envoyer un e-mail de test",
          "smtpWarning": "Les fournisseurs SMTP présentent certaines limitations. Cliquez ici pour en savoir plus."
        },
        "facebook": {
          "avatarAlt": "Avatar Facebook",
          "selectCustomAudience": "Sélectionnez une audience personnalisée"
        },
        "googleAds": {
          "conversionName": "Nom de conversion",
          "conversionTooltip": "La source de conversion doit être Importation de clics et la catégorie doit être Lead importé ou Lead.",
          "noConversions": "Aucun taux de conversion trouvé",
          "selectConversion": "Sélectionner la conversion"
        },
        "googleAnalytics": {
          "eventAction": "Action d'événement",
          "eventActionRequired": "Une action d'événement est requise.",
          "eventCategory": "Catégorie d'événement",
          "eventCategoryRequired": "La catégorie d'événement est obligatoire.",
          "eventLabel": "Intitulé de l'événement",
          "eventValue": "Valeur de l'événement",
          "hitType": "Type de vue",
          "hitTypeRequired": "Le type de vue est obligatoire.",
          "trackingId": "ID de suivi",
          "trackingIdRequired": "L'ID de suivi est obligatoire."
        },
        "membershipOffer": {
          "selectOffer": "Sélectionnez une offre"
        },
        "notification": {
          "selectRedirectPage": "Sélectionner la page de redirection",
          "selectUser": "Sélectionner un utilisateur",
          "selectUserType": "Sélectionner un type d'utilisateur"
        },
        "sms": {
          "sendTestSMS": "Envoyer un SMS de test"
        },
        "stripeCharge": {
          "customerId": "ID de client Stripe",
          "enterAmount": "Saisissez un montant",
          "selectCurrency": "Sélectionner la devise"
        },
        "webhook": {
          "webhookUrl": "URL du Webhook"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Date d'activité",
            "balance": "Solde",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Les agences qui bénéficient du forfait Pro gagnent environ 363 dollars par mois en refacturant les frais de téléphone à leurs clients",
          "title": "Souhaitez-vous refacturer cela à vos clients  ?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Votre profil n'a pas été soumis."
        },
        "success": {
          "message": "Votre marque et votre campagne A2P ont été soumises.<br/><br/><b>Remarque :</b> Vous <b>recevrez un mot de passe à usage unique au numéro de téléphone portable que vous avez fourni pour la vérification</b> TCR. <b>Veuillez répondre Oui dans les 24 heures</b> suivant la réception du SMS."
        }
      },
      "usageLimit": {
        "contactLimit": "Limite de contacts",
        "maxContactsAllowed": "Nombre maximum de contacts autorisés dans le sous-compte",
        "maxUsersAllowed": "Nombre maximum d'utilisateurs autorisés dans le sous-compte",
        "unlimited": "Illimité",
        "usageLimits": "Limites d'utilisation",
        "userLimit": "Limite d'utilisateurs",
        "userLimitHelpMessage": "Seuls les utilisateurs de niveau sous-compte sont pris en compte dans cette limite. Vous pouvez toujours inclure autant d'utilisateurs d'agence dans les sous-comptes que vous le souhaitez."
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "J'accepte d'activer Listings pour ce client sans faire de vente incitative et je reconnais que je serai facturé(e)",
          "deployDirectly": "Déployer Listings directement",
          "deployDirectlyDesc": "Utilisez cette option si vous proposez Listings dans le cadre de votre offre ou si vous souhaitez facturer votre client séparément",
          "minimumCommitment": "avec une période d'engagement minimale d'un mois.",
          "offerListings": "Listes d'offres",
          "resellListings": "Annonces de revente",
          "subscribedInfo": "{withoutUpsell} Sans vente incitative, {withUpsell} Avec vente incitative et {withSaas} Avec pack Saas",
          "subscriptionCreated": "Abonnement créé. Veuillez patienter...",
          "subscriptionCreating": "L'abonnement est en cours de création.<br/>Merci de ne pas actualiser la page ou cliquer sur le bouton Retour",
          "unableToCreate": "Impossible de créer l'abonnement, veuillez contacter l'assistance",
          "unavailabilityForAgencyAdmin": "Yext n'est pas disponible dans ce pays. Si vous pensez qu'il s'agit d'une erreur, veuillez le demander sur notre feuille de route à",
          "yourResellOffer": "Votre offre de revente"
        }
      },
      "selectCountry": "Sélectionnez votre pays",
      "documents": {
        "additionalInfo": "Informations supplémentaires",
        "createAddressLink": "Créez une adresse.",
        "createAddressPrompt": "Veuillez d'abord créer une adresse, puis procédez à la création du pack.",
        "selectAddress": "Sélectionner l'adresse :"
      }
    },
    "triggers": {
      "emptyTrigger": "Déclencheur vide"
    },
    "util": {
      "addFiles": "+ Ajouter des fichiers",
      "fillValues": "Remplissez les valeurs",
      "image": "img",
      "ok": "OK",
      "pleaseTypeOrCancel": "Veuillez taper {consentString} ci-dessus ou annuler cette action.",
      "pressEnterToAddCustomOption": "Appuyez sur Entrée pour ajouter une option personnalisée",
      "required": "* obligatoire",
      "unsaved": "Non enregistré"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Pour activer le workflow pour un emplacement, accédez à l’onglet Comptes, cliquez sur l’icône à trois points à droite d’un sous-compte et sélectionnez <strong>Activer le générateur de workflow</strong>. Ce processus est temporaire car les flux de travail seront activés dans tous les emplacements la semaine prochaine."
      },
      "faq": "FAQ",
      "gotIt": "Compris",
      "workflowIsLive": "Le flux de travail est actif dans votre compte !"
    },
    "action": {
      "stats": {
        "bounced": "Rejeté",
        "clicked": "Cliqué",
        "delivered": "Envoyé",
        "opened": "Ouvert",
        "replied": "Répondu",
        "unsubscribed": "Désinscrit",
        "total": "Total",
        "failed": "Échec"
      },
      "actions": {
        "edit": "Modifier",
        "send": "Envoyer",
        "remove": "Supprimé"
      },
      "timing": {
        "days": "Jours",
        "immediately": "Immédiatement",
        "before": "Avant",
        "after": "Après",
        "minutes": "Minutes",
        "hours": "Heures"
      },
      "labels": {
        "template": "Modèle",
        "manual": "Manuel"
      },
      "details": {
        "hideDetail": "Masquer les détails",
        "showDetail": "Afficher les détails"
      },
      "queue": {
        "people": "personnes",
        "person": "personne",
        "queued": "mis en file d'attente"
      },
      "tooltips": {
        "clickedHelp": "La précision du suivi des clics peut varier en fonction du client de messagerie et des paramètres de l'utilisateur.",
        "statsAccuracy": "La précision des statistiques peut varier en fonction du client de messagerie et des paramètres utilisateur."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Voulez-vous vraiment supprimer cette demande en masse ?",
        "startImmediately": "Commencer immédiatement"
      },
      "modal": {
        "contactTypes": {
          "all": "Tout",
          "leads": "Prospects",
          "customers": "Clients"
        },
        "buttons": {
          "cancel": "Annuler",
          "update": "Mettre à jour",
          "add": "Ajouter"
        },
        "labels": {
          "name": "Nom",
          "contactType": "Type de contact",
          "campaign": "Campagne",
          "scheduledDate": "Jour programmé",
          "tag": "Mot-clé"
        },
        "placeholders": {
          "tags": "Mots-clés",
          "selectCampaign": "Sélectionner une campagne",
          "pickType": "Sélectionnez le type"
        },
        "sections": {
          "bulkRequest": "Demande en masse",
          "whoShouldRun": "À quoi l'appliquer ?"
        },
        "titleAdd": "Ajouter une demande en masse",
        "titleEdit": "Modifier une demande en masse",
        "validation": {
          "scheduledDateRequired": "La date programmée est obligatoire."
        }
      }
    },
    "listFolder": {
      "expandIcon": "Développer"
    },
    "list": {
      "confirmDeleteFolder": "Confirmez la suppression du dossier",
      "delete": "Supprimer",
      "confirmDelete": "Voulez-vous vraiment supprimer cette campagne ?",
      "moveToFolder": "Déplacer vers un dossier",
      "pleaseRename": "veuillez renommer",
      "removeFromFolder": "Supprimer du dossier"
    },
    "copy": {
      "title": "Copier la campagne",
      "newCampaignName": "Nouveau nom de campagne",
      "locations": "Emplacements"
    }
  },
  "compliance": {
    "findOutMore": "Découvrez-en plus",
    "gdprDescription": "Nous prenons très au sérieux la protection de vos données personnelles et de celles de vos clients et traitons les données personnelles de manière confidentielle et conformément aux dispositions légales en matière de protection des données et à la présente déclaration de protection des données.",
    "gdprTitle": "Conformité au RGPD",
    "hipaaDescription": "Activez les mises à jour de sécurité pour garantir que les données de votre compte HighLevel sont sécurisées et répondent aux exigences de la loi HIPAA",
    "hipaaTitle": "Conformité HIPAA"
  },
  "customValues": {
    "key": "Clé",
    "selectedItemsCountSingular": "{count} ligne sélectionnée",
    "selectedItemsCountPlural": "{count} lignes sélectionnées"
  },
  "facebookAdFields": {
    "checkIcon": "Formulaire mappé avec succès",
    "errorMessage": "Le jeton d'accès à la page a expiré ou n'a pas suffisamment d'autorisations. Veuillez vous assurer que vous disposez d'un accès administrateur aux pages."
  },
  "fbLeadSync": {
    "confirmTitle": "Enregistrer la synchronisation des prospects Facebook ?",
    "impactMessage": "Veuillez comprendre l'impact de la synchronisation des prospects Facebook avant de continuer :",
    "observations": "1. Cela synchronisera les prospects Facebook et créera un nouveau contact pour chaque prospect généré au cours des derniers {days} jours qui n'existe pas dans déjà votre liste de contacts. <br>2. Si vous avez importé manuellement des prospects manquants à l'aide d'un fichier CSV exporté depuis Facebook Ads Manager, veuillez désactiver « Autoriser la duplication des contacts » pour empêcher la synchronisation de créer des contacts en double. <br>3. Si vous avez des flux de travail qui se déclenchent lors de la <b>création d'un contact</b> ou de la <b>soumission d'un formulaire Facebook Lead</b>, ils se déclencheront pour chaque nouveau contact créé. <br>4. Les contacts existants créés par le biais des prospects Facebook ne seront pas affectés. <br>5. L'heure de création du contact enregistrée sera l'heure actuelle. <br>6. La synchronisation peut prendre jusqu'à une heure, en fonction du nombre de prospects à synchroniser. <br>",
    "proceedQuestion": "Souhaitez-vous continuer avec la synchronisation des prospects Facebook ?"
  },
  "integrationAI": {
    "accountDisconnected": "Compte déconnecté !",
    "appNotFound": "La configuration de l'application n'a pas été trouvée. Utilisation de données de secours.",
    "checkingConnection": "Vérification du statut de la connexion...",
    "connecting": "Connexion en cours…",
    "disconnectApp": "Déconnecter l'application",
    "disconnecting": "Déconnexion en cours...",
    "loadingAppInfo": "Chargement des informations de l'application...",
    "refreshConnection": "Actualiser la connexion",
    "refreshing": "Actualisation en cours...",
    "svgNotAvailable": "SVG non disponible"
  },
  "phoneSystem": {
    "additionalSettings": "Paramètres supplémentaires",
    "messaging": "Messagerie",
    "messagingAnalytics": "Analyse de la messagerie",
    "regulatoryBundles": "Packs réglementaires",
    "title": "Système téléphonique",
    "trustCenter": "Centre de confiance",
    "voice": "Voix"
  },
  "demo": {
    "draggable": {
      "title": "Test de composant déplaçable",
      "usingVue3": "Via élément déplaçable compatible avec Vue 3",
      "description": "Ce composant utilise désormais le composant déplaçable révisé compatible avec Vue 3.",
      "buttons": {
        "resetAllLists": "Réinitialiser toutes les listes",
        "clearLog": "Effacer le journal",
        "stopLoading": "Arrêtez le chargement",
        "simulateLoading": "Simuler le Chargement",
        "refreshData": "Actualiser les données"
      },
      "examples": {
        "basicDraggable": "Composant déplaçable simple",
        "draggableWithElement": "Composant déplaçable avec élément",
        "draggableWithTransitionGroup": "Composant déplaçable avec groupe de transition",
        "draggableWithMoveFunction": "Composant déplaçable avec fonction de déplacement"
      },
      "eventLog": "Journal des Événements",
      "handle": "Pseudo",
      "name": "Nom",
      "cannotMove": "(ne peut pas bouger)"
    },
    "tableDemo": {
      "title": "Démo Vue 3 UIBTable",
      "basicControls": "Contrôles simples",
      "labels": {
        "filter": "Filtrer :",
        "sortBy": "Trier par :",
        "sortDirection": "Direction de tri :",
        "perPage": "Par page :",
        "tableStyling": "Style de tableau :"
      },
      "placeholders": {
        "typeToSearch": "Saisir pour rechercher..."
      },
      "checkboxLabels": {
        "striped": "Rayé",
        "bordered": "Bordé",
        "hover": "Survoler",
        "small": "Petit",
        "responsive": "Réactif"
      },
      "fields": {
        "id": "ID",
        "name": "Nom",
        "email": "E-mail",
        "status": "Statut",
        "created": "Créé",
        "actions": "Actions"
      },
      "statuses": {
        "active": "Actif",
        "inactive": "Inactif",
        "pending": "En attente",
        "banned": "Banni"
      },
      "modal": {
        "title": "Informations sur l'élément",
        "close": "Fermer"
      },
      "messages": {
        "confirmDelete": "Voulez-vous vraiment supprimer {name}?",
        "editItem": "Modifier l'objet {id}",
        "showingItems": "Affichage de {count} sur {total} éléments"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Confirmer et poursuivre",
      "everythingIn": "Tout dans <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "d'ajouter une carte de crédit ici",
        "message": "Veuillez demander à votre client",
        "title": "L'emplacement doit d'abord inclure une méthode de paiement."
      },
      "noSaasPlan": {
        "linkText": "créer vos plans SaaS ici.",
        "message": "Veuillez",
        "title": "Vous n'avez configuré aucun plan SaaS."
      },
      "saasModeSetupPendingWarning": "Le forfait SaaS sera activé dès que le client aura ajouté un mode de paiement. En attendant, l'accès au compte est interdit.",
      "skipForNow": "Ignorer pour le moment",
      "skipPlan": "Ignorer"
    }
  },
  "isv": {
    "business_registration_id_type": "Type d'ID d'enregistrement de l'entreprise",
    "business_registration_number": "Numéro d'enregistrement de l'entreprise",
    "business_website": "Site Web de l'entreprise",
    "enter_your_business_registration_id_type": "Saisir le type d'ID d'enregistrement de l'entreprise",
    "name_of_other_registration_id_type": "Nom de l'autre type d'ID d'enregistrement",
    "pick_business_industry": "Sélectionner le secteur d'activité",
    "pick_business_registration_id_type": "Sélectionner le type d'ID d'enregistrement de l'entreprise",
    "emailWithStar": "Adresse e-mail*",
    "businessIndustry": "Secteur d'activité*",
    "businessType": "Type d’entreprise*",
    "regionsOfOperations": "Régions d'opérations de l'entreprise*",
    "registrationNumber": "Numéro d'enregistrement de l'entreprise*",
    "registrationNumberHelper": "Numéro utilisé pour identifier votre entreprise. Dans le cas d'un EIN américain, il doit s'agir d'un numéro à 9 chiffres, par exemple 12-3456789.",
    "businessWebsiteWithStar": "Site Web de l'entreprise*",
    "businessTypeWithStar": "Type d’entreprise",
    "businessWebsite": "Site Web de l'entreprise"
  },
  "aiProductRebilling": {
    "enableRebilling": "Activer la refacturation",
    "ratesMayDiffer": "Les tarifs peuvent différer selon la région. Les calculs indiqués tiennent compte des tarifs pour le Royaume-Uni,",
    "supportDoc": "document d'assistance",
    "cancel": "Annuler",
    "profit": "Bénéfice",
    "chargedToCustomer": "Facturé au client",
    "enabling": "Activation en cours...",
    "forMore": "pour plus de détails.",
    "rebillAmount": "Montant de la refacturation",
    "tenDollarsWillGive": "10 $ vous donneront environ",
    "yourCost": "Votre coût",
    "clientBillingPage": "page de facturation du client",
    "needStripeConnection": "Afin d'activer la refacturation, vous devez connecter votre Stripe sur",
    "per1000Words": "pour 1 000 mots",
    "perImage": "par image",
    "perReviewResponse": "par réponse aux avis",
    "perFunnel": "par entonnoir",
    "minimumBetween": "Le minimum doit être compris entre {min} et {max}",
    "images": "images",
    "reviewResponse": "réponse aux avis",
    "funnel": "entonnoir",
    "pleaseCheckSupport": "veuillez vérifier"
  },
  "a2p": {
    "otpSuccess": {
      "title": "Succès de l'OTP",
      "message": "Message de réussite de l'OTP"
    },
    "otpError": {
      "title": "Erreur OTP",
      "message": "Message d’erreur OTP"
    },
    "businessProfileError": {
      "title": "Erreur de profil d'entreprise",
      "message": "Message d'erreur de profil d'entreprise"
    },
    "addressError": {
      "title": "Erreur d'adresse",
      "status": "Statut d'erreur d'adresse"
    },
    "profileError": {
      "title": "Erreur de profil A2P",
      "message": "Message d'erreur de profil A2P"
    },
    "address": {
      "country": "Pays",
      "state": "État",
      "chooseCountry": "Sélectionner le pays...",
      "statePlaceholder": "Saisissez l'État",
      "chooseState": "Sélectionner l'état...",
      "city": "Ville*",
      "postalCode": "Code postal*",
      "streetAddress": "Adresse postale*",
      "streetAddressHelper": "Doit être une adresse valide liée à votre entreprise.",
      "title": "Adresse de l'entreprise"
    },
    "validation": {
      "brandNameRequired": "Le nom de la marque est obligatoire.",
      "businessVerticalRequired": "Le secteur de l'entreprise est obligatoire.",
      "cityRequired": "La ville est obligatoire.",
      "countryRequired": "Le pays est requis.",
      "invalidMobileNumber": "Numéro de téléphone mobile non valide.",
      "mobileNumberRequired": "Le numéro de portable est obligatoire.",
      "postalCodeRequired": "Le code postal est requis.",
      "stateRequired": "L'État est requis.",
      "streetAddressRequired": "L'adresse postale est requise."
    },
    "authorizedRep": {
      "email": "E-mail*",
      "firstName": "Prénom*",
      "jobPosition": "Poste*",
      "jobTitle": "Titre du poste*",
      "jobTitlePlaceholder": "Saisissez l'intitulé du poste",
      "lastName": "Nom de famille*",
      "phoneNumber": "Numéro de téléphone*",
      "phoneNumberPlaceholder": "Saisir un numéro de téléphone",
      "pickJobPosition": "Sélectionner un rôle",
      "title": "Informations du représentant autorisé"
    },
    "registration": {
      "stepProgress": "Étape {currentStep} de 8",
      "successTitle": "Votre marque et votre campagne A2P ont été soumises.",
      "successWaitDays": "7 jours",
      "successWaitPrefix": "Cela pourrait prendre jusqu'à ",
      "successWaitSuffix": " pour l'approbation de votre marque et 4 à 5 semaines supplémentaires pour l'approbation de la campagne.",
      "otpNote": "Remarque : Vous recevrez un mot de passe à usage unique au numéro de téléphone portable que vous avez fourni pour la vérification TCR. Veuillez répondre Oui dans les 24 heures suivant la réception du SMS."
    },
    "update": {
      "brandDetailsTitle": "Mettre à jour les détails de la marque",
      "brandName": "Nom de la marque*",
      "brandNameHelper": "Utilisez le nom légal de l'organisation qui envoie les messages ou votre propre nom si cette marque n'est pas destinée à une organisation.",
      "businessVerticals": "Secteur d'activité*",
      "chooseVertical": "Sélectionner un secteur…",
      "mobileNumber": "Numéro de téléphone mobile pour la vérification OTP (avec indicatif de pays)*",
      "mobileNumberHelper": "Veuillez fournir un numéro de téléphone mobile auquel vous avez accès afin de pouvoir confirmer la vérification par mot de passe à usage unique. Seuls les numéros américains/canadiens seront acceptés. Vous ne devez pas utiliser un numéro de téléphone CPaaS tel que celui obtenu auprès de LeadConnector. Vous ne pouvez pas utiliser le même numéro de téléphone mobile pour enregistrer plus de 3 marques à propriétaire unique. Cette limite est gérée par TCR.",
      "updateButton": "Mettre à jour",
      "retryOTPTitle": "Réessayer l'OTP",
      "retryOTPMessage": "Cliquez sur le bouton ci-dessous pour renvoyer le message de vérification OTP.",
      "sending": "Envoi en cours…",
      "resendOTP": "Renvoyer le mot de passe à usage unique"
    },
    "einModal": {
      "title": "Avez-vous un EIN ?",
      "question": "Avez-vous un numéro d'identification d'employeur (EIN) ?",
      "hasEIN": "Oui, j'ai un EIN",
      "noEIN": "Non, je n'ai pas d'EIN",
      "disableNoEINText": "L'EIN est obligatoire pour les établissements hors des États-Unis et du Canada",
      "infoText": "L'EIN est obligatoire pour les entreprises situées aux États-Unis et au Canada."
    },
    "brandDetails": {
      "brandHeading": "Informations sur la marque",
      "brandName": "Nom de la marque*",
      "brandNameHelper": "Utilisez le nom légal de l'organisation qui envoie les messages ou votre propre nom si cette marque n'est pas destinée à une organisation.",
      "businessIndustry": "Secteur d'activité*",
      "chooseVertical": "Sélectionner vertical...",
      "mobileNumber": "Numéro de téléphone mobile pour la vérification OTP (avec indicatif de pays)*",
      "mobileNumberHelper": "Veuillez fournir un numéro de téléphone mobile auquel vous avez accès afin de pouvoir confirmer la vérification par mot de passe à usage unique. Seuls les numéros américains/canadiens seront acceptés. Vous ne devez pas utiliser un numéro de téléphone CPaaS tel que celui obtenu auprès de LeadConnector. Vous ne pouvez pas utiliser le même numéro de téléphone mobile pour enregistrer plus de 3 marques à propriétaire unique. Cette limite est gérée par TCR.",
      "solePropBrand": {
        "heading": "Marque à propriétaire unique",
        "point1": "Un seul numéro de téléphone est autorisé",
        "point2": "EIN/SSN/DUNS non requis",
        "subheading": "Enregistrement de marque à propriétaire unique"
      },
      "solePropCampaign": {
        "heading": "Campagne de propriétaire unique",
        "point1": "Un seul numéro peut être associé à une campagne à propriétaire unique.",
        "point2": "Une fois approuvé, votre numéro par défaut sera automatiquement lié",
        "infoText": "Vous pouvez également mettre à jour le numéro après l'approbation",
        "warningText": "Un seul numéro peut être associé à une campagne à propriétaire unique. Une fois approuvé, votre numéro par défaut sera automatiquement lié. Vous pouvez également mettre à jour le numéro après l'approbation.",
        "subheading": "Enregistrement de campagne à propriétaire unique"
      },
      "solePropSubtitle": "Informations sur la marque et la campagne à propriétaire unique",
      "standardBrand": {
        "heading": "4,41 $ - Une fois",
        "point1": "EIN/SSN/DUNS requis",
        "point2": "Plusieurs numéros de téléphone autorisés",
        "subheading": "Enregistrement de marque standard"
      },
      "standardCampaign": {
        "heading": "16,54 $ - Une fois",
        "point1": "Plus d'un numéro peut être lié à une campagne standard.",
        "point2": "EIN/SSN/DUNS requis",
        "infoText": "Des frais de campagne supplémentaires pouvant aller jusqu'à 12 $ par mois seront appliqués conformément aux règles TCR.",
        "subheading": "Enregistrement de campagne standard"
      },
      "standardSubtitle": "Informations sur la marque et la campagne standard",
      "title": "Informations sur la marque et la campagne"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Informations sur l'utilisation de la campagne",
        "subtitle": "Saisir les informations et la description de la campagne",
        "useCase": "Cas d'utilisation de campagne*",
        "pickUseCase": "Choisissez un cas d'utilisation de la campagne",
        "useCaseDescription": "Description du cas d'utilisation*",
        "explainInDetail": "Veuillez fournir une explication détaillée",
        "useCaseDescriptionPlaceholder": "Exemple : Cette campagne envoie des informations sur les rendez-vous (confirmation et messages de rappel à nos clients une fois qu'ils ont pris rendez-vous avec nous sur notre site Web et qu'ils ont choisi de recevoir des SMS promotionnels et de notification de notre part).",
        "useCaseDescriptionHelper": "Veuillez fournir une description détaillée de la manière dont vous allez utiliser cette campagne.",
        "solePropLabel": "Propriétaire unique",
        "seeExamples": "Voir des exemples",
        "closeExamples": "Fermer les exemples"
      }
    }
  },
  "opportunities": {
    "email": "E-mail",
    "phone": "Téléphone",
    "status": "Statut",
    "contactType": "Type de contact",
    "bulkOperation": "Opération en masse",
    "contactName": "Nom du contact",
    "unassigned": "Non assigné",
    "abandoned": "Abandonné",
    "addOpportunityName": "Ajouter le nom de l'opportunité",
    "companyName": "Nom de l'entreprise",
    "contactInfo": "Informations du contact",
    "enterValue": "Saisissez une valeur",
    "lost": "Perdue",
    "open": "Ouverte",
    "opportunityInfo": "Informations sur l'opportunité",
    "opportunityName": "Nom de l'opportunité",
    "opportunitySource": "Source de l'opportunité",
    "owner": "Propriétaire",
    "pipeline": "Pipeline",
    "selectPipeline": "Sélectionner un pipeline",
    "selectStage": "Sélectionner une étape",
    "stage": "Étape",
    "won": "Remportée",
    "createdOn": "Créé le",
    "goToContactDetail": "Accéder à la page des coordonnées",
    "leadValue": "Valeur du prospect",
    "removeOwner": "Supprimer le propriétaire",
    "createdBy": "Créé par",
    "notAllowedToChange": "Vous n'êtes pas autorisé à modifier ce contact",
    "opportunityAlreadyExists": "Une opportunité existe déjà pour ce contact dans le pipeline sélectionné",
    "filters": {
      "all": "Tout",
      "statuses": {
        "all": "Tout",
        "open": "Ouvrir",
        "won": "Remportée",
        "lost": "Perdue",
        "abandoned": "Abandonnée"
      },
      "search": "Rechercher",
      "status": "Statut",
      "campaign": "Campagne",
      "owner": "Propriétaire",
      "pipeline": "Pipeline",
      "dateAddedAsc": "↑ Date d'ajout (ASC)",
      "dateAddedDesc": "↓ Date d'ajout (DESC)",
      "orderBy": "OrderBy"
    },
    "columns": {
      "note": "Remarque",
      "task": "Tâche",
      "companyName": "Nom de l'entreprise",
      "additionalInfo": "Informations supplémentaires",
      "calendarEvent": "Événement de calendrier",
      "hideAssignedTo": "Masquer l'attribution",
      "hideTags": "Masquer les mots-clés"
    },
    "buttons": {
      "new": "Nouveau"
    },
    "dragActions": {
      "abandoned": "Abandonnée",
      "lost": "Perdue",
      "won": "Remportée"
    },
    "getStarted": "commencer.",
    "noPipelines": "Oups ! On dirait qu'aucun pipeline n'est configuré. Créez un nouveau pipeline pour",
    "addTask": "Ajouter une tâche",
    "tasksCount": "{count} tâches"
  },
  "appointmentDetails": "Détails du rendez-vous",
  "cloneFunnel": {
    "cloneButton": "Dupliquer {entityName}",
    "cloning": "Duplication...",
    "cloningLimit": "La duplication est limitée à 3 emplacements à la fois",
    "error": "Erreur lors de la duplication de l'entonnoir !",
    "locationsLabel": "Sélectionnez les emplacements",
    "nameLabel": "Nom pour le {entityName} cloné",
    "namePlaceholder": "Entrez le nom du {entityName} cloné",
    "selectUpTo": "Sélectionnez jusqu'à {maxSelectableLocations} emplacements",
    "title": "Dupliquer {entityName}"
  },
  "errors": "Erreurs",
  "renderEmailAddress": "Afficher l'adresse e-mail",
  "noPaymentMethodWarning": "Avertissement concernant l'absence de mode de paiement",
  "pageDetail": "Informations de la page",
  "activityHistory": "Historique des activités",
  "uiAlert": "Alerte de l'interface utilisateur",
  "eventModals": {
    "wait": {
      "save": "Enregistrer",
      "days": "Jours",
      "fri": "Ven",
      "mon": "Lun",
      "sat": "Sam",
      "sun": "Dim",
      "thu": "Jeu",
      "tue": "Mar",
      "wed": "Mer",
      "wait": "Attendre",
      "minutes": "Minutes",
      "hours": "Heures",
      "title": "Modifier l'événement d'attente",
      "whichDaysResume": "Quels jours devrions-nous reprendre ?",
      "pickDayError": "Veuillez sélectionner au moins un jour",
      "whatTimeResume": "À quelle heure devons-nous reprendre ?"
    },
    "sms": {
      "send": "Envoyer",
      "name": "Nom",
      "attachFile": "Joindre un document",
      "learnMore": "En savoir plus",
      "sendTest": "Envoyer le test",
      "title": "Modifier l'événement {eventType}",
      "titleTemplate": "Modifier le modèle {eventType}",
      "nameRequired": "Le nom est obligatoire",
      "pickTemplate": "Choisir un modèle",
      "appCharacters": "Caractères de l'application",
      "numSegments": "Nombre de segments",
      "approximateCost": "Coût estimé",
      "costEstimateNote": "Remarque sur l'estimation des frais",
      "urlAttachmentAutocompleteToken": "Pièce jointe URL",
      "addFileUrl": "Ajoutez l'URL du fichier",
      "urlImageAlt": "URL de l'image",
      "fileImageAlt": "Fichier image",
      "enterMessage": "Saisissez le message",
      "mobilePhonePlaceholder": "Téléphone mobile",
      "unsupportedContentType": "Type de contenu non pris en charge : {fileType}",
      "urlAttachmentWarning": "{count} pièce{plural} jointe{plural} n'a/n'ont pas pu être chargée{plural} Voulez-vous continuer ?",
      "provideMobileNumber": "Veuillez fournir votre numéro de téléphone portable"
    },
    "email": {
      "text": "Texte",
      "checkLinks": "Veuillez vérifier les liens où vous avez une valeur personnalisée. Il y a un %20 supplémentaire entre le {{ et custom_values.",
      "errorOccurred": "Une erreur s'est produite, veuillez réessayer.",
      "insertToAddress": "Veuillez insérer une adresse de destination."
    },
    "voicemail": {
      "save": "Enregistrer",
      "dropFile": "Déposez le document ici ou cliquez pour télécharger",
      "faq": "FAQ",
      "title": "Modifier l'événement de message vocal",
      "voicemailFile": "Fichier de message vocal",
      "warning": "Avertissement  : les fichiers de messages vocaux doivent être au format MP3, WAV ou GSM.",
      "unsupportedFormat": "Format de fichier non pris en charge. Veuillez utiliser le format MP3, WAV ou GSM."
    },
    "call": {
      "title": "Modifier l'événement d'appel",
      "save": "Enregistrer",
      "name": "Nom",
      "nameRequired": "Le nom est obligatoire",
      "callWhisper": "Message d'appel chuchoté",
      "whisperMessage": "Message chuchoté",
      "thisIsTheMessage": "Ce message sera diffusé à l'agent avant de connecter l'appel.",
      "callTimeoutS": "Délai d'attente pour les appels (s)",
      "timeoutSeconds": "Délai d'attente (secondes)",
      "disableVoicemailDetect": "Désactiver la détection de la messagerie vocale",
      "callWillPatchInstantly": "L'appel sera connecté instantanément sans détection de la messagerie vocale."
    }
  },
  "emailTemplate": {
    "createdOn": "Créé le",
    "updatedOn": "Mis à jour le"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM En savoir plus",
      "description": "Description du service de présentation du nom de l'appelant"
    },
    "submitted": {
      "checkStatus": "Vérifier l'état du CNAM",
      "description": "Le nom de votre entreprise devrait être visible des contacts concernés dans un délai de 3 à 5 jours.",
      "subtitle": "Votre demande de CNAM a été soumise.",
      "title": "Félicitations !"
    },
    "registration": {
      "confirm": "Confirmer",
      "learnMore": "En savoir plus",
      "characterLimit": "{count}/15",
      "title": "Enregistrement CNAM",
      "description": "Saisissez le nom de votre entreprise (15 caractères maximum)",
      "warning": "Avertissement : le nom de votre entreprise sera affiché à la place de l'ID d'appelant. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Erreur de mise à jour",
      "message": "Message d'erreur de mise à jour"
    },
    "success": {
      "message": "Votre marque et votre campagne A2P ont été soumises.<b>Remarque :</b> Vous <b>recevrez un mot de passe à usage unique au numéro de téléphone portable que vous avez fourni pour la vérification</b> TCR. <b>Veuillez répondre Oui dans les 24 heures</b> suivant la réception du SMS.",
      "title": "Votre marque et votre campagne A2P ont été soumises. L'approbation de votre marque peut prendre jusqu'à <b>7 jours</b> et celle de la campagne jusqu'à 4 à 5 semaines supplémentaires."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Erreur relative au pack réglementaire",
      "status": "Statut de l'erreur relative au pack réglementaire"
    },
    "createAddress": {
      "successMessage": "Votre marque et votre campagne A2P ont été soumises.",
      "successTitle": "Adresse soumise avec succès",
      "underReview": "L'adresse soumise est en cours d'examen"
    },
    "createEndUser": {
      "dateFormat": "La date doit être entrée au format AAAA-MM-JJ.",
      "phoneExample": " Par exemple : +14155552671",
      "title": "Informations sur l'entreprise :"
    },
    "success": {
      "title": "Pack réglementaire soumis avec succès",
      "underReview": "Pack soumis à examen",
      "message": "Votre demande d'enregistrement SHAKEN/STIR a été soumise. L'approbation peut prendre jusqu'à <b>3 ou 4 jours</b>. Le statut sera bientôt mis à jour."
    },
    "documents": {
      "additionalInfo": "Informations supplémentaires",
      "createAddressLink": "Créez une adresse.",
      "createAddressPrompt": "Veuillez d'abord créer une adresse, puis procédez à la création du pack.",
      "selectAddress": "Sélectionner l'adresse :"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Cette option ajoutera une nouvelle adresse à votre compte",
        "label": "Pack d'adresses"
      },
      "regulatoryBundle": {
        "description": "Cette option vous aidera à créer un nouveau pack réglementaire",
        "label": "Pack réglementaire"
      },
      "title": "Choisissez le pack que vous souhaitez ajouter"
    },
    "modal": {
      "back": "Retour",
      "next": "Suivant",
      "submit": "Envoyer",
      "title": "Nouveau pack réglementaire",
      "description": "Créez un nouveau pack réglementaire pour votre emplacement"
    }
  },
  "reminder": {
    "phone": "Téléphone",
    "noReplyYet": "Aucune réponse pour l'instant"
  },
  "sendGrid": {
    "apiKey": "Clé API de SendGrid",
    "save": "Enregistrer SendGrid",
    "apiKeyRequired": "Clé API SendGrid requise"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Mettre à niveau",
      "subtitle": "Les agences qui bénéficient du forfait Pro gagnent environ 363 dollars par mois en refacturant les frais de téléphone à leurs clients",
      "title": "Souhaitez-vous refacturer cela à vos clients ?"
    }
  },
  "emailField": {
    "label": "E-mail",
    "placeholder": "E-mail",
    "tooltip": {
      "primary": "Principal",
      "emails": "Adresses e-mail"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Charger l'instantané :",
    "loadSnapshotWarning": "Souhaitez-vous charger l'instantané associé à ce plan ? <br /> <strong class='text-danger'>Les données existantes risquent d'être perdues</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Seuls les administrateurs/utilisateurs d'agence ont accès à ce sous-compte. Actuellement, vous et les autres administrateurs/utilisateurs du compte n'avez pas accès à ce sous-compte.",
      "heading": "Ce sous-compte a été mis en pause."
    },
    "temporarily": {
      "description": "Toutes vos données sont protégées et les déclencheurs/campagnes, etc. reprendront leur fonctionnement après l'activation.",
      "heading": " Votre compte a été temporairement suspendu."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Nom non officiel de l'entreprise",
    "title": "Actualiser l'ID d'appelant"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Sélectionner un bureau",
    "whichOffice": "Quel bureau souhaitez-vous rattacher à ce compte ?",
    "connect": "Connectez-vous !"
  },
  "phoneField": {
    "label": "Téléphone",
    "placeholder": "Numéro de téléphone",
    "tooltip": {
      "invalidNumber": "Numéro de téléphone non valide",
      "notSmsCapable": "Ce numéro {type} n'est pas compatible avec les SMS"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Informations sur la réservation",
      "form": "Formulaire",
      "quiz": "Quiz",
      "submissionDetail": "Détail de l'envoi",
      "survey": "Sondage"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Votre demande d'enregistrement SHAKEN/STIR a été soumise. L'approbation peut prendre jusqu'à <b>3 ou 4 jours</b>. Le statut sera bientôt mis à jour.",
      "title": "Appel de confiance SHAKEN/STIR activé."
    },
    "modal": {
      "andThe": " et le ",
      "businessProfile": "Profil d'entreprise",
      "certification": "Je certifie que le profil d'entreprise associé est à l'origine des appels téléphoniques et que je contribuerai aux activités de traçage, y compris celles initiées par",
      "failedTitle": "L'envoi a échoué",
      "friendlyName": "Nom associé",
      "friendlyNamePlaceholder": "Ex : 24 novembre SHST à 19:47:14",
      "linkInfo": {
        "description": "Tous les numéros actuellement disponibles et les futurs numéros achetés seront automatiquement enregistrés auprès de SHAKEN/STIR.",
        "title": "Tous les numéros seront automatiquement liés"
      },
      "stiPa": "Administrateur de la politique d'identité téléphonique sécurisée (STI-PA)",
      "subtitle": "Entrer les informations et la description",
      "successMessage": "Votre demande d'enregistrement SHAKEN/STIR a été soumise. L'approbation peut prendre jusqu'à <b>3 ou 4 jours</b>. Le statut sera bientôt mis à jour.",
      "successTitle": "Appels de confiance SHAKEN/STIR activés.",
      "title": "Activer l'appel de confiance SHAKEN/STIR",
      "tracebackGroup": "US Telecom Traceback Group"
    },
    "withCnam": {
      "cnamPromo": "Inscrivez-vous au service de présentation du nom de l'appelant pour que le nom de votre entreprise soit affiché à la place de l'ID d'appelant",
      "registerCnam": "Enregistrez le CNAM"
    }
  },
  "task": {
    "2day": "2 jours",
    "3day": "3 jours",
    "4day": "4 jours",
    "5day": "5 jours",
    "addTask": "Ajouter une tâche",
    "countTasks": "{count} tâches"
  },
  "updatedProductsModal": {
    "title": "Produits mis à jour",
    "copyDirectSaleLink": "Copier le lien de vente directe",
    "setupFeeInstruction": "Les frais d'installation peuvent être configurés dans le tableau de bord Stripe. ",
    "doNotDeleteWarning": "Ne supprimez pas les produits ou les prix du tableau de bord Stripe. Cela perturberait l'intégration."
  },
  "termsOfService": {
    "privacyLink": "Politique de confidentialité",
    "accept": "Accepter",
    "termsLink": "Conditions d'utilisation",
    "updateMessage": "Nous avons mis à jour nos conditions d'utilisation et notre politique de confidentialité. Veuillez les consulter et les accepter pour continuer.",
    "agreementPrefix": "En continuant, vous acceptez nos ",
    "agreementConjunction": " et "
  },
  "callerIdVerificationModal": {
    "answerCall": "Répondez à l'appel et entrez ce code de vérification :",
    "leadConnectorCalling": "Lead Connector vous appelle...",
    "title": "Ajouter un ID d'appelant par téléphone",
    "waitingForVerification": "En attente de la vérification..."
  },
  "emailOTPModal": {
    "confirmCode": "Confirmer le code",
    "resendCode": "Si vous n'avez pas reçu le code, cliquez ici pour le renvoyer"
  },
  "survey": {
    "copy": {
      "cancel": "Annuler",
      "location": "Emplacement",
      "copy": "Copier",
      "newSurveyName": "Nouveau nom de sondage",
      "title": "Copier le sondage",
      "locationRequired": "L'emplacement est obligatoire"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Nom du produit",
    "planDetails": "Informations sur le forfait",
    "title": "Descriptions de produit",
    "planId": "ID de forfait",
    "copiedToClipboard": "Copié dans le presse-papiers"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Plus Efficace",
      "faster": "Plus rapide",
      "itsText": "C'est",
      "smoother": "Plus fluide",
      "title": "Une nouvelle expérience d'importation est disponible !",
      "warningMessage": "L'activation de la nouvelle expérience d'importation active Labs pour ce sous-compte et active la fonctionnalité bêta.",
      "tryNow": "Essayez maintenant"
    },
    "validateEmails": "Valider les e-mails ?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "Prix HighLevel",
      "howDoesItWork": "Comment cela fonctionne-t-il ?",
      "payNow": "Payer maintenant",
      "priceError": "Le prix doit être supérieur ou égal à celui de HighLevel",
      "saving": "Enregistrement",
      "yourPrice": "Votre prix",
      "yourProfit": "Votre bénéfice",
      "subscriptionCreating": "L'abonnement est en cours de création.<br/>Merci de ne pas actualiser la page ou cliquer sur le bouton Retour.",
      "subscriptionCreated": "Abonnement créé. Veuillez patienter.",
      "unableToCreate": "Impossible de créer l'abonnement, veuillez contacter l'assistance",
      "perMonth": "par mois",
      "agreeToEnable": "J'accepte d'activer Listings pour ce client sans faire de vente incitative et je reconnais que je serai facturé",
      "deployDirectly": "Déployer Listings directement",
      "deployDirectlyDesc": "Utilisez cette option si vous proposez Listings dans le cadre de votre offre ou si vous souhaitez facturer votre client séparément",
      "minimumCommitment": "avec une période d'engagement minimale d'un mois.",
      "offerListings": "Listes d'offres",
      "resellListings": "Annonces de revente",
      "subscribedInfo": "{withoutUpsell} Sans vente incitative, {withUpsell} Avec vente incitative et {withSaas} Avec pack Saas",
      "yourResellOffer": "Votre offre de revente"
    }
  }
}
